
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredcf1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredcf1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9VihW", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $73979fa3e23c7eb5$export$ffb0004e005737fa, (v) => $73979fa3e23c7eb5$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $73979fa3e23c7eb5$export$34b9dba7ce09269b, (v) => $73979fa3e23c7eb5$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $73979fa3e23c7eb5$export$25062201e9e25d76, (v) => $73979fa3e23c7eb5$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $73979fa3e23c7eb5$export$ffb0004e005737fa;
var $73979fa3e23c7eb5$export$34b9dba7ce09269b;
var $73979fa3e23c7eb5$export$25062201e9e25d76;
"use strict";
var $73979fa3e23c7eb5$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $73979fa3e23c7eb5$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $73979fa3e23c7eb5$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $73979fa3e23c7eb5$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$73979fa3e23c7eb5$export$ffb0004e005737fa = $73979fa3e23c7eb5$var$REACT_FRAGMENT_TYPE;
$73979fa3e23c7eb5$export$34b9dba7ce09269b = $73979fa3e23c7eb5$var$jsxProd;
$73979fa3e23c7eb5$export$25062201e9e25d76 = $73979fa3e23c7eb5$var$jsxProd;

});

parcelRegister("2jkU8", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1aed924cacfade00$export$dca3b0875bd9a954, (v) => $1aed924cacfade00$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1aed924cacfade00$export$16fa2f45be04daa8, (v) => $1aed924cacfade00$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1aed924cacfade00$export$ffb0004e005737fa, (v) => $1aed924cacfade00$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1aed924cacfade00$export$e2c29f18771995cb, (v) => $1aed924cacfade00$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1aed924cacfade00$export$221d75b3f55bb0bd, (v) => $1aed924cacfade00$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1aed924cacfade00$export$5f8d39834fd61797, (v) => $1aed924cacfade00$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1aed924cacfade00$export$74bf444e3cd11ea5, (v) => $1aed924cacfade00$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $1aed924cacfade00$export$1ced07cd6b1985ce, (v) => $1aed924cacfade00$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "act", () => $1aed924cacfade00$export$3ba232387fd5d6dd, (v) => $1aed924cacfade00$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cache", () => $1aed924cacfade00$export$69a3209f1a06c04d, (v) => $1aed924cacfade00$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $1aed924cacfade00$export$e530037191fcd5d7, (v) => $1aed924cacfade00$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1aed924cacfade00$export$fd42f52fd3ae1109, (v) => $1aed924cacfade00$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1aed924cacfade00$export$c8a8987d4410bf2d, (v) => $1aed924cacfade00$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $1aed924cacfade00$export$7d1e3a5e95ceca43, (v) => $1aed924cacfade00$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1aed924cacfade00$export$257a8862b851cb5b, (v) => $1aed924cacfade00$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1aed924cacfade00$export$a8257692ac88316c, (v) => $1aed924cacfade00$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1aed924cacfade00$export$488013bae63b21da, (v) => $1aed924cacfade00$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1aed924cacfade00$export$7c73462e0d25e514, (v) => $1aed924cacfade00$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1aed924cacfade00$export$7568632d0d33d16d, (v) => $1aed924cacfade00$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $1aed924cacfade00$export$f93f40ac0ca7e3a8, (v) => $1aed924cacfade00$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $1aed924cacfade00$export$1f96ae73734a86cc, (v) => $1aed924cacfade00$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $1aed924cacfade00$export$9a47ced3238df325, (v) => $1aed924cacfade00$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $1aed924cacfade00$export$35808ee640e87ca7, (v) => $1aed924cacfade00$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1aed924cacfade00$export$fae74005e78b1a27, (v) => $1aed924cacfade00$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1aed924cacfade00$export$dc8fbce3eb94dc1e, (v) => $1aed924cacfade00$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1aed924cacfade00$export$6a7bc4e911dc01cf, (v) => $1aed924cacfade00$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1aed924cacfade00$export$6d9c69b0de29b591, (v) => $1aed924cacfade00$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1aed924cacfade00$export$f680877a34711e37, (v) => $1aed924cacfade00$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1aed924cacfade00$export$d5a552a76deda3c2, (v) => $1aed924cacfade00$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1aed924cacfade00$export$aaabe4eda9ed9969, (v) => $1aed924cacfade00$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1aed924cacfade00$export$e5c5a5f917a5871c, (v) => $1aed924cacfade00$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1aed924cacfade00$export$1538c33de8887b59, (v) => $1aed924cacfade00$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $1aed924cacfade00$export$fca7f784ae7a249a, (v) => $1aed924cacfade00$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $1aed924cacfade00$export$13e3392192263954, (v) => $1aed924cacfade00$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1aed924cacfade00$export$b8f5890fc79d6aca, (v) => $1aed924cacfade00$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1aed924cacfade00$export$60241385465d0a34, (v) => $1aed924cacfade00$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1aed924cacfade00$export$306c0aa65ff9ec16, (v) => $1aed924cacfade00$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1aed924cacfade00$export$7b286972b8d8ccbf, (v) => $1aed924cacfade00$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1aed924cacfade00$export$83d89fbfd8236492, (v) => $1aed924cacfade00$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1aed924cacfade00$export$dca3b0875bd9a954;
var $1aed924cacfade00$export$16fa2f45be04daa8;
var $1aed924cacfade00$export$ffb0004e005737fa;
var $1aed924cacfade00$export$e2c29f18771995cb;
var $1aed924cacfade00$export$221d75b3f55bb0bd;
var $1aed924cacfade00$export$5f8d39834fd61797;
var $1aed924cacfade00$export$74bf444e3cd11ea5;
var $1aed924cacfade00$export$1ced07cd6b1985ce;
var $1aed924cacfade00$export$3ba232387fd5d6dd;
var $1aed924cacfade00$export$69a3209f1a06c04d;
var $1aed924cacfade00$export$e530037191fcd5d7;
var $1aed924cacfade00$export$fd42f52fd3ae1109;
var $1aed924cacfade00$export$c8a8987d4410bf2d;
var $1aed924cacfade00$export$7d1e3a5e95ceca43;
var $1aed924cacfade00$export$257a8862b851cb5b;
var $1aed924cacfade00$export$a8257692ac88316c;
var $1aed924cacfade00$export$488013bae63b21da;
var $1aed924cacfade00$export$7c73462e0d25e514;
var $1aed924cacfade00$export$7568632d0d33d16d;
var $1aed924cacfade00$export$f93f40ac0ca7e3a8;
var $1aed924cacfade00$export$1f96ae73734a86cc;
var $1aed924cacfade00$export$9a47ced3238df325;
var $1aed924cacfade00$export$35808ee640e87ca7;
var $1aed924cacfade00$export$fae74005e78b1a27;
var $1aed924cacfade00$export$dc8fbce3eb94dc1e;
var $1aed924cacfade00$export$6a7bc4e911dc01cf;
var $1aed924cacfade00$export$6d9c69b0de29b591;
var $1aed924cacfade00$export$f680877a34711e37;
var $1aed924cacfade00$export$d5a552a76deda3c2;
var $1aed924cacfade00$export$aaabe4eda9ed9969;
var $1aed924cacfade00$export$e5c5a5f917a5871c;
var $1aed924cacfade00$export$1538c33de8887b59;
var $1aed924cacfade00$export$fca7f784ae7a249a;
var $1aed924cacfade00$export$13e3392192263954;
var $1aed924cacfade00$export$b8f5890fc79d6aca;
var $1aed924cacfade00$export$60241385465d0a34;
var $1aed924cacfade00$export$306c0aa65ff9ec16;
var $1aed924cacfade00$export$7b286972b8d8ccbf;
var $1aed924cacfade00$export$83d89fbfd8236492;
"use strict";
var $1aed924cacfade00$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $1aed924cacfade00$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $1aed924cacfade00$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $1aed924cacfade00$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $1aed924cacfade00$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $1aed924cacfade00$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $1aed924cacfade00$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $1aed924cacfade00$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $1aed924cacfade00$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $1aed924cacfade00$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $1aed924cacfade00$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $1aed924cacfade00$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $1aed924cacfade00$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $1aed924cacfade00$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$1aed924cacfade00$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $1aed924cacfade00$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1aed924cacfade00$var$assign = Object.assign, $1aed924cacfade00$var$emptyObject = {};
function $1aed924cacfade00$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $1aed924cacfade00$var$emptyObject;
    this.updater = updater || $1aed924cacfade00$var$ReactNoopUpdateQueue;
}
$1aed924cacfade00$var$Component.prototype.isReactComponent = {};
$1aed924cacfade00$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$1aed924cacfade00$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $1aed924cacfade00$var$ComponentDummy() {}
$1aed924cacfade00$var$ComponentDummy.prototype = $1aed924cacfade00$var$Component.prototype;
function $1aed924cacfade00$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $1aed924cacfade00$var$emptyObject;
    this.updater = updater || $1aed924cacfade00$var$ReactNoopUpdateQueue;
}
var $1aed924cacfade00$var$pureComponentPrototype = $1aed924cacfade00$var$PureComponent.prototype = new $1aed924cacfade00$var$ComponentDummy();
$1aed924cacfade00$var$pureComponentPrototype.constructor = $1aed924cacfade00$var$PureComponent;
$1aed924cacfade00$var$assign($1aed924cacfade00$var$pureComponentPrototype, $1aed924cacfade00$var$Component.prototype);
$1aed924cacfade00$var$pureComponentPrototype.isPureReactComponent = !0;
var $1aed924cacfade00$var$isArrayImpl = Array.isArray, $1aed924cacfade00$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $1aed924cacfade00$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $1aed924cacfade00$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $1aed924cacfade00$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $1aed924cacfade00$var$cloneAndReplaceKey(oldElement, newKey) {
    return $1aed924cacfade00$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $1aed924cacfade00$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $1aed924cacfade00$var$REACT_ELEMENT_TYPE;
}
function $1aed924cacfade00$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $1aed924cacfade00$var$userProvidedKeyEscapeRegex = /\/+/g;
function $1aed924cacfade00$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $1aed924cacfade00$var$escape("" + element.key) : index.toString(36);
}
function $1aed924cacfade00$var$noop$1() {}
function $1aed924cacfade00$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($1aed924cacfade00$var$noop$1, $1aed924cacfade00$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $1aed924cacfade00$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $1aed924cacfade00$var$REACT_ELEMENT_TYPE:
                case $1aed924cacfade00$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $1aed924cacfade00$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $1aed924cacfade00$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $1aed924cacfade00$var$getElementKey(children, 0) : nameSoFar, $1aed924cacfade00$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($1aed924cacfade00$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $1aed924cacfade00$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($1aed924cacfade00$var$isValidElement(callback) && (callback = $1aed924cacfade00$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($1aed924cacfade00$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($1aed924cacfade00$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $1aed924cacfade00$var$getElementKey(nameSoFar, i), invokeCallback += $1aed924cacfade00$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $1aed924cacfade00$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $1aed924cacfade00$var$getElementKey(nameSoFar, i++), invokeCallback += $1aed924cacfade00$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $1aed924cacfade00$var$mapIntoArray($1aed924cacfade00$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $1aed924cacfade00$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $1aed924cacfade00$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $1aed924cacfade00$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $1aed924cacfade00$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $1aed924cacfade00$var$noop() {}
$1aed924cacfade00$export$dca3b0875bd9a954 = {
    map: $1aed924cacfade00$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $1aed924cacfade00$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $1aed924cacfade00$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $1aed924cacfade00$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$1aed924cacfade00$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$1aed924cacfade00$export$16fa2f45be04daa8 = $1aed924cacfade00$var$Component;
$1aed924cacfade00$export$ffb0004e005737fa = $1aed924cacfade00$var$REACT_FRAGMENT_TYPE;
$1aed924cacfade00$export$e2c29f18771995cb = $1aed924cacfade00$var$REACT_PROFILER_TYPE;
$1aed924cacfade00$export$221d75b3f55bb0bd = $1aed924cacfade00$var$PureComponent;
$1aed924cacfade00$export$5f8d39834fd61797 = $1aed924cacfade00$var$REACT_STRICT_MODE_TYPE;
$1aed924cacfade00$export$74bf444e3cd11ea5 = $1aed924cacfade00$var$REACT_SUSPENSE_TYPE;
$1aed924cacfade00$export$1ced07cd6b1985ce = $1aed924cacfade00$var$ReactSharedInternals;
$1aed924cacfade00$export$3ba232387fd5d6dd = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1aed924cacfade00$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$1aed924cacfade00$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $1aed924cacfade00$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$1aed924cacfade00$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $1aed924cacfade00$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$1aed924cacfade00$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $1aed924cacfade00$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $1aed924cacfade00$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$1aed924cacfade00$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$1aed924cacfade00$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $1aed924cacfade00$var$ReactElement(type, key, void 0, void 0, null, props);
};
$1aed924cacfade00$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1aed924cacfade00$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $1aed924cacfade00$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$1aed924cacfade00$export$a8257692ac88316c = $1aed924cacfade00$var$isValidElement;
$1aed924cacfade00$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $1aed924cacfade00$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $1aed924cacfade00$var$lazyInitializer
    };
};
$1aed924cacfade00$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $1aed924cacfade00$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$1aed924cacfade00$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $1aed924cacfade00$var$ReactSharedInternals.T, currentTransition = {};
    $1aed924cacfade00$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $1aed924cacfade00$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($1aed924cacfade00$var$noop, $1aed924cacfade00$var$reportGlobalError);
    } catch (error) {
        $1aed924cacfade00$var$reportGlobalError(error);
    } finally{
        $1aed924cacfade00$var$ReactSharedInternals.T = prevTransition;
    }
};
$1aed924cacfade00$export$f93f40ac0ca7e3a8 = function() {
    return $1aed924cacfade00$var$ReactSharedInternals.H.useCacheRefresh();
};
$1aed924cacfade00$export$1f96ae73734a86cc = function(usable) {
    return $1aed924cacfade00$var$ReactSharedInternals.H.use(usable);
};
$1aed924cacfade00$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $1aed924cacfade00$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$1aed924cacfade00$export$35808ee640e87ca7 = function(callback, deps) {
    return $1aed924cacfade00$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$1aed924cacfade00$export$fae74005e78b1a27 = function(Context) {
    return $1aed924cacfade00$var$ReactSharedInternals.H.useContext(Context);
};
$1aed924cacfade00$export$dc8fbce3eb94dc1e = function() {};
$1aed924cacfade00$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $1aed924cacfade00$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$1aed924cacfade00$export$6d9c69b0de29b591 = function(create, deps) {
    return $1aed924cacfade00$var$ReactSharedInternals.H.useEffect(create, deps);
};
$1aed924cacfade00$export$f680877a34711e37 = function() {
    return $1aed924cacfade00$var$ReactSharedInternals.H.useId();
};
$1aed924cacfade00$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $1aed924cacfade00$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$1aed924cacfade00$export$aaabe4eda9ed9969 = function(create, deps) {
    return $1aed924cacfade00$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$1aed924cacfade00$export$e5c5a5f917a5871c = function(create, deps) {
    return $1aed924cacfade00$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$1aed924cacfade00$export$1538c33de8887b59 = function(create, deps) {
    return $1aed924cacfade00$var$ReactSharedInternals.H.useMemo(create, deps);
};
$1aed924cacfade00$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $1aed924cacfade00$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$1aed924cacfade00$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $1aed924cacfade00$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$1aed924cacfade00$export$b8f5890fc79d6aca = function(initialValue) {
    return $1aed924cacfade00$var$ReactSharedInternals.H.useRef(initialValue);
};
$1aed924cacfade00$export$60241385465d0a34 = function(initialState) {
    return $1aed924cacfade00$var$ReactSharedInternals.H.useState(initialState);
};
$1aed924cacfade00$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $1aed924cacfade00$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$1aed924cacfade00$export$7b286972b8d8ccbf = function() {
    return $1aed924cacfade00$var$ReactSharedInternals.H.useTransition();
};
$1aed924cacfade00$export$83d89fbfd8236492 = "19.0.0";

});

parcelRegister("boq7L", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $84b63352e7e6aba6$export$882461b6382ed46c, (v) => $84b63352e7e6aba6$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $84b63352e7e6aba6$export$757ceba2d55c277e, (v) => $84b63352e7e6aba6$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $84b63352e7e6aba6$export$83d89fbfd8236492, (v) => $84b63352e7e6aba6$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $84b63352e7e6aba6$export$882461b6382ed46c;
var $84b63352e7e6aba6$export$757ceba2d55c277e;
var $84b63352e7e6aba6$export$83d89fbfd8236492;
"use strict";

var $4mq2P = parcelRequire("4mq2P");

var $h5vr1 = parcelRequire("h5vr1");

var $kxWH7 = parcelRequire("kxWH7");
function $84b63352e7e6aba6$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $84b63352e7e6aba6$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
var $84b63352e7e6aba6$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $84b63352e7e6aba6$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $84b63352e7e6aba6$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $84b63352e7e6aba6$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $84b63352e7e6aba6$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $84b63352e7e6aba6$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $84b63352e7e6aba6$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $84b63352e7e6aba6$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $84b63352e7e6aba6$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $84b63352e7e6aba6$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $84b63352e7e6aba6$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $84b63352e7e6aba6$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $84b63352e7e6aba6$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $84b63352e7e6aba6$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $84b63352e7e6aba6$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $84b63352e7e6aba6$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $84b63352e7e6aba6$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $84b63352e7e6aba6$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $84b63352e7e6aba6$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$84b63352e7e6aba6$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $84b63352e7e6aba6$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $84b63352e7e6aba6$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $84b63352e7e6aba6$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $84b63352e7e6aba6$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $84b63352e7e6aba6$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $84b63352e7e6aba6$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $84b63352e7e6aba6$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $84b63352e7e6aba6$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $84b63352e7e6aba6$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $84b63352e7e6aba6$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $84b63352e7e6aba6$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $84b63352e7e6aba6$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $84b63352e7e6aba6$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $84b63352e7e6aba6$var$getComponentNameFromType(type.type) || "Memo";
        case $84b63352e7e6aba6$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $84b63352e7e6aba6$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $84b63352e7e6aba6$var$ReactSharedInternals = $h5vr1.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $84b63352e7e6aba6$var$assign = Object.assign, $84b63352e7e6aba6$var$prefix, $84b63352e7e6aba6$var$suffix;
function $84b63352e7e6aba6$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $84b63352e7e6aba6$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $84b63352e7e6aba6$var$prefix = match && match[1] || "";
        $84b63352e7e6aba6$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $84b63352e7e6aba6$var$prefix + name + $84b63352e7e6aba6$var$suffix;
}
var $84b63352e7e6aba6$var$reentry = !1;
function $84b63352e7e6aba6$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $84b63352e7e6aba6$var$reentry) return "";
    $84b63352e7e6aba6$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$0) {
                                control = x$0;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$1) {
                            control = x$1;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $84b63352e7e6aba6$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $84b63352e7e6aba6$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $84b63352e7e6aba6$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $84b63352e7e6aba6$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $84b63352e7e6aba6$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $84b63352e7e6aba6$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $84b63352e7e6aba6$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return fiber = $84b63352e7e6aba6$var$describeNativeComponentFrame(fiber.type, !1), fiber;
        case 11:
            return fiber = $84b63352e7e6aba6$var$describeNativeComponentFrame(fiber.type.render, !1), fiber;
        case 1:
            return fiber = $84b63352e7e6aba6$var$describeNativeComponentFrame(fiber.type, !0), fiber;
        default:
            return "";
    }
}
function $84b63352e7e6aba6$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $84b63352e7e6aba6$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $84b63352e7e6aba6$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $84b63352e7e6aba6$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $84b63352e7e6aba6$var$assertIsMounted(fiber) {
    if ($84b63352e7e6aba6$var$getNearestMountedFiber(fiber) !== fiber) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(188));
}
function $84b63352e7e6aba6$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $84b63352e7e6aba6$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $84b63352e7e6aba6$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $84b63352e7e6aba6$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                if (child$2 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$2 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$2 = child$2.sibling;
            }
            if (!didFindChild) {
                for(child$2 = parentB.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $84b63352e7e6aba6$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $84b63352e7e6aba6$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $84b63352e7e6aba6$var$isArrayImpl = Array.isArray, $84b63352e7e6aba6$var$ReactDOMSharedInternals = $kxWH7.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $84b63352e7e6aba6$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $84b63352e7e6aba6$var$valueStack = [], $84b63352e7e6aba6$var$index = -1;
function $84b63352e7e6aba6$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $84b63352e7e6aba6$var$pop(cursor) {
    0 > $84b63352e7e6aba6$var$index || (cursor.current = $84b63352e7e6aba6$var$valueStack[$84b63352e7e6aba6$var$index], $84b63352e7e6aba6$var$valueStack[$84b63352e7e6aba6$var$index] = null, $84b63352e7e6aba6$var$index--);
}
function $84b63352e7e6aba6$var$push(cursor, value) {
    $84b63352e7e6aba6$var$index++;
    $84b63352e7e6aba6$var$valueStack[$84b63352e7e6aba6$var$index] = cursor.current;
    cursor.current = value;
}
var $84b63352e7e6aba6$var$contextStackCursor = $84b63352e7e6aba6$var$createCursor(null), $84b63352e7e6aba6$var$contextFiberStackCursor = $84b63352e7e6aba6$var$createCursor(null), $84b63352e7e6aba6$var$rootInstanceStackCursor = $84b63352e7e6aba6$var$createCursor(null), $84b63352e7e6aba6$var$hostTransitionProviderCursor = $84b63352e7e6aba6$var$createCursor(null);
function $84b63352e7e6aba6$var$pushHostContainer(fiber, nextRootInstance) {
    $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$rootInstanceStackCursor, nextRootInstance);
    $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$contextFiberStackCursor, fiber);
    $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$contextStackCursor, null);
    fiber = nextRootInstance.nodeType;
    switch(fiber){
        case 9:
        case 11:
            nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? $84b63352e7e6aba6$var$getOwnHostContext(nextRootInstance) : 0 : 0;
            break;
        default:
            if (fiber = 8 === fiber ? nextRootInstance.parentNode : nextRootInstance, nextRootInstance = fiber.tagName, fiber = fiber.namespaceURI) fiber = $84b63352e7e6aba6$var$getOwnHostContext(fiber), nextRootInstance = $84b63352e7e6aba6$var$getChildHostContextProd(fiber, nextRootInstance);
            else switch(nextRootInstance){
                case "svg":
                    nextRootInstance = 1;
                    break;
                case "math":
                    nextRootInstance = 2;
                    break;
                default:
                    nextRootInstance = 0;
            }
    }
    $84b63352e7e6aba6$var$pop($84b63352e7e6aba6$var$contextStackCursor);
    $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$contextStackCursor, nextRootInstance);
}
function $84b63352e7e6aba6$var$popHostContainer() {
    $84b63352e7e6aba6$var$pop($84b63352e7e6aba6$var$contextStackCursor);
    $84b63352e7e6aba6$var$pop($84b63352e7e6aba6$var$contextFiberStackCursor);
    $84b63352e7e6aba6$var$pop($84b63352e7e6aba6$var$rootInstanceStackCursor);
}
function $84b63352e7e6aba6$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$hostTransitionProviderCursor, fiber);
    var context = $84b63352e7e6aba6$var$contextStackCursor.current;
    var JSCompiler_inline_result = $84b63352e7e6aba6$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$contextFiberStackCursor, fiber), $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$contextStackCursor, JSCompiler_inline_result));
}
function $84b63352e7e6aba6$var$popHostContext(fiber) {
    $84b63352e7e6aba6$var$contextFiberStackCursor.current === fiber && ($84b63352e7e6aba6$var$pop($84b63352e7e6aba6$var$contextStackCursor), $84b63352e7e6aba6$var$pop($84b63352e7e6aba6$var$contextFiberStackCursor));
    $84b63352e7e6aba6$var$hostTransitionProviderCursor.current === fiber && ($84b63352e7e6aba6$var$pop($84b63352e7e6aba6$var$hostTransitionProviderCursor), $84b63352e7e6aba6$var$HostTransitionContext._currentValue = $84b63352e7e6aba6$var$sharedNotPendingObject);
}
var $84b63352e7e6aba6$var$hasOwnProperty = Object.prototype.hasOwnProperty, $84b63352e7e6aba6$var$scheduleCallback$3 = $4mq2P.unstable_scheduleCallback, $84b63352e7e6aba6$var$cancelCallback$1 = $4mq2P.unstable_cancelCallback, $84b63352e7e6aba6$var$shouldYield = $4mq2P.unstable_shouldYield, $84b63352e7e6aba6$var$requestPaint = $4mq2P.unstable_requestPaint, $84b63352e7e6aba6$var$now = $4mq2P.unstable_now, $84b63352e7e6aba6$var$getCurrentPriorityLevel = $4mq2P.unstable_getCurrentPriorityLevel, $84b63352e7e6aba6$var$ImmediatePriority = $4mq2P.unstable_ImmediatePriority, $84b63352e7e6aba6$var$UserBlockingPriority = $4mq2P.unstable_UserBlockingPriority, $84b63352e7e6aba6$var$NormalPriority$1 = $4mq2P.unstable_NormalPriority, $84b63352e7e6aba6$var$LowPriority = $4mq2P.unstable_LowPriority, $84b63352e7e6aba6$var$IdlePriority = $4mq2P.unstable_IdlePriority, $84b63352e7e6aba6$var$log$1 = $4mq2P.log, $84b63352e7e6aba6$var$unstable_setDisableYieldValue = $4mq2P.unstable_setDisableYieldValue, $84b63352e7e6aba6$var$rendererID = null, $84b63352e7e6aba6$var$injectedHook = null;
function $84b63352e7e6aba6$var$onCommitRoot(root) {
    if ($84b63352e7e6aba6$var$injectedHook && "function" === typeof $84b63352e7e6aba6$var$injectedHook.onCommitFiberRoot) try {
        $84b63352e7e6aba6$var$injectedHook.onCommitFiberRoot($84b63352e7e6aba6$var$rendererID, root, void 0, 128 === (root.current.flags & 128));
    } catch (err) {}
}
function $84b63352e7e6aba6$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $84b63352e7e6aba6$var$log$1 && $84b63352e7e6aba6$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($84b63352e7e6aba6$var$injectedHook && "function" === typeof $84b63352e7e6aba6$var$injectedHook.setStrictMode) try {
        $84b63352e7e6aba6$var$injectedHook.setStrictMode($84b63352e7e6aba6$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $84b63352e7e6aba6$var$clz32 = Math.clz32 ? Math.clz32 : $84b63352e7e6aba6$var$clz32Fallback, $84b63352e7e6aba6$var$log = Math.log, $84b63352e7e6aba6$var$LN2 = Math.LN2;
function $84b63352e7e6aba6$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($84b63352e7e6aba6$var$log(x) / $84b63352e7e6aba6$var$LN2 | 0) | 0;
}
var $84b63352e7e6aba6$var$nextTransitionLane = 128, $84b63352e7e6aba6$var$nextRetryLane = 4194304;
function $84b63352e7e6aba6$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194176;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $84b63352e7e6aba6$var$getNextLanes(root, wipLanes) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
    root = 0 !== root.finishedLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $84b63352e7e6aba6$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $84b63352e7e6aba6$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $84b63352e7e6aba6$var$getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $84b63352e7e6aba6$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $84b63352e7e6aba6$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $84b63352e7e6aba6$var$getHighestPriorityLanes(warmLanes))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
}
function $84b63352e7e6aba6$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $84b63352e7e6aba6$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
            return currentTime + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $84b63352e7e6aba6$var$claimNextTransitionLane() {
    var lane = $84b63352e7e6aba6$var$nextTransitionLane;
    $84b63352e7e6aba6$var$nextTransitionLane <<= 1;
    0 === ($84b63352e7e6aba6$var$nextTransitionLane & 4194176) && ($84b63352e7e6aba6$var$nextTransitionLane = 128);
    return lane;
}
function $84b63352e7e6aba6$var$claimNextRetryLane() {
    var lane = $84b63352e7e6aba6$var$nextRetryLane;
    $84b63352e7e6aba6$var$nextRetryLane <<= 1;
    0 === ($84b63352e7e6aba6$var$nextRetryLane & 62914560) && ($84b63352e7e6aba6$var$nextRetryLane = 4194304);
    return lane;
}
function $84b63352e7e6aba6$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $84b63352e7e6aba6$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $84b63352e7e6aba6$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $84b63352e7e6aba6$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $84b63352e7e6aba6$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $84b63352e7e6aba6$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $84b63352e7e6aba6$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
}
function $84b63352e7e6aba6$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $84b63352e7e6aba6$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $84b63352e7e6aba6$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $84b63352e7e6aba6$var$resolveUpdatePriority() {
    var updatePriority = $84b63352e7e6aba6$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $84b63352e7e6aba6$var$getEventPriority(updatePriority.type);
}
function $84b63352e7e6aba6$var$runWithPriority(priority, fn) {
    var previousPriority = $84b63352e7e6aba6$var$ReactDOMSharedInternals.p;
    try {
        return $84b63352e7e6aba6$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $84b63352e7e6aba6$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $84b63352e7e6aba6$var$randomKey = Math.random().toString(36).slice(2), $84b63352e7e6aba6$var$internalInstanceKey = "__reactFiber$" + $84b63352e7e6aba6$var$randomKey, $84b63352e7e6aba6$var$internalPropsKey = "__reactProps$" + $84b63352e7e6aba6$var$randomKey, $84b63352e7e6aba6$var$internalContainerInstanceKey = "__reactContainer$" + $84b63352e7e6aba6$var$randomKey, $84b63352e7e6aba6$var$internalEventHandlersKey = "__reactEvents$" + $84b63352e7e6aba6$var$randomKey, $84b63352e7e6aba6$var$internalEventHandlerListenersKey = "__reactListeners$" + $84b63352e7e6aba6$var$randomKey, $84b63352e7e6aba6$var$internalEventHandlesSetKey = "__reactHandles$" + $84b63352e7e6aba6$var$randomKey, $84b63352e7e6aba6$var$internalRootNodeResourcesKey = "__reactResources$" + $84b63352e7e6aba6$var$randomKey, $84b63352e7e6aba6$var$internalHoistableMarker = "__reactMarker$" + $84b63352e7e6aba6$var$randomKey;
function $84b63352e7e6aba6$var$detachDeletedInstance(node) {
    delete node[$84b63352e7e6aba6$var$internalInstanceKey];
    delete node[$84b63352e7e6aba6$var$internalPropsKey];
    delete node[$84b63352e7e6aba6$var$internalEventHandlersKey];
    delete node[$84b63352e7e6aba6$var$internalEventHandlerListenersKey];
    delete node[$84b63352e7e6aba6$var$internalEventHandlesSetKey];
}
function $84b63352e7e6aba6$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$84b63352e7e6aba6$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$84b63352e7e6aba6$var$internalContainerInstanceKey] || parentNode[$84b63352e7e6aba6$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $84b63352e7e6aba6$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$84b63352e7e6aba6$var$internalInstanceKey]) return parentNode;
                targetNode = $84b63352e7e6aba6$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $84b63352e7e6aba6$var$getInstanceFromNode(node) {
    if (node = node[$84b63352e7e6aba6$var$internalInstanceKey] || node[$84b63352e7e6aba6$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $84b63352e7e6aba6$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(33));
}
function $84b63352e7e6aba6$var$getResourcesFromRoot(root) {
    var resources = root[$84b63352e7e6aba6$var$internalRootNodeResourcesKey];
    resources || (resources = root[$84b63352e7e6aba6$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $84b63352e7e6aba6$var$markNodeAsHoistable(node) {
    node[$84b63352e7e6aba6$var$internalHoistableMarker] = !0;
}
var $84b63352e7e6aba6$var$allNativeEvents = new Set(), $84b63352e7e6aba6$var$registrationNameDependencies = {};
function $84b63352e7e6aba6$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $84b63352e7e6aba6$var$registerDirectEvent(registrationName, dependencies);
    $84b63352e7e6aba6$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $84b63352e7e6aba6$var$registerDirectEvent(registrationName, dependencies) {
    $84b63352e7e6aba6$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$84b63352e7e6aba6$var$allNativeEvents.add(dependencies[registrationName]);
}
var $84b63352e7e6aba6$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $84b63352e7e6aba6$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $84b63352e7e6aba6$var$illegalAttributeNameCache = {}, $84b63352e7e6aba6$var$validatedAttributeNameCache = {};
function $84b63352e7e6aba6$var$isAttributeNameSafe(attributeName) {
    if ($84b63352e7e6aba6$var$hasOwnProperty.call($84b63352e7e6aba6$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($84b63352e7e6aba6$var$hasOwnProperty.call($84b63352e7e6aba6$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($84b63352e7e6aba6$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $84b63352e7e6aba6$var$validatedAttributeNameCache[attributeName] = !0;
    $84b63352e7e6aba6$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $84b63352e7e6aba6$var$setValueForAttribute(node, name, value) {
    if ($84b63352e7e6aba6$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $84b63352e7e6aba6$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $84b63352e7e6aba6$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $84b63352e7e6aba6$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $84b63352e7e6aba6$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $84b63352e7e6aba6$var$trackValueOnNode(node) {
    var valueField = $84b63352e7e6aba6$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $84b63352e7e6aba6$var$track(node) {
    node._valueTracker || (node._valueTracker = $84b63352e7e6aba6$var$trackValueOnNode(node));
}
function $84b63352e7e6aba6$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $84b63352e7e6aba6$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $84b63352e7e6aba6$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $84b63352e7e6aba6$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $84b63352e7e6aba6$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($84b63352e7e6aba6$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $84b63352e7e6aba6$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $84b63352e7e6aba6$var$getToStringValue(value);
        } else element.value !== "" + $84b63352e7e6aba6$var$getToStringValue(value) && (element.value = "" + $84b63352e7e6aba6$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $84b63352e7e6aba6$var$setDefaultValue(element, type, $84b63352e7e6aba6$var$getToStringValue(value)) : null != defaultValue ? $84b63352e7e6aba6$var$setDefaultValue(element, type, $84b63352e7e6aba6$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $84b63352e7e6aba6$var$getToStringValue(name) : element.removeAttribute("name");
}
function $84b63352e7e6aba6$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $84b63352e7e6aba6$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $84b63352e7e6aba6$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $84b63352e7e6aba6$var$setDefaultValue(node, type, value) {
    "number" === type && $84b63352e7e6aba6$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $84b63352e7e6aba6$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $84b63352e7e6aba6$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $84b63352e7e6aba6$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $84b63352e7e6aba6$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $84b63352e7e6aba6$var$getToStringValue(defaultValue) : "";
}
function $84b63352e7e6aba6$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(92));
            if ($84b63352e7e6aba6$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $84b63352e7e6aba6$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $84b63352e7e6aba6$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $84b63352e7e6aba6$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $84b63352e7e6aba6$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $84b63352e7e6aba6$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $84b63352e7e6aba6$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $84b63352e7e6aba6$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $84b63352e7e6aba6$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $84b63352e7e6aba6$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $84b63352e7e6aba6$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $84b63352e7e6aba6$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $84b63352e7e6aba6$var$sanitizeURL(url) {
    return $84b63352e7e6aba6$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $84b63352e7e6aba6$var$currentReplayingEvent = null;
function $84b63352e7e6aba6$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $84b63352e7e6aba6$var$restoreTarget = null, $84b63352e7e6aba6$var$restoreQueue = null;
function $84b63352e7e6aba6$var$restoreStateOfTarget(target) {
    var internalInstance = $84b63352e7e6aba6$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$84b63352e7e6aba6$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $84b63352e7e6aba6$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $84b63352e7e6aba6$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$84b63352e7e6aba6$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(90));
                            $84b63352e7e6aba6$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $84b63352e7e6aba6$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $84b63352e7e6aba6$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $84b63352e7e6aba6$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $84b63352e7e6aba6$var$isInsideEventHandler = !1;
function $84b63352e7e6aba6$var$batchedUpdates$1(fn, a, b) {
    if ($84b63352e7e6aba6$var$isInsideEventHandler) return fn(a, b);
    $84b63352e7e6aba6$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($84b63352e7e6aba6$var$isInsideEventHandler = !1, null !== $84b63352e7e6aba6$var$restoreTarget || null !== $84b63352e7e6aba6$var$restoreQueue) {
            if ($84b63352e7e6aba6$var$flushSyncWork$1(), $84b63352e7e6aba6$var$restoreTarget && (a = $84b63352e7e6aba6$var$restoreTarget, fn = $84b63352e7e6aba6$var$restoreQueue, $84b63352e7e6aba6$var$restoreQueue = $84b63352e7e6aba6$var$restoreTarget = null, $84b63352e7e6aba6$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$84b63352e7e6aba6$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $84b63352e7e6aba6$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$84b63352e7e6aba6$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $84b63352e7e6aba6$var$passiveBrowserEventsSupported = !1;
if ($84b63352e7e6aba6$var$canUseDOM) try {
    var $84b63352e7e6aba6$var$options = {};
    Object.defineProperty($84b63352e7e6aba6$var$options, "passive", {
        get: function() {
            $84b63352e7e6aba6$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $84b63352e7e6aba6$var$options, $84b63352e7e6aba6$var$options);
    window.removeEventListener("test", $84b63352e7e6aba6$var$options, $84b63352e7e6aba6$var$options);
} catch (e) {
    $84b63352e7e6aba6$var$passiveBrowserEventsSupported = !1;
}
var $84b63352e7e6aba6$var$root = null, $84b63352e7e6aba6$var$startText = null, $84b63352e7e6aba6$var$fallbackText = null;
function $84b63352e7e6aba6$var$getData() {
    if ($84b63352e7e6aba6$var$fallbackText) return $84b63352e7e6aba6$var$fallbackText;
    var start, startValue = $84b63352e7e6aba6$var$startText, startLength = startValue.length, end, endValue = "value" in $84b63352e7e6aba6$var$root ? $84b63352e7e6aba6$var$root.value : $84b63352e7e6aba6$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $84b63352e7e6aba6$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $84b63352e7e6aba6$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $84b63352e7e6aba6$var$functionThatReturnsTrue() {
    return !0;
}
function $84b63352e7e6aba6$var$functionThatReturnsFalse() {
    return !1;
}
function $84b63352e7e6aba6$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $84b63352e7e6aba6$var$functionThatReturnsTrue : $84b63352e7e6aba6$var$functionThatReturnsFalse;
        this.isPropagationStopped = $84b63352e7e6aba6$var$functionThatReturnsFalse;
        return this;
    }
    $84b63352e7e6aba6$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $84b63352e7e6aba6$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $84b63352e7e6aba6$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $84b63352e7e6aba6$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $84b63352e7e6aba6$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $84b63352e7e6aba6$var$SyntheticEvent = $84b63352e7e6aba6$var$createSyntheticEvent($84b63352e7e6aba6$var$EventInterface), $84b63352e7e6aba6$var$UIEventInterface = $84b63352e7e6aba6$var$assign({}, $84b63352e7e6aba6$var$EventInterface, {
    view: 0,
    detail: 0
}), $84b63352e7e6aba6$var$SyntheticUIEvent = $84b63352e7e6aba6$var$createSyntheticEvent($84b63352e7e6aba6$var$UIEventInterface), $84b63352e7e6aba6$var$lastMovementX, $84b63352e7e6aba6$var$lastMovementY, $84b63352e7e6aba6$var$lastMouseEvent, $84b63352e7e6aba6$var$MouseEventInterface = $84b63352e7e6aba6$var$assign({}, $84b63352e7e6aba6$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $84b63352e7e6aba6$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $84b63352e7e6aba6$var$lastMouseEvent && ($84b63352e7e6aba6$var$lastMouseEvent && "mousemove" === event.type ? ($84b63352e7e6aba6$var$lastMovementX = event.screenX - $84b63352e7e6aba6$var$lastMouseEvent.screenX, $84b63352e7e6aba6$var$lastMovementY = event.screenY - $84b63352e7e6aba6$var$lastMouseEvent.screenY) : $84b63352e7e6aba6$var$lastMovementY = $84b63352e7e6aba6$var$lastMovementX = 0, $84b63352e7e6aba6$var$lastMouseEvent = event);
        return $84b63352e7e6aba6$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $84b63352e7e6aba6$var$lastMovementY;
    }
}), $84b63352e7e6aba6$var$SyntheticMouseEvent = $84b63352e7e6aba6$var$createSyntheticEvent($84b63352e7e6aba6$var$MouseEventInterface), $84b63352e7e6aba6$var$DragEventInterface = $84b63352e7e6aba6$var$assign({}, $84b63352e7e6aba6$var$MouseEventInterface, {
    dataTransfer: 0
}), $84b63352e7e6aba6$var$SyntheticDragEvent = $84b63352e7e6aba6$var$createSyntheticEvent($84b63352e7e6aba6$var$DragEventInterface), $84b63352e7e6aba6$var$FocusEventInterface = $84b63352e7e6aba6$var$assign({}, $84b63352e7e6aba6$var$UIEventInterface, {
    relatedTarget: 0
}), $84b63352e7e6aba6$var$SyntheticFocusEvent = $84b63352e7e6aba6$var$createSyntheticEvent($84b63352e7e6aba6$var$FocusEventInterface), $84b63352e7e6aba6$var$AnimationEventInterface = $84b63352e7e6aba6$var$assign({}, $84b63352e7e6aba6$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $84b63352e7e6aba6$var$SyntheticAnimationEvent = $84b63352e7e6aba6$var$createSyntheticEvent($84b63352e7e6aba6$var$AnimationEventInterface), $84b63352e7e6aba6$var$ClipboardEventInterface = $84b63352e7e6aba6$var$assign({}, $84b63352e7e6aba6$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $84b63352e7e6aba6$var$SyntheticClipboardEvent = $84b63352e7e6aba6$var$createSyntheticEvent($84b63352e7e6aba6$var$ClipboardEventInterface), $84b63352e7e6aba6$var$CompositionEventInterface = $84b63352e7e6aba6$var$assign({}, $84b63352e7e6aba6$var$EventInterface, {
    data: 0
}), $84b63352e7e6aba6$var$SyntheticCompositionEvent = $84b63352e7e6aba6$var$createSyntheticEvent($84b63352e7e6aba6$var$CompositionEventInterface), $84b63352e7e6aba6$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $84b63352e7e6aba6$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $84b63352e7e6aba6$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $84b63352e7e6aba6$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $84b63352e7e6aba6$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $84b63352e7e6aba6$var$getEventModifierState() {
    return $84b63352e7e6aba6$var$modifierStateGetter;
}
var $84b63352e7e6aba6$var$KeyboardEventInterface = $84b63352e7e6aba6$var$assign({}, $84b63352e7e6aba6$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $84b63352e7e6aba6$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $84b63352e7e6aba6$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $84b63352e7e6aba6$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $84b63352e7e6aba6$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $84b63352e7e6aba6$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $84b63352e7e6aba6$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $84b63352e7e6aba6$var$SyntheticKeyboardEvent = $84b63352e7e6aba6$var$createSyntheticEvent($84b63352e7e6aba6$var$KeyboardEventInterface), $84b63352e7e6aba6$var$PointerEventInterface = $84b63352e7e6aba6$var$assign({}, $84b63352e7e6aba6$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $84b63352e7e6aba6$var$SyntheticPointerEvent = $84b63352e7e6aba6$var$createSyntheticEvent($84b63352e7e6aba6$var$PointerEventInterface), $84b63352e7e6aba6$var$TouchEventInterface = $84b63352e7e6aba6$var$assign({}, $84b63352e7e6aba6$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $84b63352e7e6aba6$var$getEventModifierState
}), $84b63352e7e6aba6$var$SyntheticTouchEvent = $84b63352e7e6aba6$var$createSyntheticEvent($84b63352e7e6aba6$var$TouchEventInterface), $84b63352e7e6aba6$var$TransitionEventInterface = $84b63352e7e6aba6$var$assign({}, $84b63352e7e6aba6$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $84b63352e7e6aba6$var$SyntheticTransitionEvent = $84b63352e7e6aba6$var$createSyntheticEvent($84b63352e7e6aba6$var$TransitionEventInterface), $84b63352e7e6aba6$var$WheelEventInterface = $84b63352e7e6aba6$var$assign({}, $84b63352e7e6aba6$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $84b63352e7e6aba6$var$SyntheticWheelEvent = $84b63352e7e6aba6$var$createSyntheticEvent($84b63352e7e6aba6$var$WheelEventInterface), $84b63352e7e6aba6$var$ToggleEventInterface = $84b63352e7e6aba6$var$assign({}, $84b63352e7e6aba6$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $84b63352e7e6aba6$var$SyntheticToggleEvent = $84b63352e7e6aba6$var$createSyntheticEvent($84b63352e7e6aba6$var$ToggleEventInterface), $84b63352e7e6aba6$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $84b63352e7e6aba6$var$canUseCompositionEvent = $84b63352e7e6aba6$var$canUseDOM && "CompositionEvent" in window, $84b63352e7e6aba6$var$documentMode = null;
$84b63352e7e6aba6$var$canUseDOM && "documentMode" in document && ($84b63352e7e6aba6$var$documentMode = document.documentMode);
var $84b63352e7e6aba6$var$canUseTextInputEvent = $84b63352e7e6aba6$var$canUseDOM && "TextEvent" in window && !$84b63352e7e6aba6$var$documentMode, $84b63352e7e6aba6$var$useFallbackCompositionData = $84b63352e7e6aba6$var$canUseDOM && (!$84b63352e7e6aba6$var$canUseCompositionEvent || $84b63352e7e6aba6$var$documentMode && 8 < $84b63352e7e6aba6$var$documentMode && 11 >= $84b63352e7e6aba6$var$documentMode), $84b63352e7e6aba6$var$SPACEBAR_CHAR = String.fromCharCode(32), $84b63352e7e6aba6$var$hasSpaceKeypress = !1;
function $84b63352e7e6aba6$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $84b63352e7e6aba6$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $84b63352e7e6aba6$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $84b63352e7e6aba6$var$isComposing = !1;
function $84b63352e7e6aba6$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $84b63352e7e6aba6$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $84b63352e7e6aba6$var$hasSpaceKeypress = !0;
            return $84b63352e7e6aba6$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $84b63352e7e6aba6$var$SPACEBAR_CHAR && $84b63352e7e6aba6$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $84b63352e7e6aba6$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($84b63352e7e6aba6$var$isComposing) return "compositionend" === domEventName || !$84b63352e7e6aba6$var$canUseCompositionEvent && $84b63352e7e6aba6$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $84b63352e7e6aba6$var$getData(), $84b63352e7e6aba6$var$fallbackText = $84b63352e7e6aba6$var$startText = $84b63352e7e6aba6$var$root = null, $84b63352e7e6aba6$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $84b63352e7e6aba6$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $84b63352e7e6aba6$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $84b63352e7e6aba6$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$84b63352e7e6aba6$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $84b63352e7e6aba6$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $84b63352e7e6aba6$var$restoreTarget ? $84b63352e7e6aba6$var$restoreQueue ? $84b63352e7e6aba6$var$restoreQueue.push(target) : $84b63352e7e6aba6$var$restoreQueue = [
        target
    ] : $84b63352e7e6aba6$var$restoreTarget = target;
    inst = $84b63352e7e6aba6$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $84b63352e7e6aba6$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $84b63352e7e6aba6$var$activeElement$1 = null, $84b63352e7e6aba6$var$activeElementInst$1 = null;
function $84b63352e7e6aba6$var$runEventInBatch(dispatchQueue) {
    $84b63352e7e6aba6$var$processDispatchQueue(dispatchQueue, 0);
}
function $84b63352e7e6aba6$var$getInstIfValueChanged(targetInst) {
    var targetNode = $84b63352e7e6aba6$var$getNodeFromInstance(targetInst);
    if ($84b63352e7e6aba6$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $84b63352e7e6aba6$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $84b63352e7e6aba6$var$isInputEventSupported = !1;
if ($84b63352e7e6aba6$var$canUseDOM) {
    var $84b63352e7e6aba6$var$JSCompiler_inline_result$jscomp$283;
    if ($84b63352e7e6aba6$var$canUseDOM) {
        var $84b63352e7e6aba6$var$isSupported$jscomp$inline_418 = "oninput" in document;
        if (!$84b63352e7e6aba6$var$isSupported$jscomp$inline_418) {
            var $84b63352e7e6aba6$var$element$jscomp$inline_419 = document.createElement("div");
            $84b63352e7e6aba6$var$element$jscomp$inline_419.setAttribute("oninput", "return;");
            $84b63352e7e6aba6$var$isSupported$jscomp$inline_418 = "function" === typeof $84b63352e7e6aba6$var$element$jscomp$inline_419.oninput;
        }
        $84b63352e7e6aba6$var$JSCompiler_inline_result$jscomp$283 = $84b63352e7e6aba6$var$isSupported$jscomp$inline_418;
    } else $84b63352e7e6aba6$var$JSCompiler_inline_result$jscomp$283 = !1;
    $84b63352e7e6aba6$var$isInputEventSupported = $84b63352e7e6aba6$var$JSCompiler_inline_result$jscomp$283 && (!document.documentMode || 9 < document.documentMode);
}
function $84b63352e7e6aba6$var$stopWatchingForValueChange() {
    $84b63352e7e6aba6$var$activeElement$1 && ($84b63352e7e6aba6$var$activeElement$1.detachEvent("onpropertychange", $84b63352e7e6aba6$var$handlePropertyChange), $84b63352e7e6aba6$var$activeElementInst$1 = $84b63352e7e6aba6$var$activeElement$1 = null);
}
function $84b63352e7e6aba6$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $84b63352e7e6aba6$var$getInstIfValueChanged($84b63352e7e6aba6$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $84b63352e7e6aba6$var$createAndAccumulateChangeEvent(dispatchQueue, $84b63352e7e6aba6$var$activeElementInst$1, nativeEvent, $84b63352e7e6aba6$var$getEventTarget(nativeEvent));
        $84b63352e7e6aba6$var$batchedUpdates$1($84b63352e7e6aba6$var$runEventInBatch, dispatchQueue);
    }
}
function $84b63352e7e6aba6$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($84b63352e7e6aba6$var$stopWatchingForValueChange(), $84b63352e7e6aba6$var$activeElement$1 = target, $84b63352e7e6aba6$var$activeElementInst$1 = targetInst, $84b63352e7e6aba6$var$activeElement$1.attachEvent("onpropertychange", $84b63352e7e6aba6$var$handlePropertyChange)) : "focusout" === domEventName && $84b63352e7e6aba6$var$stopWatchingForValueChange();
}
function $84b63352e7e6aba6$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $84b63352e7e6aba6$var$getInstIfValueChanged($84b63352e7e6aba6$var$activeElementInst$1);
}
function $84b63352e7e6aba6$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $84b63352e7e6aba6$var$getInstIfValueChanged(targetInst);
}
function $84b63352e7e6aba6$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $84b63352e7e6aba6$var$getInstIfValueChanged(targetInst);
}
function $84b63352e7e6aba6$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $84b63352e7e6aba6$var$objectIs = "function" === typeof Object.is ? Object.is : $84b63352e7e6aba6$var$is;
function $84b63352e7e6aba6$var$shallowEqual(objA, objB) {
    if ($84b63352e7e6aba6$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$84b63352e7e6aba6$var$hasOwnProperty.call(objB, currentKey) || !$84b63352e7e6aba6$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $84b63352e7e6aba6$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $84b63352e7e6aba6$var$getNodeForCharacterOffset(root, offset) {
    var node = $84b63352e7e6aba6$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $84b63352e7e6aba6$var$getLeafNode(node);
    }
}
function $84b63352e7e6aba6$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $84b63352e7e6aba6$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $84b63352e7e6aba6$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $84b63352e7e6aba6$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $84b63352e7e6aba6$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $84b63352e7e6aba6$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
function $84b63352e7e6aba6$var$restoreSelection(priorSelectionInformation, containerInfo) {
    var curFocusedElem = $84b63352e7e6aba6$var$getActiveElementDeep(containerInfo);
    containerInfo = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== containerInfo && containerInfo && containerInfo.ownerDocument && $84b63352e7e6aba6$var$containsNode(containerInfo.ownerDocument.documentElement, containerInfo)) {
        if (null !== priorSelectionRange && $84b63352e7e6aba6$var$hasSelectionCapabilities(containerInfo)) {
            if (priorSelectionInformation = priorSelectionRange.start, curFocusedElem = priorSelectionRange.end, void 0 === curFocusedElem && (curFocusedElem = priorSelectionInformation), "selectionStart" in containerInfo) containerInfo.selectionStart = priorSelectionInformation, containerInfo.selectionEnd = Math.min(curFocusedElem, containerInfo.value.length);
            else if (curFocusedElem = (priorSelectionInformation = containerInfo.ownerDocument || document) && priorSelectionInformation.defaultView || window, curFocusedElem.getSelection) {
                curFocusedElem = curFocusedElem.getSelection();
                var length = containerInfo.textContent.length, start = Math.min(priorSelectionRange.start, length);
                priorSelectionRange = void 0 === priorSelectionRange.end ? start : Math.min(priorSelectionRange.end, length);
                !curFocusedElem.extend && start > priorSelectionRange && (length = priorSelectionRange, priorSelectionRange = start, start = length);
                length = $84b63352e7e6aba6$var$getNodeForCharacterOffset(containerInfo, start);
                var endMarker = $84b63352e7e6aba6$var$getNodeForCharacterOffset(containerInfo, priorSelectionRange);
                length && endMarker && (1 !== curFocusedElem.rangeCount || curFocusedElem.anchorNode !== length.node || curFocusedElem.anchorOffset !== length.offset || curFocusedElem.focusNode !== endMarker.node || curFocusedElem.focusOffset !== endMarker.offset) && (priorSelectionInformation = priorSelectionInformation.createRange(), priorSelectionInformation.setStart(length.node, length.offset), curFocusedElem.removeAllRanges(), start > priorSelectionRange ? (curFocusedElem.addRange(priorSelectionInformation), curFocusedElem.extend(endMarker.node, endMarker.offset)) : (priorSelectionInformation.setEnd(endMarker.node, endMarker.offset), curFocusedElem.addRange(priorSelectionInformation)));
            }
        }
        priorSelectionInformation = [];
        for(curFocusedElem = containerInfo; curFocusedElem = curFocusedElem.parentNode;)1 === curFocusedElem.nodeType && priorSelectionInformation.push({
            element: curFocusedElem,
            left: curFocusedElem.scrollLeft,
            top: curFocusedElem.scrollTop
        });
        "function" === typeof containerInfo.focus && containerInfo.focus();
        for(containerInfo = 0; containerInfo < priorSelectionInformation.length; containerInfo++)curFocusedElem = priorSelectionInformation[containerInfo], curFocusedElem.element.scrollLeft = curFocusedElem.left, curFocusedElem.element.scrollTop = curFocusedElem.top;
    }
}
var $84b63352e7e6aba6$var$skipSelectionChangeEvent = $84b63352e7e6aba6$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $84b63352e7e6aba6$var$activeElement = null, $84b63352e7e6aba6$var$activeElementInst = null, $84b63352e7e6aba6$var$lastSelection = null, $84b63352e7e6aba6$var$mouseDown = !1;
function $84b63352e7e6aba6$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $84b63352e7e6aba6$var$mouseDown || null == $84b63352e7e6aba6$var$activeElement || $84b63352e7e6aba6$var$activeElement !== $84b63352e7e6aba6$var$getActiveElement(doc) || (doc = $84b63352e7e6aba6$var$activeElement, "selectionStart" in doc && $84b63352e7e6aba6$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $84b63352e7e6aba6$var$lastSelection && $84b63352e7e6aba6$var$shallowEqual($84b63352e7e6aba6$var$lastSelection, doc) || ($84b63352e7e6aba6$var$lastSelection = doc, doc = $84b63352e7e6aba6$var$accumulateTwoPhaseListeners($84b63352e7e6aba6$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $84b63352e7e6aba6$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $84b63352e7e6aba6$var$activeElement)));
}
function $84b63352e7e6aba6$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $84b63352e7e6aba6$var$vendorPrefixes = {
    animationend: $84b63352e7e6aba6$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $84b63352e7e6aba6$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $84b63352e7e6aba6$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $84b63352e7e6aba6$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $84b63352e7e6aba6$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $84b63352e7e6aba6$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $84b63352e7e6aba6$var$makePrefixMap("Transition", "TransitionEnd")
}, $84b63352e7e6aba6$var$prefixedEventNames = {}, $84b63352e7e6aba6$var$style = {};
$84b63352e7e6aba6$var$canUseDOM && ($84b63352e7e6aba6$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $84b63352e7e6aba6$var$vendorPrefixes.animationend.animation, delete $84b63352e7e6aba6$var$vendorPrefixes.animationiteration.animation, delete $84b63352e7e6aba6$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $84b63352e7e6aba6$var$vendorPrefixes.transitionend.transition);
function $84b63352e7e6aba6$var$getVendorPrefixedEventName(eventName) {
    if ($84b63352e7e6aba6$var$prefixedEventNames[eventName]) return $84b63352e7e6aba6$var$prefixedEventNames[eventName];
    if (!$84b63352e7e6aba6$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $84b63352e7e6aba6$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $84b63352e7e6aba6$var$style) return $84b63352e7e6aba6$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $84b63352e7e6aba6$var$ANIMATION_END = $84b63352e7e6aba6$var$getVendorPrefixedEventName("animationend"), $84b63352e7e6aba6$var$ANIMATION_ITERATION = $84b63352e7e6aba6$var$getVendorPrefixedEventName("animationiteration"), $84b63352e7e6aba6$var$ANIMATION_START = $84b63352e7e6aba6$var$getVendorPrefixedEventName("animationstart"), $84b63352e7e6aba6$var$TRANSITION_RUN = $84b63352e7e6aba6$var$getVendorPrefixedEventName("transitionrun"), $84b63352e7e6aba6$var$TRANSITION_START = $84b63352e7e6aba6$var$getVendorPrefixedEventName("transitionstart"), $84b63352e7e6aba6$var$TRANSITION_CANCEL = $84b63352e7e6aba6$var$getVendorPrefixedEventName("transitioncancel"), $84b63352e7e6aba6$var$TRANSITION_END = $84b63352e7e6aba6$var$getVendorPrefixedEventName("transitionend"), $84b63352e7e6aba6$var$topLevelEventsToReactNames = new Map(), $84b63352e7e6aba6$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(" ");
function $84b63352e7e6aba6$var$registerSimpleEvent(domEventName, reactName) {
    $84b63352e7e6aba6$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $84b63352e7e6aba6$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $84b63352e7e6aba6$var$concurrentQueues = [], $84b63352e7e6aba6$var$concurrentQueuesIndex = 0, $84b63352e7e6aba6$var$concurrentlyUpdatedLanes = 0;
function $84b63352e7e6aba6$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $84b63352e7e6aba6$var$concurrentQueuesIndex, i = $84b63352e7e6aba6$var$concurrentlyUpdatedLanes = $84b63352e7e6aba6$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $84b63352e7e6aba6$var$concurrentQueues[i];
        $84b63352e7e6aba6$var$concurrentQueues[i++] = null;
        var queue = $84b63352e7e6aba6$var$concurrentQueues[i];
        $84b63352e7e6aba6$var$concurrentQueues[i++] = null;
        var update = $84b63352e7e6aba6$var$concurrentQueues[i];
        $84b63352e7e6aba6$var$concurrentQueues[i++] = null;
        var lane = $84b63352e7e6aba6$var$concurrentQueues[i];
        $84b63352e7e6aba6$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $84b63352e7e6aba6$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $84b63352e7e6aba6$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $84b63352e7e6aba6$var$concurrentQueues[$84b63352e7e6aba6$var$concurrentQueuesIndex++] = fiber;
    $84b63352e7e6aba6$var$concurrentQueues[$84b63352e7e6aba6$var$concurrentQueuesIndex++] = queue;
    $84b63352e7e6aba6$var$concurrentQueues[$84b63352e7e6aba6$var$concurrentQueuesIndex++] = update;
    $84b63352e7e6aba6$var$concurrentQueues[$84b63352e7e6aba6$var$concurrentQueuesIndex++] = lane;
    $84b63352e7e6aba6$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $84b63352e7e6aba6$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $84b63352e7e6aba6$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $84b63352e7e6aba6$var$getRootForUpdatedFiber(fiber);
}
function $84b63352e7e6aba6$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $84b63352e7e6aba6$var$enqueueUpdate$1(fiber, null, null, lane);
    return $84b63352e7e6aba6$var$getRootForUpdatedFiber(fiber);
}
function $84b63352e7e6aba6$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - $84b63352e7e6aba6$var$clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
        update
    ] : sourceFiber.push(update), update.lane = lane | 536870912);
}
function $84b63352e7e6aba6$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $84b63352e7e6aba6$var$nestedUpdateCount) throw $84b63352e7e6aba6$var$nestedUpdateCount = 0, $84b63352e7e6aba6$var$rootWithNestedUpdates = null, Error($84b63352e7e6aba6$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $84b63352e7e6aba6$var$emptyContextObject = {}, $84b63352e7e6aba6$var$CapturedStacks = new WeakMap();
function $84b63352e7e6aba6$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $84b63352e7e6aba6$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $84b63352e7e6aba6$var$getStackByFiberInDevAndProd(source)
        };
        $84b63352e7e6aba6$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $84b63352e7e6aba6$var$getStackByFiberInDevAndProd(source)
    };
}
var $84b63352e7e6aba6$var$forkStack = [], $84b63352e7e6aba6$var$forkStackIndex = 0, $84b63352e7e6aba6$var$treeForkProvider = null, $84b63352e7e6aba6$var$treeForkCount = 0, $84b63352e7e6aba6$var$idStack = [], $84b63352e7e6aba6$var$idStackIndex = 0, $84b63352e7e6aba6$var$treeContextProvider = null, $84b63352e7e6aba6$var$treeContextId = 1, $84b63352e7e6aba6$var$treeContextOverflow = "";
function $84b63352e7e6aba6$var$pushTreeFork(workInProgress, totalChildren) {
    $84b63352e7e6aba6$var$forkStack[$84b63352e7e6aba6$var$forkStackIndex++] = $84b63352e7e6aba6$var$treeForkCount;
    $84b63352e7e6aba6$var$forkStack[$84b63352e7e6aba6$var$forkStackIndex++] = $84b63352e7e6aba6$var$treeForkProvider;
    $84b63352e7e6aba6$var$treeForkProvider = workInProgress;
    $84b63352e7e6aba6$var$treeForkCount = totalChildren;
}
function $84b63352e7e6aba6$var$pushTreeId(workInProgress, totalChildren, index) {
    $84b63352e7e6aba6$var$idStack[$84b63352e7e6aba6$var$idStackIndex++] = $84b63352e7e6aba6$var$treeContextId;
    $84b63352e7e6aba6$var$idStack[$84b63352e7e6aba6$var$idStackIndex++] = $84b63352e7e6aba6$var$treeContextOverflow;
    $84b63352e7e6aba6$var$idStack[$84b63352e7e6aba6$var$idStackIndex++] = $84b63352e7e6aba6$var$treeContextProvider;
    $84b63352e7e6aba6$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $84b63352e7e6aba6$var$treeContextId;
    workInProgress = $84b63352e7e6aba6$var$treeContextOverflow;
    var baseLength = 32 - $84b63352e7e6aba6$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $84b63352e7e6aba6$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $84b63352e7e6aba6$var$treeContextId = 1 << 32 - $84b63352e7e6aba6$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $84b63352e7e6aba6$var$treeContextOverflow = length + workInProgress;
    } else $84b63352e7e6aba6$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $84b63352e7e6aba6$var$treeContextOverflow = workInProgress;
}
function $84b63352e7e6aba6$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($84b63352e7e6aba6$var$pushTreeFork(workInProgress, 1), $84b63352e7e6aba6$var$pushTreeId(workInProgress, 1, 0));
}
function $84b63352e7e6aba6$var$popTreeContext(workInProgress) {
    for(; workInProgress === $84b63352e7e6aba6$var$treeForkProvider;)$84b63352e7e6aba6$var$treeForkProvider = $84b63352e7e6aba6$var$forkStack[--$84b63352e7e6aba6$var$forkStackIndex], $84b63352e7e6aba6$var$forkStack[$84b63352e7e6aba6$var$forkStackIndex] = null, $84b63352e7e6aba6$var$treeForkCount = $84b63352e7e6aba6$var$forkStack[--$84b63352e7e6aba6$var$forkStackIndex], $84b63352e7e6aba6$var$forkStack[$84b63352e7e6aba6$var$forkStackIndex] = null;
    for(; workInProgress === $84b63352e7e6aba6$var$treeContextProvider;)$84b63352e7e6aba6$var$treeContextProvider = $84b63352e7e6aba6$var$idStack[--$84b63352e7e6aba6$var$idStackIndex], $84b63352e7e6aba6$var$idStack[$84b63352e7e6aba6$var$idStackIndex] = null, $84b63352e7e6aba6$var$treeContextOverflow = $84b63352e7e6aba6$var$idStack[--$84b63352e7e6aba6$var$idStackIndex], $84b63352e7e6aba6$var$idStack[$84b63352e7e6aba6$var$idStackIndex] = null, $84b63352e7e6aba6$var$treeContextId = $84b63352e7e6aba6$var$idStack[--$84b63352e7e6aba6$var$idStackIndex], $84b63352e7e6aba6$var$idStack[$84b63352e7e6aba6$var$idStackIndex] = null;
}
var $84b63352e7e6aba6$var$hydrationParentFiber = null, $84b63352e7e6aba6$var$nextHydratableInstance = null, $84b63352e7e6aba6$var$isHydrating = !1, $84b63352e7e6aba6$var$hydrationErrors = null, $84b63352e7e6aba6$var$rootOrSingletonContext = !1, $84b63352e7e6aba6$var$HydrationMismatchException = Error($84b63352e7e6aba6$var$formatProdErrorMessage(519));
function $84b63352e7e6aba6$var$throwOnHydrationMismatch(fiber) {
    var error = Error($84b63352e7e6aba6$var$formatProdErrorMessage(418, ""));
    $84b63352e7e6aba6$var$queueHydrationError($84b63352e7e6aba6$var$createCapturedValueAtFiber(error, fiber));
    throw $84b63352e7e6aba6$var$HydrationMismatchException;
}
function $84b63352e7e6aba6$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$84b63352e7e6aba6$var$internalInstanceKey] = fiber;
    instance[$84b63352e7e6aba6$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("cancel", instance);
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $84b63352e7e6aba6$var$mediaEventTypes.length; type++)$84b63352e7e6aba6$var$listenToNonDelegatedEvent($84b63352e7e6aba6$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("error", instance);
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("invalid", instance);
            $84b63352e7e6aba6$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $84b63352e7e6aba6$var$track(instance);
            break;
        case "select":
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("invalid", instance), $84b63352e7e6aba6$var$initTextarea(instance, props.value, props.defaultValue, props.children), $84b63352e7e6aba6$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $84b63352e7e6aba6$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($84b63352e7e6aba6$var$listenToNonDelegatedEvent("beforetoggle", instance), $84b63352e7e6aba6$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $84b63352e7e6aba6$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $84b63352e7e6aba6$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $84b63352e7e6aba6$var$noop$1), instance = !0) : instance = !1;
    instance || $84b63352e7e6aba6$var$throwOnHydrationMismatch(fiber);
}
function $84b63352e7e6aba6$var$popToNextHostParent(fiber) {
    for($84b63352e7e6aba6$var$hydrationParentFiber = fiber.return; $84b63352e7e6aba6$var$hydrationParentFiber;)switch($84b63352e7e6aba6$var$hydrationParentFiber.tag){
        case 3:
        case 27:
            $84b63352e7e6aba6$var$rootOrSingletonContext = !0;
            return;
        case 5:
        case 13:
            $84b63352e7e6aba6$var$rootOrSingletonContext = !1;
            return;
        default:
            $84b63352e7e6aba6$var$hydrationParentFiber = $84b63352e7e6aba6$var$hydrationParentFiber.return;
    }
}
function $84b63352e7e6aba6$var$popHydrationState(fiber) {
    if (fiber !== $84b63352e7e6aba6$var$hydrationParentFiber) return !1;
    if (!$84b63352e7e6aba6$var$isHydrating) return $84b63352e7e6aba6$var$popToNextHostParent(fiber), $84b63352e7e6aba6$var$isHydrating = !0, !1;
    var shouldClear = !1, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== fiber.tag && 27 !== fiber.tag) {
        if (JSCompiler_temp = 5 === fiber.tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $84b63352e7e6aba6$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && (shouldClear = !0);
    shouldClear && $84b63352e7e6aba6$var$nextHydratableInstance && $84b63352e7e6aba6$var$throwOnHydrationMismatch(fiber);
    $84b63352e7e6aba6$var$popToNextHostParent(fiber);
    if (13 === fiber.tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(shouldClear = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === shouldClear) {
                            $84b63352e7e6aba6$var$nextHydratableInstance = $84b63352e7e6aba6$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        shouldClear--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || shouldClear++;
                }
                fiber = fiber.nextSibling;
            }
            $84b63352e7e6aba6$var$nextHydratableInstance = null;
        }
    } else $84b63352e7e6aba6$var$nextHydratableInstance = $84b63352e7e6aba6$var$hydrationParentFiber ? $84b63352e7e6aba6$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $84b63352e7e6aba6$var$resetHydrationState() {
    $84b63352e7e6aba6$var$nextHydratableInstance = $84b63352e7e6aba6$var$hydrationParentFiber = null;
    $84b63352e7e6aba6$var$isHydrating = !1;
}
function $84b63352e7e6aba6$var$queueHydrationError(error) {
    null === $84b63352e7e6aba6$var$hydrationErrors ? $84b63352e7e6aba6$var$hydrationErrors = [
        error
    ] : $84b63352e7e6aba6$var$hydrationErrors.push(error);
}
var $84b63352e7e6aba6$var$SuspenseException = Error($84b63352e7e6aba6$var$formatProdErrorMessage(460)), $84b63352e7e6aba6$var$SuspenseyCommitException = Error($84b63352e7e6aba6$var$formatProdErrorMessage(474)), $84b63352e7e6aba6$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $84b63352e7e6aba6$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $84b63352e7e6aba6$var$noop$3() {}
function $84b63352e7e6aba6$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($84b63352e7e6aba6$var$noop$3, $84b63352e7e6aba6$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            if (thenableState === $84b63352e7e6aba6$var$SuspenseException) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(483));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($84b63352e7e6aba6$var$noop$3, $84b63352e7e6aba6$var$noop$3);
            else {
                thenableState = $84b63352e7e6aba6$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    thenableState = thenable.reason;
                    if (thenableState === $84b63352e7e6aba6$var$SuspenseException) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(483));
                    throw thenableState;
            }
            $84b63352e7e6aba6$var$suspendedThenable = thenable;
            throw $84b63352e7e6aba6$var$SuspenseException;
    }
}
var $84b63352e7e6aba6$var$suspendedThenable = null;
function $84b63352e7e6aba6$var$getSuspendedThenable() {
    if (null === $84b63352e7e6aba6$var$suspendedThenable) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(459));
    var thenable = $84b63352e7e6aba6$var$suspendedThenable;
    $84b63352e7e6aba6$var$suspendedThenable = null;
    return thenable;
}
var $84b63352e7e6aba6$var$thenableState$1 = null, $84b63352e7e6aba6$var$thenableIndexCounter$1 = 0;
function $84b63352e7e6aba6$var$unwrapThenable(thenable) {
    var index = $84b63352e7e6aba6$var$thenableIndexCounter$1;
    $84b63352e7e6aba6$var$thenableIndexCounter$1 += 1;
    null === $84b63352e7e6aba6$var$thenableState$1 && ($84b63352e7e6aba6$var$thenableState$1 = []);
    return $84b63352e7e6aba6$var$trackUsedThenable($84b63352e7e6aba6$var$thenableState$1, thenable, index);
}
function $84b63352e7e6aba6$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $84b63352e7e6aba6$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $84b63352e7e6aba6$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $84b63352e7e6aba6$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $84b63352e7e6aba6$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $84b63352e7e6aba6$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
        newFiber.flags |= 33554434;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $84b63352e7e6aba6$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $84b63352e7e6aba6$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $84b63352e7e6aba6$var$REACT_LAZY_TYPE && $84b63352e7e6aba6$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $84b63352e7e6aba6$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $84b63352e7e6aba6$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $84b63352e7e6aba6$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $84b63352e7e6aba6$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $84b63352e7e6aba6$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $84b63352e7e6aba6$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $84b63352e7e6aba6$var$REACT_ELEMENT_TYPE:
                    return lanes = $84b63352e7e6aba6$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $84b63352e7e6aba6$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $84b63352e7e6aba6$var$REACT_PORTAL_TYPE:
                    return newChild = $84b63352e7e6aba6$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $84b63352e7e6aba6$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($84b63352e7e6aba6$var$isArrayImpl(newChild) || $84b63352e7e6aba6$var$getIteratorFn(newChild)) return newChild = $84b63352e7e6aba6$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $84b63352e7e6aba6$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $84b63352e7e6aba6$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $84b63352e7e6aba6$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $84b63352e7e6aba6$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $84b63352e7e6aba6$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $84b63352e7e6aba6$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $84b63352e7e6aba6$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($84b63352e7e6aba6$var$isArrayImpl(newChild) || $84b63352e7e6aba6$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $84b63352e7e6aba6$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $84b63352e7e6aba6$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $84b63352e7e6aba6$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $84b63352e7e6aba6$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $84b63352e7e6aba6$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $84b63352e7e6aba6$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $84b63352e7e6aba6$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($84b63352e7e6aba6$var$isArrayImpl(newChild) || $84b63352e7e6aba6$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $84b63352e7e6aba6$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $84b63352e7e6aba6$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $84b63352e7e6aba6$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $84b63352e7e6aba6$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $84b63352e7e6aba6$var$isHydrating && $84b63352e7e6aba6$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $84b63352e7e6aba6$var$isHydrating && $84b63352e7e6aba6$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $84b63352e7e6aba6$var$isHydrating && $84b63352e7e6aba6$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $84b63352e7e6aba6$var$isHydrating && $84b63352e7e6aba6$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $84b63352e7e6aba6$var$isHydrating && $84b63352e7e6aba6$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $84b63352e7e6aba6$var$isHydrating && $84b63352e7e6aba6$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $84b63352e7e6aba6$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $84b63352e7e6aba6$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $84b63352e7e6aba6$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $84b63352e7e6aba6$var$REACT_LAZY_TYPE && $84b63352e7e6aba6$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $84b63352e7e6aba6$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $84b63352e7e6aba6$var$REACT_FRAGMENT_TYPE ? (lanes = $84b63352e7e6aba6$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $84b63352e7e6aba6$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $84b63352e7e6aba6$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $84b63352e7e6aba6$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $84b63352e7e6aba6$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $84b63352e7e6aba6$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($84b63352e7e6aba6$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($84b63352e7e6aba6$var$getIteratorFn(newChild)) {
                key = $84b63352e7e6aba6$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $84b63352e7e6aba6$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $84b63352e7e6aba6$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $84b63352e7e6aba6$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $84b63352e7e6aba6$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $84b63352e7e6aba6$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $84b63352e7e6aba6$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $84b63352e7e6aba6$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $84b63352e7e6aba6$var$SuspenseException) throw x;
            var fiber = $84b63352e7e6aba6$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $84b63352e7e6aba6$var$reconcileChildFibers = $84b63352e7e6aba6$var$createChildReconciler(!0), $84b63352e7e6aba6$var$mountChildFibers = $84b63352e7e6aba6$var$createChildReconciler(!1), $84b63352e7e6aba6$var$currentTreeHiddenStackCursor = $84b63352e7e6aba6$var$createCursor(null), $84b63352e7e6aba6$var$prevEntangledRenderLanesCursor = $84b63352e7e6aba6$var$createCursor(0);
function $84b63352e7e6aba6$var$pushHiddenContext(fiber, context) {
    fiber = $84b63352e7e6aba6$var$entangledRenderLanes;
    $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$prevEntangledRenderLanesCursor, fiber);
    $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$currentTreeHiddenStackCursor, context);
    $84b63352e7e6aba6$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $84b63352e7e6aba6$var$reuseHiddenContextOnStack() {
    $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$prevEntangledRenderLanesCursor, $84b63352e7e6aba6$var$entangledRenderLanes);
    $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$currentTreeHiddenStackCursor, $84b63352e7e6aba6$var$currentTreeHiddenStackCursor.current);
}
function $84b63352e7e6aba6$var$popHiddenContext() {
    $84b63352e7e6aba6$var$entangledRenderLanes = $84b63352e7e6aba6$var$prevEntangledRenderLanesCursor.current;
    $84b63352e7e6aba6$var$pop($84b63352e7e6aba6$var$currentTreeHiddenStackCursor);
    $84b63352e7e6aba6$var$pop($84b63352e7e6aba6$var$prevEntangledRenderLanesCursor);
}
var $84b63352e7e6aba6$var$suspenseHandlerStackCursor = $84b63352e7e6aba6$var$createCursor(null), $84b63352e7e6aba6$var$shellBoundary = null;
function $84b63352e7e6aba6$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$suspenseStackCursor, $84b63352e7e6aba6$var$suspenseStackCursor.current & 1);
    $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$suspenseHandlerStackCursor, handler);
    null === $84b63352e7e6aba6$var$shellBoundary && (null === current || null !== $84b63352e7e6aba6$var$currentTreeHiddenStackCursor.current ? $84b63352e7e6aba6$var$shellBoundary = handler : null !== current.memoizedState && ($84b63352e7e6aba6$var$shellBoundary = handler));
}
function $84b63352e7e6aba6$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$suspenseStackCursor, $84b63352e7e6aba6$var$suspenseStackCursor.current), $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$suspenseHandlerStackCursor, fiber), null === $84b63352e7e6aba6$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($84b63352e7e6aba6$var$shellBoundary = fiber);
        }
    } else $84b63352e7e6aba6$var$reuseSuspenseHandlerOnStack(fiber);
}
function $84b63352e7e6aba6$var$reuseSuspenseHandlerOnStack() {
    $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$suspenseStackCursor, $84b63352e7e6aba6$var$suspenseStackCursor.current);
    $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$suspenseHandlerStackCursor, $84b63352e7e6aba6$var$suspenseHandlerStackCursor.current);
}
function $84b63352e7e6aba6$var$popSuspenseHandler(fiber) {
    $84b63352e7e6aba6$var$pop($84b63352e7e6aba6$var$suspenseHandlerStackCursor);
    $84b63352e7e6aba6$var$shellBoundary === fiber && ($84b63352e7e6aba6$var$shellBoundary = null);
    $84b63352e7e6aba6$var$pop($84b63352e7e6aba6$var$suspenseStackCursor);
}
var $84b63352e7e6aba6$var$suspenseStackCursor = $84b63352e7e6aba6$var$createCursor(0);
function $84b63352e7e6aba6$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || "$!" === state.data)) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $84b63352e7e6aba6$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $84b63352e7e6aba6$var$scheduleCallback$2 = $4mq2P.unstable_scheduleCallback, $84b63352e7e6aba6$var$NormalPriority = $4mq2P.unstable_NormalPriority, $84b63352e7e6aba6$var$CacheContext = {
    $$typeof: $84b63352e7e6aba6$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $84b63352e7e6aba6$var$createCache() {
    return {
        controller: new $84b63352e7e6aba6$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $84b63352e7e6aba6$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $84b63352e7e6aba6$var$scheduleCallback$2($84b63352e7e6aba6$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $84b63352e7e6aba6$var$currentEntangledListeners = null, $84b63352e7e6aba6$var$currentEntangledPendingCount = 0, $84b63352e7e6aba6$var$currentEntangledLane = 0, $84b63352e7e6aba6$var$currentEntangledActionThenable = null;
function $84b63352e7e6aba6$var$entangleAsyncAction(transition, thenable) {
    if (null === $84b63352e7e6aba6$var$currentEntangledListeners) {
        var entangledListeners = $84b63352e7e6aba6$var$currentEntangledListeners = [];
        $84b63352e7e6aba6$var$currentEntangledPendingCount = 0;
        $84b63352e7e6aba6$var$currentEntangledLane = $84b63352e7e6aba6$var$requestTransitionLane();
        $84b63352e7e6aba6$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $84b63352e7e6aba6$var$currentEntangledPendingCount++;
    thenable.then($84b63352e7e6aba6$var$pingEngtangledActionScope, $84b63352e7e6aba6$var$pingEngtangledActionScope);
    return thenable;
}
function $84b63352e7e6aba6$var$pingEngtangledActionScope() {
    if (0 === --$84b63352e7e6aba6$var$currentEntangledPendingCount && null !== $84b63352e7e6aba6$var$currentEntangledListeners) {
        null !== $84b63352e7e6aba6$var$currentEntangledActionThenable && ($84b63352e7e6aba6$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $84b63352e7e6aba6$var$currentEntangledListeners;
        $84b63352e7e6aba6$var$currentEntangledListeners = null;
        $84b63352e7e6aba6$var$currentEntangledLane = 0;
        $84b63352e7e6aba6$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $84b63352e7e6aba6$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $84b63352e7e6aba6$var$prevOnStartTransitionFinish = $84b63352e7e6aba6$var$ReactSharedInternals.S;
$84b63352e7e6aba6$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $84b63352e7e6aba6$var$entangleAsyncAction(transition, returnValue);
    null !== $84b63352e7e6aba6$var$prevOnStartTransitionFinish && $84b63352e7e6aba6$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $84b63352e7e6aba6$var$resumedCache = $84b63352e7e6aba6$var$createCursor(null);
function $84b63352e7e6aba6$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $84b63352e7e6aba6$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $84b63352e7e6aba6$var$workInProgressRoot.pooledCache;
}
function $84b63352e7e6aba6$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$resumedCache, $84b63352e7e6aba6$var$resumedCache.current) : $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$resumedCache, prevCachePool.pool);
}
function $84b63352e7e6aba6$var$getSuspendedCache() {
    var cacheFromPool = $84b63352e7e6aba6$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $84b63352e7e6aba6$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $84b63352e7e6aba6$var$renderLanes = 0, $84b63352e7e6aba6$var$currentlyRenderingFiber$1 = null, $84b63352e7e6aba6$var$currentHook = null, $84b63352e7e6aba6$var$workInProgressHook = null, $84b63352e7e6aba6$var$didScheduleRenderPhaseUpdate = !1, $84b63352e7e6aba6$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $84b63352e7e6aba6$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $84b63352e7e6aba6$var$localIdCounter = 0, $84b63352e7e6aba6$var$thenableIndexCounter = 0, $84b63352e7e6aba6$var$thenableState = null, $84b63352e7e6aba6$var$globalClientIdCounter = 0;
function $84b63352e7e6aba6$var$throwInvalidHookError() {
    throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(321));
}
function $84b63352e7e6aba6$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$84b63352e7e6aba6$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $84b63352e7e6aba6$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $84b63352e7e6aba6$var$renderLanes = nextRenderLanes;
    $84b63352e7e6aba6$var$currentlyRenderingFiber$1 = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $84b63352e7e6aba6$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $84b63352e7e6aba6$var$HooksDispatcherOnMount : $84b63352e7e6aba6$var$HooksDispatcherOnUpdate;
    $84b63352e7e6aba6$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $84b63352e7e6aba6$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $84b63352e7e6aba6$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $84b63352e7e6aba6$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $84b63352e7e6aba6$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $84b63352e7e6aba6$var$finishRenderingHooks(current) {
    $84b63352e7e6aba6$var$ReactSharedInternals.H = $84b63352e7e6aba6$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $84b63352e7e6aba6$var$currentHook && null !== $84b63352e7e6aba6$var$currentHook.next;
    $84b63352e7e6aba6$var$renderLanes = 0;
    $84b63352e7e6aba6$var$workInProgressHook = $84b63352e7e6aba6$var$currentHook = $84b63352e7e6aba6$var$currentlyRenderingFiber$1 = null;
    $84b63352e7e6aba6$var$didScheduleRenderPhaseUpdate = !1;
    $84b63352e7e6aba6$var$thenableIndexCounter = 0;
    $84b63352e7e6aba6$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(300));
    null === current || $84b63352e7e6aba6$var$didReceiveUpdate || (current = current.dependencies, null !== current && $84b63352e7e6aba6$var$checkIfContextChanged(current) && ($84b63352e7e6aba6$var$didReceiveUpdate = !0));
}
function $84b63352e7e6aba6$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $84b63352e7e6aba6$var$currentlyRenderingFiber$1 = workInProgress;
    var numberOfReRenders = 0;
    do {
        $84b63352e7e6aba6$var$didScheduleRenderPhaseUpdateDuringThisPass && ($84b63352e7e6aba6$var$thenableState = null);
        $84b63352e7e6aba6$var$thenableIndexCounter = 0;
        $84b63352e7e6aba6$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $84b63352e7e6aba6$var$workInProgressHook = $84b63352e7e6aba6$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $84b63352e7e6aba6$var$ReactSharedInternals.H = $84b63352e7e6aba6$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($84b63352e7e6aba6$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $84b63352e7e6aba6$var$TransitionAwareHostComponent() {
    var dispatcher = $84b63352e7e6aba6$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $84b63352e7e6aba6$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $84b63352e7e6aba6$var$currentHook ? $84b63352e7e6aba6$var$currentHook.memoizedState : null) !== dispatcher && ($84b63352e7e6aba6$var$currentlyRenderingFiber$1.flags |= 1024);
    return maybeThenable;
}
function $84b63352e7e6aba6$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $84b63352e7e6aba6$var$localIdCounter;
    $84b63352e7e6aba6$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $84b63352e7e6aba6$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $84b63352e7e6aba6$var$resetHooksOnUnwind(workInProgress) {
    if ($84b63352e7e6aba6$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $84b63352e7e6aba6$var$didScheduleRenderPhaseUpdate = !1;
    }
    $84b63352e7e6aba6$var$renderLanes = 0;
    $84b63352e7e6aba6$var$workInProgressHook = $84b63352e7e6aba6$var$currentHook = $84b63352e7e6aba6$var$currentlyRenderingFiber$1 = null;
    $84b63352e7e6aba6$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $84b63352e7e6aba6$var$thenableIndexCounter = $84b63352e7e6aba6$var$localIdCounter = 0;
    $84b63352e7e6aba6$var$thenableState = null;
}
function $84b63352e7e6aba6$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $84b63352e7e6aba6$var$workInProgressHook ? $84b63352e7e6aba6$var$currentlyRenderingFiber$1.memoizedState = $84b63352e7e6aba6$var$workInProgressHook = hook : $84b63352e7e6aba6$var$workInProgressHook = $84b63352e7e6aba6$var$workInProgressHook.next = hook;
    return $84b63352e7e6aba6$var$workInProgressHook;
}
function $84b63352e7e6aba6$var$updateWorkInProgressHook() {
    if (null === $84b63352e7e6aba6$var$currentHook) {
        var nextCurrentHook = $84b63352e7e6aba6$var$currentlyRenderingFiber$1.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $84b63352e7e6aba6$var$currentHook.next;
    var nextWorkInProgressHook = null === $84b63352e7e6aba6$var$workInProgressHook ? $84b63352e7e6aba6$var$currentlyRenderingFiber$1.memoizedState : $84b63352e7e6aba6$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $84b63352e7e6aba6$var$workInProgressHook = nextWorkInProgressHook, $84b63352e7e6aba6$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $84b63352e7e6aba6$var$currentlyRenderingFiber$1.alternate) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(467));
            throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(310));
        }
        $84b63352e7e6aba6$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $84b63352e7e6aba6$var$currentHook.memoizedState,
            baseState: $84b63352e7e6aba6$var$currentHook.baseState,
            baseQueue: $84b63352e7e6aba6$var$currentHook.baseQueue,
            queue: $84b63352e7e6aba6$var$currentHook.queue,
            next: null
        };
        null === $84b63352e7e6aba6$var$workInProgressHook ? $84b63352e7e6aba6$var$currentlyRenderingFiber$1.memoizedState = $84b63352e7e6aba6$var$workInProgressHook = nextCurrentHook : $84b63352e7e6aba6$var$workInProgressHook = $84b63352e7e6aba6$var$workInProgressHook.next = nextCurrentHook;
    }
    return $84b63352e7e6aba6$var$workInProgressHook;
}
var $84b63352e7e6aba6$var$createFunctionComponentUpdateQueue;
$84b63352e7e6aba6$var$createFunctionComponentUpdateQueue = function() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function $84b63352e7e6aba6$var$useThenable(thenable) {
    var index = $84b63352e7e6aba6$var$thenableIndexCounter;
    $84b63352e7e6aba6$var$thenableIndexCounter += 1;
    null === $84b63352e7e6aba6$var$thenableState && ($84b63352e7e6aba6$var$thenableState = []);
    thenable = $84b63352e7e6aba6$var$trackUsedThenable($84b63352e7e6aba6$var$thenableState, thenable, index);
    index = $84b63352e7e6aba6$var$currentlyRenderingFiber$1;
    null === (null === $84b63352e7e6aba6$var$workInProgressHook ? index.memoizedState : $84b63352e7e6aba6$var$workInProgressHook.next) && (index = index.alternate, $84b63352e7e6aba6$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $84b63352e7e6aba6$var$HooksDispatcherOnMount : $84b63352e7e6aba6$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $84b63352e7e6aba6$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $84b63352e7e6aba6$var$useThenable(usable);
        if (usable.$$typeof === $84b63352e7e6aba6$var$REACT_CONTEXT_TYPE) return $84b63352e7e6aba6$var$readContext(usable);
    }
    throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(438, String(usable)));
}
function $84b63352e7e6aba6$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $84b63352e7e6aba6$var$currentlyRenderingFiber$1.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $84b63352e7e6aba6$var$currentlyRenderingFiber$1.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $84b63352e7e6aba6$var$createFunctionComponentUpdateQueue(), $84b63352e7e6aba6$var$currentlyRenderingFiber$1.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $84b63352e7e6aba6$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $84b63352e7e6aba6$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $84b63352e7e6aba6$var$updateReducer(reducer) {
    var hook = $84b63352e7e6aba6$var$updateWorkInProgressHook();
    return $84b63352e7e6aba6$var$updateReducerImpl(hook, $84b63352e7e6aba6$var$currentHook, reducer);
}
function $84b63352e7e6aba6$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$54 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($84b63352e7e6aba6$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($84b63352e7e6aba6$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $84b63352e7e6aba6$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                else if (($84b63352e7e6aba6$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $84b63352e7e6aba6$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $84b63352e7e6aba6$var$currentlyRenderingFiber$1.lanes |= revertLane, $84b63352e7e6aba6$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $84b63352e7e6aba6$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $84b63352e7e6aba6$var$currentlyRenderingFiber$1.lanes |= updateLane, $84b63352e7e6aba6$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$84b63352e7e6aba6$var$objectIs(pendingQueue, hook.memoizedState) && ($84b63352e7e6aba6$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$54 && (reducer = $84b63352e7e6aba6$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $84b63352e7e6aba6$var$rerenderReducer(reducer) {
    var hook = $84b63352e7e6aba6$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $84b63352e7e6aba6$var$objectIs(newState, hook.memoizedState) || ($84b63352e7e6aba6$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $84b63352e7e6aba6$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $84b63352e7e6aba6$var$currentlyRenderingFiber$1, hook = $84b63352e7e6aba6$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $84b63352e7e6aba6$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$84b63352e7e6aba6$var$objectIs(($84b63352e7e6aba6$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $84b63352e7e6aba6$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $84b63352e7e6aba6$var$updateEffect($84b63352e7e6aba6$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $84b63352e7e6aba6$var$workInProgressHook && $84b63352e7e6aba6$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $84b63352e7e6aba6$var$pushEffect(9, $84b63352e7e6aba6$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        if (null === $84b63352e7e6aba6$var$workInProgressRoot) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($84b63352e7e6aba6$var$renderLanes & 60) || $84b63352e7e6aba6$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $84b63352e7e6aba6$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $84b63352e7e6aba6$var$currentlyRenderingFiber$1.updateQueue;
    null === getSnapshot ? (getSnapshot = $84b63352e7e6aba6$var$createFunctionComponentUpdateQueue(), $84b63352e7e6aba6$var$currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $84b63352e7e6aba6$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $84b63352e7e6aba6$var$checkIfSnapshotChanged(inst) && $84b63352e7e6aba6$var$forceStoreRerender(fiber);
}
function $84b63352e7e6aba6$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $84b63352e7e6aba6$var$checkIfSnapshotChanged(inst) && $84b63352e7e6aba6$var$forceStoreRerender(fiber);
    });
}
function $84b63352e7e6aba6$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$84b63352e7e6aba6$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $84b63352e7e6aba6$var$forceStoreRerender(fiber) {
    var root = $84b63352e7e6aba6$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $84b63352e7e6aba6$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $84b63352e7e6aba6$var$mountStateImpl(initialState) {
    var hook = $84b63352e7e6aba6$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($84b63352e7e6aba6$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $84b63352e7e6aba6$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $84b63352e7e6aba6$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $84b63352e7e6aba6$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $84b63352e7e6aba6$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $84b63352e7e6aba6$var$updateReducerImpl(hook, $84b63352e7e6aba6$var$currentHook, "function" === typeof reducer ? reducer : $84b63352e7e6aba6$var$basicStateReducer);
}
function $84b63352e7e6aba6$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($84b63352e7e6aba6$var$isRenderPhaseUpdate(fiber)) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $84b63352e7e6aba6$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $84b63352e7e6aba6$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $84b63352e7e6aba6$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $84b63352e7e6aba6$var$ReactSharedInternals.T, currentTransition = {};
        $84b63352e7e6aba6$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $84b63352e7e6aba6$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $84b63352e7e6aba6$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $84b63352e7e6aba6$var$onActionError(actionQueue, node, error);
        } finally{
            $84b63352e7e6aba6$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $84b63352e7e6aba6$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$60) {
        $84b63352e7e6aba6$var$onActionError(actionQueue, node, error$60);
    }
}
function $84b63352e7e6aba6$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $84b63352e7e6aba6$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $84b63352e7e6aba6$var$onActionError(actionQueue, node, error);
    }) : $84b63352e7e6aba6$var$onActionSuccess(actionQueue, node, returnValue);
}
function $84b63352e7e6aba6$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $84b63352e7e6aba6$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $84b63352e7e6aba6$var$runActionStateAction(actionQueue, nextState)));
}
function $84b63352e7e6aba6$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $84b63352e7e6aba6$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $84b63352e7e6aba6$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $84b63352e7e6aba6$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $84b63352e7e6aba6$var$mountActionState(action, initialStateProp) {
    if ($84b63352e7e6aba6$var$isHydrating) {
        var ssrFormState = $84b63352e7e6aba6$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $84b63352e7e6aba6$var$currentlyRenderingFiber$1;
                if ($84b63352e7e6aba6$var$isHydrating) {
                    if ($84b63352e7e6aba6$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $84b63352e7e6aba6$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $84b63352e7e6aba6$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $84b63352e7e6aba6$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $84b63352e7e6aba6$var$nextHydratableInstance = $84b63352e7e6aba6$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $84b63352e7e6aba6$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $84b63352e7e6aba6$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $84b63352e7e6aba6$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $84b63352e7e6aba6$var$dispatchSetState.bind(null, $84b63352e7e6aba6$var$currentlyRenderingFiber$1, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $84b63352e7e6aba6$var$mountStateImpl(!1);
    inRootOrSingleton = $84b63352e7e6aba6$var$dispatchOptimisticSetState.bind(null, $84b63352e7e6aba6$var$currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $84b63352e7e6aba6$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $84b63352e7e6aba6$var$dispatchActionState.bind(null, $84b63352e7e6aba6$var$currentlyRenderingFiber$1, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $84b63352e7e6aba6$var$updateActionState(action) {
    var stateHook = $84b63352e7e6aba6$var$updateWorkInProgressHook();
    return $84b63352e7e6aba6$var$updateActionStateImpl(stateHook, $84b63352e7e6aba6$var$currentHook, action);
}
function $84b63352e7e6aba6$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $84b63352e7e6aba6$var$updateReducerImpl(stateHook, currentStateHook, $84b63352e7e6aba6$var$actionStateReducer)[0];
    stateHook = $84b63352e7e6aba6$var$updateReducer($84b63352e7e6aba6$var$basicStateReducer)[0];
    currentStateHook = "object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then ? $84b63352e7e6aba6$var$useThenable(currentStateHook) : currentStateHook;
    var actionQueueHook = $84b63352e7e6aba6$var$updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
    action !== actionQueueHook.memoizedState && ($84b63352e7e6aba6$var$currentlyRenderingFiber$1.flags |= 2048, $84b63352e7e6aba6$var$pushEffect(9, $84b63352e7e6aba6$var$actionStateActionEffect.bind(null, actionQueue, action), {
        destroy: void 0
    }, null));
    return [
        currentStateHook,
        dispatch,
        stateHook
    ];
}
function $84b63352e7e6aba6$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $84b63352e7e6aba6$var$rerenderActionState(action) {
    var stateHook = $84b63352e7e6aba6$var$updateWorkInProgressHook(), currentStateHook = $84b63352e7e6aba6$var$currentHook;
    if (null !== currentStateHook) return $84b63352e7e6aba6$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $84b63352e7e6aba6$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $84b63352e7e6aba6$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $84b63352e7e6aba6$var$pushEffect(tag, create, inst, deps) {
    tag = {
        tag: tag,
        create: create,
        inst: inst,
        deps: deps,
        next: null
    };
    create = $84b63352e7e6aba6$var$currentlyRenderingFiber$1.updateQueue;
    null === create && (create = $84b63352e7e6aba6$var$createFunctionComponentUpdateQueue(), $84b63352e7e6aba6$var$currentlyRenderingFiber$1.updateQueue = create);
    inst = create.lastEffect;
    null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
    return tag;
}
function $84b63352e7e6aba6$var$updateRef() {
    return $84b63352e7e6aba6$var$updateWorkInProgressHook().memoizedState;
}
function $84b63352e7e6aba6$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $84b63352e7e6aba6$var$mountWorkInProgressHook();
    $84b63352e7e6aba6$var$currentlyRenderingFiber$1.flags |= fiberFlags;
    hook.memoizedState = $84b63352e7e6aba6$var$pushEffect(1 | hookFlags, create, {
        destroy: void 0
    }, void 0 === deps ? null : deps);
}
function $84b63352e7e6aba6$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $84b63352e7e6aba6$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $84b63352e7e6aba6$var$currentHook && null !== deps && $84b63352e7e6aba6$var$areHookInputsEqual(deps, $84b63352e7e6aba6$var$currentHook.memoizedState.deps) ? hook.memoizedState = $84b63352e7e6aba6$var$pushEffect(hookFlags, create, inst, deps) : ($84b63352e7e6aba6$var$currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = $84b63352e7e6aba6$var$pushEffect(1 | hookFlags, create, inst, deps));
}
function $84b63352e7e6aba6$var$mountEffect(create, deps) {
    $84b63352e7e6aba6$var$mountEffectImpl(8390656, 8, create, deps);
}
function $84b63352e7e6aba6$var$updateEffect(create, deps) {
    $84b63352e7e6aba6$var$updateEffectImpl(2048, 8, create, deps);
}
function $84b63352e7e6aba6$var$updateInsertionEffect(create, deps) {
    return $84b63352e7e6aba6$var$updateEffectImpl(4, 2, create, deps);
}
function $84b63352e7e6aba6$var$updateLayoutEffect(create, deps) {
    return $84b63352e7e6aba6$var$updateEffectImpl(4, 4, create, deps);
}
function $84b63352e7e6aba6$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $84b63352e7e6aba6$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $84b63352e7e6aba6$var$updateEffectImpl(4, 4, $84b63352e7e6aba6$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $84b63352e7e6aba6$var$mountDebugValue() {}
function $84b63352e7e6aba6$var$updateCallback(callback, deps) {
    var hook = $84b63352e7e6aba6$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $84b63352e7e6aba6$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $84b63352e7e6aba6$var$updateMemo(nextCreate, deps) {
    var hook = $84b63352e7e6aba6$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $84b63352e7e6aba6$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($84b63352e7e6aba6$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $84b63352e7e6aba6$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $84b63352e7e6aba6$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $84b63352e7e6aba6$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($84b63352e7e6aba6$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $84b63352e7e6aba6$var$requestDeferredLane();
    $84b63352e7e6aba6$var$currentlyRenderingFiber$1.lanes |= hook;
    $84b63352e7e6aba6$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $84b63352e7e6aba6$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($84b63352e7e6aba6$var$objectIs(value, prevValue)) return value;
    if (null !== $84b63352e7e6aba6$var$currentTreeHiddenStackCursor.current) return hook = $84b63352e7e6aba6$var$mountDeferredValueImpl(hook, value, initialValue), $84b63352e7e6aba6$var$objectIs(hook, prevValue) || ($84b63352e7e6aba6$var$didReceiveUpdate = !0), hook;
    if (0 === ($84b63352e7e6aba6$var$renderLanes & 42)) return $84b63352e7e6aba6$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $84b63352e7e6aba6$var$requestDeferredLane();
    $84b63352e7e6aba6$var$currentlyRenderingFiber$1.lanes |= hook;
    $84b63352e7e6aba6$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $84b63352e7e6aba6$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $84b63352e7e6aba6$var$ReactDOMSharedInternals.p;
    $84b63352e7e6aba6$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $84b63352e7e6aba6$var$ReactSharedInternals.T, currentTransition = {};
    $84b63352e7e6aba6$var$ReactSharedInternals.T = currentTransition;
    $84b63352e7e6aba6$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $84b63352e7e6aba6$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $84b63352e7e6aba6$var$chainThenableValue(returnValue, finishedState);
            $84b63352e7e6aba6$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $84b63352e7e6aba6$var$requestUpdateLane(fiber));
        } else $84b63352e7e6aba6$var$dispatchSetStateInternal(fiber, queue, finishedState, $84b63352e7e6aba6$var$requestUpdateLane(fiber));
    } catch (error) {
        $84b63352e7e6aba6$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $84b63352e7e6aba6$var$requestUpdateLane());
    } finally{
        $84b63352e7e6aba6$var$ReactDOMSharedInternals.p = previousPriority, $84b63352e7e6aba6$var$ReactSharedInternals.T = prevTransition;
    }
}
function $84b63352e7e6aba6$var$noop$2() {}
function $84b63352e7e6aba6$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(476));
    var queue = $84b63352e7e6aba6$var$ensureFormComponentIsStateful(formFiber).queue;
    $84b63352e7e6aba6$var$startTransition(formFiber, queue, pendingState, $84b63352e7e6aba6$var$sharedNotPendingObject, null === action ? $84b63352e7e6aba6$var$noop$2 : function() {
        $84b63352e7e6aba6$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $84b63352e7e6aba6$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $84b63352e7e6aba6$var$sharedNotPendingObject,
        baseState: $84b63352e7e6aba6$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $84b63352e7e6aba6$var$basicStateReducer,
            lastRenderedState: $84b63352e7e6aba6$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $84b63352e7e6aba6$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $84b63352e7e6aba6$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $84b63352e7e6aba6$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $84b63352e7e6aba6$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $84b63352e7e6aba6$var$requestUpdateLane());
}
function $84b63352e7e6aba6$var$useHostTransitionStatus() {
    return $84b63352e7e6aba6$var$readContext($84b63352e7e6aba6$var$HostTransitionContext);
}
function $84b63352e7e6aba6$var$updateId() {
    return $84b63352e7e6aba6$var$updateWorkInProgressHook().memoizedState;
}
function $84b63352e7e6aba6$var$updateRefresh() {
    return $84b63352e7e6aba6$var$updateWorkInProgressHook().memoizedState;
}
function $84b63352e7e6aba6$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $84b63352e7e6aba6$var$requestUpdateLane();
                fiber = $84b63352e7e6aba6$var$createUpdate(lane);
                var root$63 = $84b63352e7e6aba6$var$enqueueUpdate(provider, fiber, lane);
                null !== root$63 && ($84b63352e7e6aba6$var$scheduleUpdateOnFiber(root$63, provider, lane), $84b63352e7e6aba6$var$entangleTransitions(root$63, provider, lane));
                provider = {
                    cache: $84b63352e7e6aba6$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $84b63352e7e6aba6$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $84b63352e7e6aba6$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $84b63352e7e6aba6$var$isRenderPhaseUpdate(fiber) ? $84b63352e7e6aba6$var$enqueueRenderPhaseUpdate(queue, action) : (action = $84b63352e7e6aba6$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($84b63352e7e6aba6$var$scheduleUpdateOnFiber(action, fiber, lane), $84b63352e7e6aba6$var$entangleTransitionUpdate(action, queue, lane)));
}
function $84b63352e7e6aba6$var$dispatchSetState(fiber, queue, action) {
    var lane = $84b63352e7e6aba6$var$requestUpdateLane();
    $84b63352e7e6aba6$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $84b63352e7e6aba6$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($84b63352e7e6aba6$var$isRenderPhaseUpdate(fiber)) $84b63352e7e6aba6$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($84b63352e7e6aba6$var$objectIs(eagerState, currentState)) return $84b63352e7e6aba6$var$enqueueUpdate$1(fiber, queue, update, 0), null === $84b63352e7e6aba6$var$workInProgressRoot && $84b63352e7e6aba6$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $84b63352e7e6aba6$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $84b63352e7e6aba6$var$scheduleUpdateOnFiber(action, fiber, lane), $84b63352e7e6aba6$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $84b63352e7e6aba6$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $84b63352e7e6aba6$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($84b63352e7e6aba6$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $84b63352e7e6aba6$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $84b63352e7e6aba6$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $84b63352e7e6aba6$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $84b63352e7e6aba6$var$currentlyRenderingFiber$1 || null !== alternate && alternate === $84b63352e7e6aba6$var$currentlyRenderingFiber$1;
}
function $84b63352e7e6aba6$var$enqueueRenderPhaseUpdate(queue, update) {
    $84b63352e7e6aba6$var$didScheduleRenderPhaseUpdateDuringThisPass = $84b63352e7e6aba6$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $84b63352e7e6aba6$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194176)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $84b63352e7e6aba6$var$markRootEntangled(root, lane);
    }
}
var $84b63352e7e6aba6$var$ContextOnlyDispatcher = {
    readContext: $84b63352e7e6aba6$var$readContext,
    use: $84b63352e7e6aba6$var$use,
    useCallback: $84b63352e7e6aba6$var$throwInvalidHookError,
    useContext: $84b63352e7e6aba6$var$throwInvalidHookError,
    useEffect: $84b63352e7e6aba6$var$throwInvalidHookError,
    useImperativeHandle: $84b63352e7e6aba6$var$throwInvalidHookError,
    useLayoutEffect: $84b63352e7e6aba6$var$throwInvalidHookError,
    useInsertionEffect: $84b63352e7e6aba6$var$throwInvalidHookError,
    useMemo: $84b63352e7e6aba6$var$throwInvalidHookError,
    useReducer: $84b63352e7e6aba6$var$throwInvalidHookError,
    useRef: $84b63352e7e6aba6$var$throwInvalidHookError,
    useState: $84b63352e7e6aba6$var$throwInvalidHookError,
    useDebugValue: $84b63352e7e6aba6$var$throwInvalidHookError,
    useDeferredValue: $84b63352e7e6aba6$var$throwInvalidHookError,
    useTransition: $84b63352e7e6aba6$var$throwInvalidHookError,
    useSyncExternalStore: $84b63352e7e6aba6$var$throwInvalidHookError,
    useId: $84b63352e7e6aba6$var$throwInvalidHookError
};
$84b63352e7e6aba6$var$ContextOnlyDispatcher.useCacheRefresh = $84b63352e7e6aba6$var$throwInvalidHookError;
$84b63352e7e6aba6$var$ContextOnlyDispatcher.useMemoCache = $84b63352e7e6aba6$var$throwInvalidHookError;
$84b63352e7e6aba6$var$ContextOnlyDispatcher.useHostTransitionStatus = $84b63352e7e6aba6$var$throwInvalidHookError;
$84b63352e7e6aba6$var$ContextOnlyDispatcher.useFormState = $84b63352e7e6aba6$var$throwInvalidHookError;
$84b63352e7e6aba6$var$ContextOnlyDispatcher.useActionState = $84b63352e7e6aba6$var$throwInvalidHookError;
$84b63352e7e6aba6$var$ContextOnlyDispatcher.useOptimistic = $84b63352e7e6aba6$var$throwInvalidHookError;
var $84b63352e7e6aba6$var$HooksDispatcherOnMount = {
    readContext: $84b63352e7e6aba6$var$readContext,
    use: $84b63352e7e6aba6$var$use,
    useCallback: function(callback, deps) {
        $84b63352e7e6aba6$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $84b63352e7e6aba6$var$readContext,
    useEffect: $84b63352e7e6aba6$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $84b63352e7e6aba6$var$mountEffectImpl(4194308, 4, $84b63352e7e6aba6$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $84b63352e7e6aba6$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $84b63352e7e6aba6$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $84b63352e7e6aba6$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($84b63352e7e6aba6$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $84b63352e7e6aba6$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $84b63352e7e6aba6$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $84b63352e7e6aba6$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($84b63352e7e6aba6$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $84b63352e7e6aba6$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $84b63352e7e6aba6$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $84b63352e7e6aba6$var$dispatchReducerAction.bind(null, $84b63352e7e6aba6$var$currentlyRenderingFiber$1, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $84b63352e7e6aba6$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $84b63352e7e6aba6$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $84b63352e7e6aba6$var$dispatchSetState.bind(null, $84b63352e7e6aba6$var$currentlyRenderingFiber$1, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $84b63352e7e6aba6$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $84b63352e7e6aba6$var$mountWorkInProgressHook();
        return $84b63352e7e6aba6$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $84b63352e7e6aba6$var$mountStateImpl(!1);
        stateHook = $84b63352e7e6aba6$var$startTransition.bind(null, $84b63352e7e6aba6$var$currentlyRenderingFiber$1, stateHook.queue, !0, !1);
        $84b63352e7e6aba6$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $84b63352e7e6aba6$var$currentlyRenderingFiber$1, hook = $84b63352e7e6aba6$var$mountWorkInProgressHook();
        if ($84b63352e7e6aba6$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $84b63352e7e6aba6$var$workInProgressRoot) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(349));
            0 !== ($84b63352e7e6aba6$var$workInProgressRootRenderLanes & 60) || $84b63352e7e6aba6$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $84b63352e7e6aba6$var$mountEffect($84b63352e7e6aba6$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $84b63352e7e6aba6$var$pushEffect(9, $84b63352e7e6aba6$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $84b63352e7e6aba6$var$mountWorkInProgressHook(), identifierPrefix = $84b63352e7e6aba6$var$workInProgressRoot.identifierPrefix;
        if ($84b63352e7e6aba6$var$isHydrating) {
            var JSCompiler_inline_result = $84b63352e7e6aba6$var$treeContextOverflow;
            var idWithLeadingBit = $84b63352e7e6aba6$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $84b63352e7e6aba6$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $84b63352e7e6aba6$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += ":";
        } else JSCompiler_inline_result = $84b63352e7e6aba6$var$globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
        return hook.memoizedState = identifierPrefix;
    },
    useCacheRefresh: function() {
        return $84b63352e7e6aba6$var$mountWorkInProgressHook().memoizedState = $84b63352e7e6aba6$var$refreshCache.bind(null, $84b63352e7e6aba6$var$currentlyRenderingFiber$1);
    }
};
$84b63352e7e6aba6$var$HooksDispatcherOnMount.useMemoCache = $84b63352e7e6aba6$var$useMemoCache;
$84b63352e7e6aba6$var$HooksDispatcherOnMount.useHostTransitionStatus = $84b63352e7e6aba6$var$useHostTransitionStatus;
$84b63352e7e6aba6$var$HooksDispatcherOnMount.useFormState = $84b63352e7e6aba6$var$mountActionState;
$84b63352e7e6aba6$var$HooksDispatcherOnMount.useActionState = $84b63352e7e6aba6$var$mountActionState;
$84b63352e7e6aba6$var$HooksDispatcherOnMount.useOptimistic = function(passthrough) {
    var hook = $84b63352e7e6aba6$var$mountWorkInProgressHook();
    hook.memoizedState = hook.baseState = passthrough;
    var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
    };
    hook.queue = queue;
    hook = $84b63352e7e6aba6$var$dispatchOptimisticSetState.bind(null, $84b63352e7e6aba6$var$currentlyRenderingFiber$1, !0, queue);
    queue.dispatch = hook;
    return [
        passthrough,
        hook
    ];
};
var $84b63352e7e6aba6$var$HooksDispatcherOnUpdate = {
    readContext: $84b63352e7e6aba6$var$readContext,
    use: $84b63352e7e6aba6$var$use,
    useCallback: $84b63352e7e6aba6$var$updateCallback,
    useContext: $84b63352e7e6aba6$var$readContext,
    useEffect: $84b63352e7e6aba6$var$updateEffect,
    useImperativeHandle: $84b63352e7e6aba6$var$updateImperativeHandle,
    useInsertionEffect: $84b63352e7e6aba6$var$updateInsertionEffect,
    useLayoutEffect: $84b63352e7e6aba6$var$updateLayoutEffect,
    useMemo: $84b63352e7e6aba6$var$updateMemo,
    useReducer: $84b63352e7e6aba6$var$updateReducer,
    useRef: $84b63352e7e6aba6$var$updateRef,
    useState: function() {
        return $84b63352e7e6aba6$var$updateReducer($84b63352e7e6aba6$var$basicStateReducer);
    },
    useDebugValue: $84b63352e7e6aba6$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $84b63352e7e6aba6$var$updateWorkInProgressHook();
        return $84b63352e7e6aba6$var$updateDeferredValueImpl(hook, $84b63352e7e6aba6$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $84b63352e7e6aba6$var$updateReducer($84b63352e7e6aba6$var$basicStateReducer)[0], start = $84b63352e7e6aba6$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $84b63352e7e6aba6$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $84b63352e7e6aba6$var$updateSyncExternalStore,
    useId: $84b63352e7e6aba6$var$updateId
};
$84b63352e7e6aba6$var$HooksDispatcherOnUpdate.useCacheRefresh = $84b63352e7e6aba6$var$updateRefresh;
$84b63352e7e6aba6$var$HooksDispatcherOnUpdate.useMemoCache = $84b63352e7e6aba6$var$useMemoCache;
$84b63352e7e6aba6$var$HooksDispatcherOnUpdate.useHostTransitionStatus = $84b63352e7e6aba6$var$useHostTransitionStatus;
$84b63352e7e6aba6$var$HooksDispatcherOnUpdate.useFormState = $84b63352e7e6aba6$var$updateActionState;
$84b63352e7e6aba6$var$HooksDispatcherOnUpdate.useActionState = $84b63352e7e6aba6$var$updateActionState;
$84b63352e7e6aba6$var$HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
    var hook = $84b63352e7e6aba6$var$updateWorkInProgressHook();
    return $84b63352e7e6aba6$var$updateOptimisticImpl(hook, $84b63352e7e6aba6$var$currentHook, passthrough, reducer);
};
var $84b63352e7e6aba6$var$HooksDispatcherOnRerender = {
    readContext: $84b63352e7e6aba6$var$readContext,
    use: $84b63352e7e6aba6$var$use,
    useCallback: $84b63352e7e6aba6$var$updateCallback,
    useContext: $84b63352e7e6aba6$var$readContext,
    useEffect: $84b63352e7e6aba6$var$updateEffect,
    useImperativeHandle: $84b63352e7e6aba6$var$updateImperativeHandle,
    useInsertionEffect: $84b63352e7e6aba6$var$updateInsertionEffect,
    useLayoutEffect: $84b63352e7e6aba6$var$updateLayoutEffect,
    useMemo: $84b63352e7e6aba6$var$updateMemo,
    useReducer: $84b63352e7e6aba6$var$rerenderReducer,
    useRef: $84b63352e7e6aba6$var$updateRef,
    useState: function() {
        return $84b63352e7e6aba6$var$rerenderReducer($84b63352e7e6aba6$var$basicStateReducer);
    },
    useDebugValue: $84b63352e7e6aba6$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $84b63352e7e6aba6$var$updateWorkInProgressHook();
        return null === $84b63352e7e6aba6$var$currentHook ? $84b63352e7e6aba6$var$mountDeferredValueImpl(hook, value, initialValue) : $84b63352e7e6aba6$var$updateDeferredValueImpl(hook, $84b63352e7e6aba6$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $84b63352e7e6aba6$var$rerenderReducer($84b63352e7e6aba6$var$basicStateReducer)[0], start = $84b63352e7e6aba6$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $84b63352e7e6aba6$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $84b63352e7e6aba6$var$updateSyncExternalStore,
    useId: $84b63352e7e6aba6$var$updateId
};
$84b63352e7e6aba6$var$HooksDispatcherOnRerender.useCacheRefresh = $84b63352e7e6aba6$var$updateRefresh;
$84b63352e7e6aba6$var$HooksDispatcherOnRerender.useMemoCache = $84b63352e7e6aba6$var$useMemoCache;
$84b63352e7e6aba6$var$HooksDispatcherOnRerender.useHostTransitionStatus = $84b63352e7e6aba6$var$useHostTransitionStatus;
$84b63352e7e6aba6$var$HooksDispatcherOnRerender.useFormState = $84b63352e7e6aba6$var$rerenderActionState;
$84b63352e7e6aba6$var$HooksDispatcherOnRerender.useActionState = $84b63352e7e6aba6$var$rerenderActionState;
$84b63352e7e6aba6$var$HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
    var hook = $84b63352e7e6aba6$var$updateWorkInProgressHook();
    if (null !== $84b63352e7e6aba6$var$currentHook) return $84b63352e7e6aba6$var$updateOptimisticImpl(hook, $84b63352e7e6aba6$var$currentHook, passthrough, reducer);
    hook.baseState = passthrough;
    return [
        passthrough,
        hook.queue.dispatch
    ];
};
function $84b63352e7e6aba6$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $84b63352e7e6aba6$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $84b63352e7e6aba6$var$classComponentUpdater = {
    isMounted: function(component) {
        return (component = component._reactInternals) ? $84b63352e7e6aba6$var$getNearestMountedFiber(component) === component : !1;
    },
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $84b63352e7e6aba6$var$requestUpdateLane(), update = $84b63352e7e6aba6$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $84b63352e7e6aba6$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($84b63352e7e6aba6$var$scheduleUpdateOnFiber(payload, inst, lane), $84b63352e7e6aba6$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $84b63352e7e6aba6$var$requestUpdateLane(), update = $84b63352e7e6aba6$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $84b63352e7e6aba6$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($84b63352e7e6aba6$var$scheduleUpdateOnFiber(payload, inst, lane), $84b63352e7e6aba6$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $84b63352e7e6aba6$var$requestUpdateLane(), update = $84b63352e7e6aba6$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $84b63352e7e6aba6$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($84b63352e7e6aba6$var$scheduleUpdateOnFiber(callback, inst, lane), $84b63352e7e6aba6$var$entangleTransitions(callback, inst, lane));
    }
};
function $84b63352e7e6aba6$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$84b63352e7e6aba6$var$shallowEqual(oldProps, newProps) || !$84b63352e7e6aba6$var$shallowEqual(oldState, newState) : !0;
}
function $84b63352e7e6aba6$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $84b63352e7e6aba6$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $84b63352e7e6aba6$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $84b63352e7e6aba6$var$assign({}, newProps));
        for(var propName$67 in Component)void 0 === newProps[propName$67] && (newProps[propName$67] = Component[propName$67]);
    }
    return newProps;
}
var $84b63352e7e6aba6$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $84b63352e7e6aba6$var$defaultOnUncaughtError(error) {
    $84b63352e7e6aba6$var$reportGlobalError(error);
}
function $84b63352e7e6aba6$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $84b63352e7e6aba6$var$defaultOnRecoverableError(error) {
    $84b63352e7e6aba6$var$reportGlobalError(error);
}
function $84b63352e7e6aba6$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$68) {
        setTimeout(function() {
            throw e$68;
        });
    }
}
function $84b63352e7e6aba6$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$69) {
        setTimeout(function() {
            throw e$69;
        });
    }
}
function $84b63352e7e6aba6$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $84b63352e7e6aba6$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $84b63352e7e6aba6$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $84b63352e7e6aba6$var$createClassErrorUpdate(lane) {
    lane = $84b63352e7e6aba6$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $84b63352e7e6aba6$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $84b63352e7e6aba6$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $84b63352e7e6aba6$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $84b63352e7e6aba6$var$legacyErrorBoundariesThatAlreadyFailed ? $84b63352e7e6aba6$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $84b63352e7e6aba6$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $84b63352e7e6aba6$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $84b63352e7e6aba6$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $84b63352e7e6aba6$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $84b63352e7e6aba6$var$shellBoundary ? $84b63352e7e6aba6$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $84b63352e7e6aba6$var$workInProgressRootExitStatus && ($84b63352e7e6aba6$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $84b63352e7e6aba6$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $84b63352e7e6aba6$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $84b63352e7e6aba6$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $84b63352e7e6aba6$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $84b63352e7e6aba6$var$attachPingListener(root, value, rootRenderLanes);
        $84b63352e7e6aba6$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($84b63352e7e6aba6$var$isHydrating) return returnFiber = $84b63352e7e6aba6$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $84b63352e7e6aba6$var$HydrationMismatchException && (root = Error($84b63352e7e6aba6$var$formatProdErrorMessage(422), {
        cause: value
    }), $84b63352e7e6aba6$var$queueHydrationError($84b63352e7e6aba6$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $84b63352e7e6aba6$var$HydrationMismatchException && (returnFiber = Error($84b63352e7e6aba6$var$formatProdErrorMessage(423), {
        cause: value
    }), $84b63352e7e6aba6$var$queueHydrationError($84b63352e7e6aba6$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $84b63352e7e6aba6$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $84b63352e7e6aba6$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $84b63352e7e6aba6$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $84b63352e7e6aba6$var$workInProgressRootExitStatus && ($84b63352e7e6aba6$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($84b63352e7e6aba6$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $84b63352e7e6aba6$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $84b63352e7e6aba6$var$workInProgressRootConcurrentErrors ? $84b63352e7e6aba6$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $84b63352e7e6aba6$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $84b63352e7e6aba6$var$workInProgressRootExitStatus && ($84b63352e7e6aba6$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $84b63352e7e6aba6$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $84b63352e7e6aba6$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $84b63352e7e6aba6$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $84b63352e7e6aba6$var$legacyErrorBoundariesThatAlreadyFailed || !$84b63352e7e6aba6$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $84b63352e7e6aba6$var$createClassErrorUpdate(rootRenderLanes), $84b63352e7e6aba6$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $84b63352e7e6aba6$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $84b63352e7e6aba6$var$SelectiveHydrationException = Error($84b63352e7e6aba6$var$formatProdErrorMessage(461)), $84b63352e7e6aba6$var$didReceiveUpdate = !1;
function $84b63352e7e6aba6$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $84b63352e7e6aba6$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $84b63352e7e6aba6$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $84b63352e7e6aba6$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $84b63352e7e6aba6$var$prepareToReadContext(workInProgress);
    nextProps = $84b63352e7e6aba6$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $84b63352e7e6aba6$var$checkDidRenderIdHook();
    if (null !== current && !$84b63352e7e6aba6$var$didReceiveUpdate) return $84b63352e7e6aba6$var$bailoutHooks(current, workInProgress, renderLanes), $84b63352e7e6aba6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $84b63352e7e6aba6$var$isHydrating && key && $84b63352e7e6aba6$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $84b63352e7e6aba6$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $84b63352e7e6aba6$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$84b63352e7e6aba6$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $84b63352e7e6aba6$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $84b63352e7e6aba6$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$84b63352e7e6aba6$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $84b63352e7e6aba6$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $84b63352e7e6aba6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $84b63352e7e6aba6$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $84b63352e7e6aba6$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($84b63352e7e6aba6$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($84b63352e7e6aba6$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $84b63352e7e6aba6$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($84b63352e7e6aba6$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $84b63352e7e6aba6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $84b63352e7e6aba6$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $84b63352e7e6aba6$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
    $84b63352e7e6aba6$var$markRef(current, workInProgress);
    if ("hidden" === nextProps.mode || nextIsDetached) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = nextIsDetached & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $84b63352e7e6aba6$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $84b63352e7e6aba6$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $84b63352e7e6aba6$var$pushHiddenContext(workInProgress, prevState) : $84b63352e7e6aba6$var$reuseHiddenContextOnStack(), $84b63352e7e6aba6$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $84b63352e7e6aba6$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($84b63352e7e6aba6$var$pushTransition(workInProgress, prevState.cachePool), $84b63352e7e6aba6$var$pushHiddenContext(workInProgress, prevState), $84b63352e7e6aba6$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $84b63352e7e6aba6$var$pushTransition(workInProgress, null), $84b63352e7e6aba6$var$reuseHiddenContextOnStack(), $84b63352e7e6aba6$var$reuseSuspenseHandlerOnStack(workInProgress));
    $84b63352e7e6aba6$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $84b63352e7e6aba6$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $84b63352e7e6aba6$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $84b63352e7e6aba6$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $84b63352e7e6aba6$var$pushTransition(workInProgress, null);
    $84b63352e7e6aba6$var$reuseHiddenContextOnStack();
    $84b63352e7e6aba6$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $84b63352e7e6aba6$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $84b63352e7e6aba6$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
    }
}
function $84b63352e7e6aba6$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $84b63352e7e6aba6$var$prepareToReadContext(workInProgress);
    Component = $84b63352e7e6aba6$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $84b63352e7e6aba6$var$checkDidRenderIdHook();
    if (null !== current && !$84b63352e7e6aba6$var$didReceiveUpdate) return $84b63352e7e6aba6$var$bailoutHooks(current, workInProgress, renderLanes), $84b63352e7e6aba6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $84b63352e7e6aba6$var$isHydrating && nextProps && $84b63352e7e6aba6$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $84b63352e7e6aba6$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $84b63352e7e6aba6$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $84b63352e7e6aba6$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $84b63352e7e6aba6$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $84b63352e7e6aba6$var$finishRenderingHooks(current);
    Component = $84b63352e7e6aba6$var$checkDidRenderIdHook();
    if (null !== current && !$84b63352e7e6aba6$var$didReceiveUpdate) return $84b63352e7e6aba6$var$bailoutHooks(current, workInProgress, renderLanes), $84b63352e7e6aba6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $84b63352e7e6aba6$var$isHydrating && Component && $84b63352e7e6aba6$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $84b63352e7e6aba6$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $84b63352e7e6aba6$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $84b63352e7e6aba6$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $84b63352e7e6aba6$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $84b63352e7e6aba6$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $84b63352e7e6aba6$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $84b63352e7e6aba6$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $84b63352e7e6aba6$var$readContext(contextType) : $84b63352e7e6aba6$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($84b63352e7e6aba6$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $84b63352e7e6aba6$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $84b63352e7e6aba6$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $84b63352e7e6aba6$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $84b63352e7e6aba6$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $84b63352e7e6aba6$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $84b63352e7e6aba6$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $84b63352e7e6aba6$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $84b63352e7e6aba6$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $84b63352e7e6aba6$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $84b63352e7e6aba6$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $84b63352e7e6aba6$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($84b63352e7e6aba6$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $84b63352e7e6aba6$var$hasForceUpdate || $84b63352e7e6aba6$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $84b63352e7e6aba6$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $84b63352e7e6aba6$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $84b63352e7e6aba6$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $84b63352e7e6aba6$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $84b63352e7e6aba6$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $84b63352e7e6aba6$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $84b63352e7e6aba6$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $84b63352e7e6aba6$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $84b63352e7e6aba6$var$hasForceUpdate || null !== current && null !== current.dependencies && $84b63352e7e6aba6$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($84b63352e7e6aba6$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $84b63352e7e6aba6$var$hasForceUpdate || $84b63352e7e6aba6$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $84b63352e7e6aba6$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $84b63352e7e6aba6$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $84b63352e7e6aba6$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $84b63352e7e6aba6$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $84b63352e7e6aba6$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $84b63352e7e6aba6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $84b63352e7e6aba6$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $84b63352e7e6aba6$var$resetHydrationState();
    workInProgress.flags |= 256;
    $84b63352e7e6aba6$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $84b63352e7e6aba6$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $84b63352e7e6aba6$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $84b63352e7e6aba6$var$getSuspendedCache()
    };
}
function $84b63352e7e6aba6$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $84b63352e7e6aba6$var$workInProgressDeferredLane);
    return current;
}
function $84b63352e7e6aba6$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($84b63352e7e6aba6$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($84b63352e7e6aba6$var$isHydrating) {
            showFallback ? $84b63352e7e6aba6$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $84b63352e7e6aba6$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($84b63352e7e6aba6$var$isHydrating) {
                var nextInstance = $84b63352e7e6aba6$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $84b63352e7e6aba6$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $84b63352e7e6aba6$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $84b63352e7e6aba6$var$treeContextProvider ? {
                            id: $84b63352e7e6aba6$var$treeContextId,
                            overflow: $84b63352e7e6aba6$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = $84b63352e7e6aba6$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $84b63352e7e6aba6$var$hydrationParentFiber = workInProgress, $84b63352e7e6aba6$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $84b63352e7e6aba6$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return "$!" === nextInstance.data ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
            $84b63352e7e6aba6$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $84b63352e7e6aba6$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $84b63352e7e6aba6$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $84b63352e7e6aba6$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $84b63352e7e6aba6$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $84b63352e7e6aba6$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $84b63352e7e6aba6$var$SUSPENDED_MARKER, nextProps;
        $84b63352e7e6aba6$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $84b63352e7e6aba6$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($84b63352e7e6aba6$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $84b63352e7e6aba6$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($84b63352e7e6aba6$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($84b63352e7e6aba6$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $84b63352e7e6aba6$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $84b63352e7e6aba6$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $84b63352e7e6aba6$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $84b63352e7e6aba6$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $84b63352e7e6aba6$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $84b63352e7e6aba6$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($84b63352e7e6aba6$var$pushPrimaryTreeSuspenseHandler(workInProgress), "$!" === nextInstance.data) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($84b63352e7e6aba6$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $84b63352e7e6aba6$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $84b63352e7e6aba6$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($84b63352e7e6aba6$var$didReceiveUpdate || $84b63352e7e6aba6$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $84b63352e7e6aba6$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $84b63352e7e6aba6$var$workInProgressRoot;
            if (null !== JSCompiler_temp) {
                nextProps = renderLanes & -renderLanes;
                if (0 !== (nextProps & 42)) nextProps = 1;
                else switch(nextProps){
                    case 2:
                        nextProps = 1;
                        break;
                    case 8:
                        nextProps = 4;
                        break;
                    case 32:
                        nextProps = 16;
                        break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        nextProps = 64;
                        break;
                    case 268435456:
                        nextProps = 134217728;
                        break;
                    default:
                        nextProps = 0;
                }
                nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $84b63352e7e6aba6$var$enqueueConcurrentRenderForLane(current, nextProps), $84b63352e7e6aba6$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $84b63352e7e6aba6$var$SelectiveHydrationException;
            }
            "$?" === nextInstance.data || $84b63352e7e6aba6$var$renderDidSuspendDelayIfPossible();
            workInProgress = $84b63352e7e6aba6$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = $84b63352e7e6aba6$var$retryDehydratedSuspenseBoundary.bind(null, current), nextInstance._reactRetry = workInProgress, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $84b63352e7e6aba6$var$nextHydratableInstance = $84b63352e7e6aba6$var$getNextHydratable(nextInstance.nextSibling), $84b63352e7e6aba6$var$hydrationParentFiber = workInProgress, $84b63352e7e6aba6$var$isHydrating = !0, $84b63352e7e6aba6$var$hydrationErrors = null, $84b63352e7e6aba6$var$rootOrSingletonContext = !1, null !== current && ($84b63352e7e6aba6$var$idStack[$84b63352e7e6aba6$var$idStackIndex++] = $84b63352e7e6aba6$var$treeContextId, $84b63352e7e6aba6$var$idStack[$84b63352e7e6aba6$var$idStackIndex++] = $84b63352e7e6aba6$var$treeContextOverflow, $84b63352e7e6aba6$var$idStack[$84b63352e7e6aba6$var$idStackIndex++] = $84b63352e7e6aba6$var$treeContextProvider, $84b63352e7e6aba6$var$treeContextId = current.id, $84b63352e7e6aba6$var$treeContextOverflow = current.overflow, $84b63352e7e6aba6$var$treeContextProvider = workInProgress), workInProgress = $84b63352e7e6aba6$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $84b63352e7e6aba6$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $84b63352e7e6aba6$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== digest ? showFallback = $84b63352e7e6aba6$var$createWorkInProgress(digest, showFallback) : (showFallback = $84b63352e7e6aba6$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $84b63352e7e6aba6$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $84b63352e7e6aba6$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $84b63352e7e6aba6$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $84b63352e7e6aba6$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $84b63352e7e6aba6$var$SUSPENDED_MARKER, nextProps;
    $84b63352e7e6aba6$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $84b63352e7e6aba6$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $84b63352e7e6aba6$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $84b63352e7e6aba6$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $84b63352e7e6aba6$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    return $84b63352e7e6aba6$var$createFiberFromOffscreen(offscreenProps, mode, 0, null);
}
function $84b63352e7e6aba6$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $84b63352e7e6aba6$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $84b63352e7e6aba6$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $84b63352e7e6aba6$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $84b63352e7e6aba6$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $84b63352e7e6aba6$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $84b63352e7e6aba6$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $84b63352e7e6aba6$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $84b63352e7e6aba6$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $84b63352e7e6aba6$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $84b63352e7e6aba6$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $84b63352e7e6aba6$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $84b63352e7e6aba6$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $84b63352e7e6aba6$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $84b63352e7e6aba6$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $84b63352e7e6aba6$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $84b63352e7e6aba6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $84b63352e7e6aba6$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($84b63352e7e6aba6$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $84b63352e7e6aba6$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $84b63352e7e6aba6$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $84b63352e7e6aba6$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $84b63352e7e6aba6$var$checkIfContextChanged(current) ? !0 : !1;
}
function $84b63352e7e6aba6$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $84b63352e7e6aba6$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $84b63352e7e6aba6$var$pushProvider(workInProgress, $84b63352e7e6aba6$var$CacheContext, current.memoizedState.cache);
            $84b63352e7e6aba6$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $84b63352e7e6aba6$var$pushHostContext(workInProgress);
            break;
        case 4:
            $84b63352e7e6aba6$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $84b63352e7e6aba6$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $84b63352e7e6aba6$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $84b63352e7e6aba6$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $84b63352e7e6aba6$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $84b63352e7e6aba6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $84b63352e7e6aba6$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($84b63352e7e6aba6$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $84b63352e7e6aba6$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$suspenseStackCursor, $84b63352e7e6aba6$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $84b63352e7e6aba6$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $84b63352e7e6aba6$var$pushProvider(workInProgress, $84b63352e7e6aba6$var$CacheContext, current.memoizedState.cache);
    }
    return $84b63352e7e6aba6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $84b63352e7e6aba6$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $84b63352e7e6aba6$var$didReceiveUpdate = !0;
        else {
            if (!$84b63352e7e6aba6$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $84b63352e7e6aba6$var$didReceiveUpdate = !1, $84b63352e7e6aba6$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $84b63352e7e6aba6$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $84b63352e7e6aba6$var$didReceiveUpdate = !1, $84b63352e7e6aba6$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $84b63352e7e6aba6$var$pushTreeId(workInProgress, $84b63352e7e6aba6$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $84b63352e7e6aba6$var$shouldConstruct(lazyComponent) ? (current = $84b63352e7e6aba6$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $84b63352e7e6aba6$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $84b63352e7e6aba6$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $84b63352e7e6aba6$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $84b63352e7e6aba6$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $84b63352e7e6aba6$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $84b63352e7e6aba6$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $84b63352e7e6aba6$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $84b63352e7e6aba6$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $84b63352e7e6aba6$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $84b63352e7e6aba6$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $84b63352e7e6aba6$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(387));
                var nextProps = workInProgress.pendingProps;
                init = workInProgress.memoizedState;
                lazyComponent = init.element;
                $84b63352e7e6aba6$var$cloneUpdateQueue(current, workInProgress);
                $84b63352e7e6aba6$var$processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                nextProps = nextState.cache;
                $84b63352e7e6aba6$var$pushProvider(workInProgress, $84b63352e7e6aba6$var$CacheContext, nextProps);
                nextProps !== init.cache && $84b63352e7e6aba6$var$propagateContextChanges(workInProgress, [
                    $84b63352e7e6aba6$var$CacheContext
                ], renderLanes, !0);
                $84b63352e7e6aba6$var$suspendIfUpdateReadFromEntangledAsyncAction();
                nextProps = nextState.element;
                if (init.isDehydrated) {
                    if (init = {
                        element: nextProps,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                        workInProgress = $84b63352e7e6aba6$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else if (nextProps !== lazyComponent) {
                        lazyComponent = $84b63352e7e6aba6$var$createCapturedValueAtFiber(Error($84b63352e7e6aba6$var$formatProdErrorMessage(424)), workInProgress);
                        $84b63352e7e6aba6$var$queueHydrationError(lazyComponent);
                        workInProgress = $84b63352e7e6aba6$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else for($84b63352e7e6aba6$var$nextHydratableInstance = $84b63352e7e6aba6$var$getNextHydratable(workInProgress.stateNode.containerInfo.firstChild), $84b63352e7e6aba6$var$hydrationParentFiber = workInProgress, $84b63352e7e6aba6$var$isHydrating = !0, $84b63352e7e6aba6$var$hydrationErrors = null, $84b63352e7e6aba6$var$rootOrSingletonContext = !0, renderLanes = $84b63352e7e6aba6$var$mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                } else {
                    $84b63352e7e6aba6$var$resetHydrationState();
                    if (nextProps === lazyComponent) {
                        workInProgress = $84b63352e7e6aba6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $84b63352e7e6aba6$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $84b63352e7e6aba6$var$markRef(current, workInProgress), null === current ? (renderLanes = $84b63352e7e6aba6$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $84b63352e7e6aba6$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $84b63352e7e6aba6$var$getOwnerDocumentFromRootContainer($84b63352e7e6aba6$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$84b63352e7e6aba6$var$internalInstanceKey] = workInProgress, lazyComponent[$84b63352e7e6aba6$var$internalPropsKey] = current, $84b63352e7e6aba6$var$setInitialProperties(lazyComponent, renderLanes, current), $84b63352e7e6aba6$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $84b63352e7e6aba6$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $84b63352e7e6aba6$var$pushHostContext(workInProgress), null === current && $84b63352e7e6aba6$var$isHydrating && (lazyComponent = workInProgress.stateNode = $84b63352e7e6aba6$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $84b63352e7e6aba6$var$rootInstanceStackCursor.current), $84b63352e7e6aba6$var$hydrationParentFiber = workInProgress, $84b63352e7e6aba6$var$rootOrSingletonContext = !0, $84b63352e7e6aba6$var$nextHydratableInstance = $84b63352e7e6aba6$var$getNextHydratable(lazyComponent.firstChild)), lazyComponent = workInProgress.pendingProps.children, null !== current || $84b63352e7e6aba6$var$isHydrating ? $84b63352e7e6aba6$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = $84b63352e7e6aba6$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), $84b63352e7e6aba6$var$markRef(current, workInProgress), workInProgress.child;
        case 5:
            if (null === current && $84b63352e7e6aba6$var$isHydrating) {
                if (init = lazyComponent = $84b63352e7e6aba6$var$nextHydratableInstance) lazyComponent = $84b63352e7e6aba6$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $84b63352e7e6aba6$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $84b63352e7e6aba6$var$hydrationParentFiber = workInProgress, $84b63352e7e6aba6$var$nextHydratableInstance = $84b63352e7e6aba6$var$getNextHydratable(lazyComponent.firstChild), $84b63352e7e6aba6$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $84b63352e7e6aba6$var$throwOnHydrationMismatch(workInProgress);
            }
            $84b63352e7e6aba6$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            nextProps = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = nextProps.children;
            $84b63352e7e6aba6$var$shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && $84b63352e7e6aba6$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $84b63352e7e6aba6$var$renderWithHooks(current, workInProgress, $84b63352e7e6aba6$var$TransitionAwareHostComponent, null, null, renderLanes), $84b63352e7e6aba6$var$HostTransitionContext._currentValue = init);
            $84b63352e7e6aba6$var$markRef(current, workInProgress);
            $84b63352e7e6aba6$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $84b63352e7e6aba6$var$isHydrating) {
                if (current = renderLanes = $84b63352e7e6aba6$var$nextHydratableInstance) renderLanes = $84b63352e7e6aba6$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $84b63352e7e6aba6$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $84b63352e7e6aba6$var$hydrationParentFiber = workInProgress, $84b63352e7e6aba6$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $84b63352e7e6aba6$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $84b63352e7e6aba6$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $84b63352e7e6aba6$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $84b63352e7e6aba6$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $84b63352e7e6aba6$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $84b63352e7e6aba6$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $84b63352e7e6aba6$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $84b63352e7e6aba6$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $84b63352e7e6aba6$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $84b63352e7e6aba6$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $84b63352e7e6aba6$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $84b63352e7e6aba6$var$prepareToReadContext(workInProgress), init = $84b63352e7e6aba6$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $84b63352e7e6aba6$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $84b63352e7e6aba6$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $84b63352e7e6aba6$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $84b63352e7e6aba6$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 22:
            return $84b63352e7e6aba6$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $84b63352e7e6aba6$var$prepareToReadContext(workInProgress), lazyComponent = $84b63352e7e6aba6$var$readContext($84b63352e7e6aba6$var$CacheContext), null === current ? (init = $84b63352e7e6aba6$var$peekCacheFromPool(), null === init && (init = $84b63352e7e6aba6$var$workInProgressRoot, nextProps = $84b63352e7e6aba6$var$createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $84b63352e7e6aba6$var$initializeUpdateQueue(workInProgress), $84b63352e7e6aba6$var$pushProvider(workInProgress, $84b63352e7e6aba6$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($84b63352e7e6aba6$var$cloneUpdateQueue(current, workInProgress), $84b63352e7e6aba6$var$processUpdateQueue(workInProgress, null, null, renderLanes), $84b63352e7e6aba6$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $84b63352e7e6aba6$var$pushProvider(workInProgress, $84b63352e7e6aba6$var$CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, $84b63352e7e6aba6$var$pushProvider(workInProgress, $84b63352e7e6aba6$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $84b63352e7e6aba6$var$propagateContextChanges(workInProgress, [
                $84b63352e7e6aba6$var$CacheContext
            ], renderLanes, !0))), $84b63352e7e6aba6$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(156, workInProgress.tag));
}
var $84b63352e7e6aba6$var$valueCursor = $84b63352e7e6aba6$var$createCursor(null), $84b63352e7e6aba6$var$currentlyRenderingFiber = null, $84b63352e7e6aba6$var$lastContextDependency = null;
function $84b63352e7e6aba6$var$pushProvider(providerFiber, context, nextValue) {
    $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $84b63352e7e6aba6$var$popProvider(context) {
    context._currentValue = $84b63352e7e6aba6$var$valueCursor.current;
    $84b63352e7e6aba6$var$pop($84b63352e7e6aba6$var$valueCursor);
}
function $84b63352e7e6aba6$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $84b63352e7e6aba6$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $84b63352e7e6aba6$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $84b63352e7e6aba6$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $84b63352e7e6aba6$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $84b63352e7e6aba6$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $84b63352e7e6aba6$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($84b63352e7e6aba6$var$HostTransitionContext) : current = [
                $84b63352e7e6aba6$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $84b63352e7e6aba6$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $84b63352e7e6aba6$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$84b63352e7e6aba6$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $84b63352e7e6aba6$var$prepareToReadContext(workInProgress) {
    $84b63352e7e6aba6$var$currentlyRenderingFiber = workInProgress;
    $84b63352e7e6aba6$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $84b63352e7e6aba6$var$readContext(context) {
    return $84b63352e7e6aba6$var$readContextForConsumer($84b63352e7e6aba6$var$currentlyRenderingFiber, context);
}
function $84b63352e7e6aba6$var$readContextDuringReconciliation(consumer, context) {
    null === $84b63352e7e6aba6$var$currentlyRenderingFiber && $84b63352e7e6aba6$var$prepareToReadContext(consumer);
    return $84b63352e7e6aba6$var$readContextForConsumer(consumer, context);
}
function $84b63352e7e6aba6$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $84b63352e7e6aba6$var$lastContextDependency) {
        if (null === consumer) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(308));
        $84b63352e7e6aba6$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $84b63352e7e6aba6$var$lastContextDependency = $84b63352e7e6aba6$var$lastContextDependency.next = context;
    return value;
}
var $84b63352e7e6aba6$var$hasForceUpdate = !1;
function $84b63352e7e6aba6$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $84b63352e7e6aba6$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $84b63352e7e6aba6$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $84b63352e7e6aba6$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($84b63352e7e6aba6$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $84b63352e7e6aba6$var$getRootForUpdatedFiber(fiber);
        $84b63352e7e6aba6$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $84b63352e7e6aba6$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $84b63352e7e6aba6$var$getRootForUpdatedFiber(fiber);
}
function $84b63352e7e6aba6$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $84b63352e7e6aba6$var$markRootEntangled(root, lane);
    }
}
function $84b63352e7e6aba6$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $84b63352e7e6aba6$var$didReadFromEntangledAsyncAction = !1;
function $84b63352e7e6aba6$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($84b63352e7e6aba6$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $84b63352e7e6aba6$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $84b63352e7e6aba6$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $84b63352e7e6aba6$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $84b63352e7e6aba6$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($84b63352e7e6aba6$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $84b63352e7e6aba6$var$currentEntangledLane && ($84b63352e7e6aba6$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $84b63352e7e6aba6$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $84b63352e7e6aba6$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $84b63352e7e6aba6$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $84b63352e7e6aba6$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $84b63352e7e6aba6$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$84b63352e7e6aba6$var$callCallback(callbacks[updateQueue], context);
}
function $84b63352e7e6aba6$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $84b63352e7e6aba6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $84b63352e7e6aba6$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                        try {
                            destroy();
                        } catch (error) {
                            $84b63352e7e6aba6$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $84b63352e7e6aba6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $84b63352e7e6aba6$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $84b63352e7e6aba6$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $84b63352e7e6aba6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $84b63352e7e6aba6$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $84b63352e7e6aba6$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $84b63352e7e6aba6$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $84b63352e7e6aba6$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            var instance = current.stateNode;
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = instance;
                    break;
                default:
                    instanceToUse = instance;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $84b63352e7e6aba6$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $84b63352e7e6aba6$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $84b63352e7e6aba6$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$112) {
            $84b63352e7e6aba6$var$captureCommitPhaseError(current, nearestMountedAncestor, error$112);
        }
        else ref.current = null;
    }
}
function $84b63352e7e6aba6$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $84b63352e7e6aba6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $84b63352e7e6aba6$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $84b63352e7e6aba6$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$84b63352e7e6aba6$var$internalPropsKey] = newProps;
    } catch (error) {
        $84b63352e7e6aba6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $84b63352e7e6aba6$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag || 4 === fiber.tag;
}
function $84b63352e7e6aba6$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $84b63352e7e6aba6$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 27 !== fiber.tag && 18 !== fiber.tag;){
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $84b63352e7e6aba6$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? 8 === parent.nodeType ? parent.parentNode.insertBefore(node, before) : parent.insertBefore(node, before) : (8 === parent.nodeType ? (before = parent.parentNode, before.insertBefore(node, parent)) : (before = parent, before.appendChild(node)), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $84b63352e7e6aba6$var$noop$1));
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($84b63352e7e6aba6$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$84b63352e7e6aba6$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $84b63352e7e6aba6$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($84b63352e7e6aba6$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$84b63352e7e6aba6$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
var $84b63352e7e6aba6$var$offscreenSubtreeIsHidden = !1, $84b63352e7e6aba6$var$offscreenSubtreeWasHidden = !1, $84b63352e7e6aba6$var$needsFormReset = !1, $84b63352e7e6aba6$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $84b63352e7e6aba6$var$nextEffect = null, $84b63352e7e6aba6$var$shouldFireAfterActiveInstanceBlur = !1;
function $84b63352e7e6aba6$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $84b63352e7e6aba6$var$eventsEnabled = $84b63352e7e6aba6$var$_enabled;
    root = $84b63352e7e6aba6$var$getActiveElementDeep(root);
    if ($84b63352e7e6aba6$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $84b63352e7e6aba6$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $84b63352e7e6aba6$var$_enabled = !1;
    for($84b63352e7e6aba6$var$nextEffect = firstChild; null !== $84b63352e7e6aba6$var$nextEffect;)if (firstChild = $84b63352e7e6aba6$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $84b63352e7e6aba6$var$nextEffect = root;
    else for(; null !== $84b63352e7e6aba6$var$nextEffect;){
        firstChild = $84b63352e7e6aba6$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $84b63352e7e6aba6$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $84b63352e7e6aba6$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $84b63352e7e6aba6$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $84b63352e7e6aba6$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $84b63352e7e6aba6$var$nextEffect = root;
            break;
        }
        $84b63352e7e6aba6$var$nextEffect = firstChild.return;
    }
    resolvedPrevProps = $84b63352e7e6aba6$var$shouldFireAfterActiveInstanceBlur;
    $84b63352e7e6aba6$var$shouldFireAfterActiveInstanceBlur = !1;
    return resolvedPrevProps;
}
function $84b63352e7e6aba6$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $84b63352e7e6aba6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $84b63352e7e6aba6$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $84b63352e7e6aba6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $84b63352e7e6aba6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $84b63352e7e6aba6$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$111) {
                        $84b63352e7e6aba6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$111);
                    }
                }
            }
            flags & 64 && $84b63352e7e6aba6$var$commitClassCallbacks(finishedWork);
            flags & 512 && $84b63352e7e6aba6$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $84b63352e7e6aba6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                finishedRoot = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        finishedRoot = finishedWork.child.stateNode;
                        break;
                    case 1:
                        finishedRoot = finishedWork.child.stateNode;
                }
                try {
                    $84b63352e7e6aba6$var$commitCallbacks(flags, finishedRoot);
                } catch (error) {
                    $84b63352e7e6aba6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 26:
            $84b63352e7e6aba6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $84b63352e7e6aba6$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 27:
        case 5:
            $84b63352e7e6aba6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $84b63352e7e6aba6$var$commitHostMount(finishedWork);
            flags & 512 && $84b63352e7e6aba6$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $84b63352e7e6aba6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $84b63352e7e6aba6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $84b63352e7e6aba6$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 22:
            prevProps = null !== finishedWork.memoizedState || $84b63352e7e6aba6$var$offscreenSubtreeIsHidden;
            if (!prevProps) {
                current = null !== current && null !== current.memoizedState || $84b63352e7e6aba6$var$offscreenSubtreeWasHidden;
                var prevOffscreenSubtreeIsHidden = $84b63352e7e6aba6$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $84b63352e7e6aba6$var$offscreenSubtreeWasHidden;
                $84b63352e7e6aba6$var$offscreenSubtreeIsHidden = prevProps;
                ($84b63352e7e6aba6$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $84b63352e7e6aba6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $84b63352e7e6aba6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $84b63352e7e6aba6$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                $84b63352e7e6aba6$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? $84b63352e7e6aba6$var$safelyAttachRef(finishedWork, finishedWork.return) : $84b63352e7e6aba6$var$safelyDetachRef(finishedWork, finishedWork.return));
            break;
        default:
            $84b63352e7e6aba6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $84b63352e7e6aba6$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $84b63352e7e6aba6$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $84b63352e7e6aba6$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $84b63352e7e6aba6$var$hostParent = null, $84b63352e7e6aba6$var$hostParentIsContainer = !1;
function $84b63352e7e6aba6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$84b63352e7e6aba6$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $84b63352e7e6aba6$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($84b63352e7e6aba6$var$injectedHook && "function" === typeof $84b63352e7e6aba6$var$injectedHook.onCommitFiberUnmount) try {
        $84b63352e7e6aba6$var$injectedHook.onCommitFiberUnmount($84b63352e7e6aba6$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $84b63352e7e6aba6$var$offscreenSubtreeWasHidden || $84b63352e7e6aba6$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $84b63352e7e6aba6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $84b63352e7e6aba6$var$offscreenSubtreeWasHidden || $84b63352e7e6aba6$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $84b63352e7e6aba6$var$hostParent, prevHostParentIsContainer = $84b63352e7e6aba6$var$hostParentIsContainer;
            $84b63352e7e6aba6$var$hostParent = deletedFiber.stateNode;
            $84b63352e7e6aba6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber = deletedFiber.stateNode;
            for(nearestMountedAncestor = deletedFiber.attributes; nearestMountedAncestor.length;)deletedFiber.removeAttributeNode(nearestMountedAncestor[0]);
            $84b63352e7e6aba6$var$detachDeletedInstance(deletedFiber);
            $84b63352e7e6aba6$var$hostParent = prevHostParent;
            $84b63352e7e6aba6$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $84b63352e7e6aba6$var$offscreenSubtreeWasHidden || $84b63352e7e6aba6$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParentIsContainer = $84b63352e7e6aba6$var$hostParent;
            var prevHostParentIsContainer$119 = $84b63352e7e6aba6$var$hostParentIsContainer;
            $84b63352e7e6aba6$var$hostParent = null;
            $84b63352e7e6aba6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $84b63352e7e6aba6$var$hostParent = prevHostParentIsContainer;
            $84b63352e7e6aba6$var$hostParentIsContainer = prevHostParentIsContainer$119;
            if (null !== $84b63352e7e6aba6$var$hostParent) {
                if ($84b63352e7e6aba6$var$hostParentIsContainer) try {
                    finishedRoot = $84b63352e7e6aba6$var$hostParent, prevHostParent = deletedFiber.stateNode, 8 === finishedRoot.nodeType ? finishedRoot.parentNode.removeChild(prevHostParent) : finishedRoot.removeChild(prevHostParent);
                } catch (error) {
                    $84b63352e7e6aba6$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $84b63352e7e6aba6$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $84b63352e7e6aba6$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $84b63352e7e6aba6$var$hostParent && ($84b63352e7e6aba6$var$hostParentIsContainer ? (nearestMountedAncestor = $84b63352e7e6aba6$var$hostParent, deletedFiber = deletedFiber.stateNode, 8 === nearestMountedAncestor.nodeType ? $84b63352e7e6aba6$var$clearSuspenseBoundary(nearestMountedAncestor.parentNode, deletedFiber) : 1 === nearestMountedAncestor.nodeType && $84b63352e7e6aba6$var$clearSuspenseBoundary(nearestMountedAncestor, deletedFiber), $84b63352e7e6aba6$var$retryIfBlockedOn(nearestMountedAncestor)) : $84b63352e7e6aba6$var$clearSuspenseBoundary($84b63352e7e6aba6$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $84b63352e7e6aba6$var$hostParent;
            prevHostParentIsContainer = $84b63352e7e6aba6$var$hostParentIsContainer;
            $84b63352e7e6aba6$var$hostParent = deletedFiber.stateNode.containerInfo;
            $84b63352e7e6aba6$var$hostParentIsContainer = !0;
            $84b63352e7e6aba6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $84b63352e7e6aba6$var$hostParent = prevHostParent;
            $84b63352e7e6aba6$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $84b63352e7e6aba6$var$offscreenSubtreeWasHidden || $84b63352e7e6aba6$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $84b63352e7e6aba6$var$offscreenSubtreeWasHidden || $84b63352e7e6aba6$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $84b63352e7e6aba6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $84b63352e7e6aba6$var$offscreenSubtreeWasHidden || ($84b63352e7e6aba6$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $84b63352e7e6aba6$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $84b63352e7e6aba6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $84b63352e7e6aba6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $84b63352e7e6aba6$var$offscreenSubtreeWasHidden || $84b63352e7e6aba6$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $84b63352e7e6aba6$var$offscreenSubtreeWasHidden = (prevHostParent = $84b63352e7e6aba6$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $84b63352e7e6aba6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $84b63352e7e6aba6$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $84b63352e7e6aba6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $84b63352e7e6aba6$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $84b63352e7e6aba6$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $84b63352e7e6aba6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $84b63352e7e6aba6$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $84b63352e7e6aba6$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $84b63352e7e6aba6$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $84b63352e7e6aba6$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $84b63352e7e6aba6$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $84b63352e7e6aba6$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $84b63352e7e6aba6$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                case 5:
                    $84b63352e7e6aba6$var$hostParent = parent.stateNode;
                    $84b63352e7e6aba6$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                    $84b63352e7e6aba6$var$hostParent = parent.stateNode.containerInfo;
                    $84b63352e7e6aba6$var$hostParentIsContainer = !0;
                    break a;
                case 4:
                    $84b63352e7e6aba6$var$hostParent = parent.stateNode.containerInfo;
                    $84b63352e7e6aba6$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $84b63352e7e6aba6$var$hostParent) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(160));
        $84b63352e7e6aba6$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $84b63352e7e6aba6$var$hostParent = null;
        $84b63352e7e6aba6$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$84b63352e7e6aba6$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $84b63352e7e6aba6$var$currentHoistableRoot = null;
function $84b63352e7e6aba6$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $84b63352e7e6aba6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $84b63352e7e6aba6$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($84b63352e7e6aba6$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $84b63352e7e6aba6$var$commitHookEffectListMount(3, finishedWork), $84b63352e7e6aba6$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $84b63352e7e6aba6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $84b63352e7e6aba6$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($84b63352e7e6aba6$var$offscreenSubtreeWasHidden || null === current || $84b63352e7e6aba6$var$safelyDetachRef(current, current.return));
            flags & 64 && $84b63352e7e6aba6$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $84b63352e7e6aba6$var$currentHoistableRoot;
            $84b63352e7e6aba6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $84b63352e7e6aba6$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($84b63352e7e6aba6$var$offscreenSubtreeWasHidden || null === current || $84b63352e7e6aba6$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$84b63352e7e6aba6$var$internalHoistableMarker] || currentResource[$84b63352e7e6aba6$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $84b63352e7e6aba6$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$84b63352e7e6aba6$var$internalInstanceKey] = finishedWork;
                                        $84b63352e7e6aba6$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $84b63352e7e6aba6$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $84b63352e7e6aba6$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $84b63352e7e6aba6$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $84b63352e7e6aba6$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$84b63352e7e6aba6$var$internalInstanceKey] = finishedWork;
                                $84b63352e7e6aba6$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $84b63352e7e6aba6$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $84b63352e7e6aba6$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $84b63352e7e6aba6$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $84b63352e7e6aba6$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $84b63352e7e6aba6$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            if (flags & 4 && null === finishedWork.alternate) {
                hoistableRoot = finishedWork.stateNode;
                currentResource = finishedWork.memoizedProps;
                try {
                    for(var node = hoistableRoot.firstChild; node;){
                        var nextNode = node.nextSibling, nodeName = node.nodeName;
                        node[$84b63352e7e6aba6$var$internalHoistableMarker] || "HEAD" === nodeName || "BODY" === nodeName || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node.rel.toLowerCase() || hoistableRoot.removeChild(node);
                        node = nextNode;
                    }
                    for(var type = finishedWork.type, attributes = hoistableRoot.attributes; attributes.length;)hoistableRoot.removeAttributeNode(attributes[0]);
                    $84b63352e7e6aba6$var$setInitialProperties(hoistableRoot, type, currentResource);
                    hoistableRoot[$84b63352e7e6aba6$var$internalInstanceKey] = finishedWork;
                    hoistableRoot[$84b63352e7e6aba6$var$internalPropsKey] = currentResource;
                } catch (error) {
                    $84b63352e7e6aba6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
        case 5:
            $84b63352e7e6aba6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $84b63352e7e6aba6$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($84b63352e7e6aba6$var$offscreenSubtreeWasHidden || null === current || $84b63352e7e6aba6$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $84b63352e7e6aba6$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $84b63352e7e6aba6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $84b63352e7e6aba6$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($84b63352e7e6aba6$var$needsFormReset = !0);
            break;
        case 6:
            $84b63352e7e6aba6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $84b63352e7e6aba6$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $84b63352e7e6aba6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $84b63352e7e6aba6$var$tagCaches = null;
            hoistableRoot = $84b63352e7e6aba6$var$currentHoistableRoot;
            $84b63352e7e6aba6$var$currentHoistableRoot = $84b63352e7e6aba6$var$getHoistableRoot(root.containerInfo);
            $84b63352e7e6aba6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $84b63352e7e6aba6$var$currentHoistableRoot = hoistableRoot;
            $84b63352e7e6aba6$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $84b63352e7e6aba6$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $84b63352e7e6aba6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $84b63352e7e6aba6$var$needsFormReset && ($84b63352e7e6aba6$var$needsFormReset = !1, $84b63352e7e6aba6$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $84b63352e7e6aba6$var$currentHoistableRoot;
            $84b63352e7e6aba6$var$currentHoistableRoot = $84b63352e7e6aba6$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $84b63352e7e6aba6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $84b63352e7e6aba6$var$commitReconciliationEffects(finishedWork);
            $84b63352e7e6aba6$var$currentHoistableRoot = flags;
            break;
        case 12:
            $84b63352e7e6aba6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $84b63352e7e6aba6$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $84b63352e7e6aba6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $84b63352e7e6aba6$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($84b63352e7e6aba6$var$globalMostRecentFallbackTime = $84b63352e7e6aba6$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $84b63352e7e6aba6$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            flags & 512 && ($84b63352e7e6aba6$var$offscreenSubtreeWasHidden || null === current || $84b63352e7e6aba6$var$safelyDetachRef(current, current.return));
            node = null !== finishedWork.memoizedState;
            nextNode = null !== current && null !== current.memoizedState;
            nodeName = $84b63352e7e6aba6$var$offscreenSubtreeIsHidden;
            type = $84b63352e7e6aba6$var$offscreenSubtreeWasHidden;
            $84b63352e7e6aba6$var$offscreenSubtreeIsHidden = nodeName || node;
            $84b63352e7e6aba6$var$offscreenSubtreeWasHidden = type || nextNode;
            $84b63352e7e6aba6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $84b63352e7e6aba6$var$offscreenSubtreeWasHidden = type;
            $84b63352e7e6aba6$var$offscreenSubtreeIsHidden = nodeName;
            $84b63352e7e6aba6$var$commitReconciliationEffects(finishedWork);
            root = finishedWork.stateNode;
            root._current = finishedWork;
            root._visibility &= -3;
            root._visibility |= root._pendingVisibility & 2;
            if (flags & 8192 && (root._visibility = node ? root._visibility & -2 : root._visibility | 1, node && (root = $84b63352e7e6aba6$var$offscreenSubtreeIsHidden || $84b63352e7e6aba6$var$offscreenSubtreeWasHidden, null === current || nextNode || root || $84b63352e7e6aba6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode)) a: for(current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag || 27 === root.tag) {
                    if (null === current) {
                        nextNode = current = root;
                        try {
                            if (hoistableRoot = nextNode.stateNode, node) currentResource = hoistableRoot.style, "function" === typeof currentResource.setProperty ? currentResource.setProperty("display", "none", "important") : currentResource.display = "none";
                            else {
                                maybeNodes = nextNode.stateNode;
                                i = nextNode.memoizedProps.style;
                                var display = void 0 !== i && null !== i && i.hasOwnProperty("display") ? i.display : null;
                                maybeNodes.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $84b63352e7e6aba6$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        nextNode = root;
                        try {
                            nextNode.stateNode.nodeValue = node ? "" : nextNode.memoizedProps;
                        } catch (error) {
                            $84b63352e7e6aba6$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $84b63352e7e6aba6$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $84b63352e7e6aba6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $84b63352e7e6aba6$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $84b63352e7e6aba6$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 21:
            break;
        default:
            $84b63352e7e6aba6$var$recursivelyTraverseMutationEffects(root, finishedWork), $84b63352e7e6aba6$var$commitReconciliationEffects(finishedWork);
    }
}
function $84b63352e7e6aba6$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            if (27 !== finishedWork.tag) {
                a: {
                    for(var parent = finishedWork.return; null !== parent;){
                        if ($84b63352e7e6aba6$var$isHostParent(parent)) {
                            var JSCompiler_inline_result = parent;
                            break a;
                        }
                        parent = parent.return;
                    }
                    throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(160));
                }
                switch(JSCompiler_inline_result.tag){
                    case 27:
                        var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = $84b63352e7e6aba6$var$getHostSibling(finishedWork);
                        $84b63352e7e6aba6$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                        break;
                    case 5:
                        var parent$113 = JSCompiler_inline_result.stateNode;
                        JSCompiler_inline_result.flags & 32 && ($84b63352e7e6aba6$var$setTextContent(parent$113, ""), JSCompiler_inline_result.flags &= -33);
                        var before$114 = $84b63352e7e6aba6$var$getHostSibling(finishedWork);
                        $84b63352e7e6aba6$var$insertOrAppendPlacementNode(finishedWork, before$114, parent$113);
                        break;
                    case 3:
                    case 4:
                        var parent$115 = JSCompiler_inline_result.stateNode.containerInfo, before$116 = $84b63352e7e6aba6$var$getHostSibling(finishedWork);
                        $84b63352e7e6aba6$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$116, parent$115);
                        break;
                    default:
                        throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(161));
                }
            }
        } catch (error) {
            $84b63352e7e6aba6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $84b63352e7e6aba6$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $84b63352e7e6aba6$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $84b63352e7e6aba6$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$84b63352e7e6aba6$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $84b63352e7e6aba6$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $84b63352e7e6aba6$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $84b63352e7e6aba6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $84b63352e7e6aba6$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $84b63352e7e6aba6$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $84b63352e7e6aba6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 26:
            case 27:
            case 5:
                $84b63352e7e6aba6$var$safelyDetachRef(finishedWork, finishedWork.return);
                $84b63352e7e6aba6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                $84b63352e7e6aba6$var$safelyDetachRef(finishedWork, finishedWork.return);
                null === finishedWork.memoizedState && $84b63352e7e6aba6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $84b63352e7e6aba6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $84b63352e7e6aba6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $84b63352e7e6aba6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $84b63352e7e6aba6$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $84b63352e7e6aba6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $84b63352e7e6aba6$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$84b63352e7e6aba6$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $84b63352e7e6aba6$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $84b63352e7e6aba6$var$commitClassCallbacks(finishedWork);
                $84b63352e7e6aba6$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 26:
            case 27:
            case 5:
                $84b63352e7e6aba6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $84b63352e7e6aba6$var$commitHostMount(finishedWork);
                $84b63352e7e6aba6$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $84b63352e7e6aba6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $84b63352e7e6aba6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $84b63352e7e6aba6$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $84b63352e7e6aba6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $84b63352e7e6aba6$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            default:
                $84b63352e7e6aba6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $84b63352e7e6aba6$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $84b63352e7e6aba6$var$releaseCache(previousCache));
}
function $84b63352e7e6aba6$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $84b63352e7e6aba6$var$releaseCache(current));
}
function $84b63352e7e6aba6$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$84b63352e7e6aba6$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $84b63352e7e6aba6$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $84b63352e7e6aba6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $84b63352e7e6aba6$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 3:
            $84b63352e7e6aba6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $84b63352e7e6aba6$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $84b63352e7e6aba6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $84b63352e7e6aba6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $84b63352e7e6aba6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? $84b63352e7e6aba6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $84b63352e7e6aba6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? $84b63352e7e6aba6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, $84b63352e7e6aba6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $84b63352e7e6aba6$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
            break;
        case 24:
            $84b63352e7e6aba6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $84b63352e7e6aba6$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $84b63352e7e6aba6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $84b63352e7e6aba6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $84b63352e7e6aba6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $84b63352e7e6aba6$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 4 ? $84b63352e7e6aba6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $84b63352e7e6aba6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, $84b63352e7e6aba6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $84b63352e7e6aba6$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $84b63352e7e6aba6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $84b63352e7e6aba6$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $84b63352e7e6aba6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $84b63352e7e6aba6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $84b63352e7e6aba6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $84b63352e7e6aba6$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $84b63352e7e6aba6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $84b63352e7e6aba6$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $84b63352e7e6aba6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $84b63352e7e6aba6$var$suspenseyCommitFlag = 8192;
function $84b63352e7e6aba6$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $84b63352e7e6aba6$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$84b63352e7e6aba6$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $84b63352e7e6aba6$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $84b63352e7e6aba6$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $84b63352e7e6aba6$var$suspenseyCommitFlag && null !== fiber.memoizedState && $84b63352e7e6aba6$var$suspendResource($84b63352e7e6aba6$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $84b63352e7e6aba6$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $84b63352e7e6aba6$var$currentHoistableRoot;
            $84b63352e7e6aba6$var$currentHoistableRoot = $84b63352e7e6aba6$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $84b63352e7e6aba6$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $84b63352e7e6aba6$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $84b63352e7e6aba6$var$suspenseyCommitFlag, $84b63352e7e6aba6$var$suspenseyCommitFlag = 16777216, $84b63352e7e6aba6$var$recursivelyAccumulateSuspenseyCommit(fiber), $84b63352e7e6aba6$var$suspenseyCommitFlag = previousHoistableRoot) : $84b63352e7e6aba6$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $84b63352e7e6aba6$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $84b63352e7e6aba6$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $84b63352e7e6aba6$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $84b63352e7e6aba6$var$nextEffect = childToDelete;
            $84b63352e7e6aba6$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $84b63352e7e6aba6$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$84b63352e7e6aba6$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $84b63352e7e6aba6$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $84b63352e7e6aba6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $84b63352e7e6aba6$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $84b63352e7e6aba6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $84b63352e7e6aba6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, $84b63352e7e6aba6$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $84b63352e7e6aba6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $84b63352e7e6aba6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $84b63352e7e6aba6$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $84b63352e7e6aba6$var$nextEffect = childToDelete;
            $84b63352e7e6aba6$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $84b63352e7e6aba6$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $84b63352e7e6aba6$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $84b63352e7e6aba6$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 4 && (i._visibility &= -5, $84b63352e7e6aba6$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $84b63352e7e6aba6$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $84b63352e7e6aba6$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $84b63352e7e6aba6$var$nextEffect;){
        var fiber = $84b63352e7e6aba6$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $84b63352e7e6aba6$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $84b63352e7e6aba6$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $84b63352e7e6aba6$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $84b63352e7e6aba6$var$nextEffect;){
            cache = $84b63352e7e6aba6$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $84b63352e7e6aba6$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $84b63352e7e6aba6$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $84b63352e7e6aba6$var$nextEffect = sibling;
                break a;
            }
            $84b63352e7e6aba6$var$nextEffect = returnFiber;
        }
    }
}
function $84b63352e7e6aba6$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $84b63352e7e6aba6$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $84b63352e7e6aba6$var$FiberNode(tag, pendingProps, key, mode);
}
function $84b63352e7e6aba6$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $84b63352e7e6aba6$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $84b63352e7e6aba6$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 31457280;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $84b63352e7e6aba6$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 31457282;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $84b63352e7e6aba6$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $84b63352e7e6aba6$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $84b63352e7e6aba6$var$isHostHoistableType(type, pendingProps, $84b63352e7e6aba6$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $84b63352e7e6aba6$var$REACT_FRAGMENT_TYPE:
            return $84b63352e7e6aba6$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $84b63352e7e6aba6$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $84b63352e7e6aba6$var$REACT_PROFILER_TYPE:
            return type = $84b63352e7e6aba6$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $84b63352e7e6aba6$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $84b63352e7e6aba6$var$REACT_SUSPENSE_TYPE:
            return type = $84b63352e7e6aba6$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $84b63352e7e6aba6$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $84b63352e7e6aba6$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $84b63352e7e6aba6$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $84b63352e7e6aba6$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $84b63352e7e6aba6$var$REACT_OFFSCREEN_TYPE:
            return $84b63352e7e6aba6$var$createFiberFromOffscreen(pendingProps, mode, lanes, key);
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $84b63352e7e6aba6$var$REACT_PROVIDER_TYPE:
                case $84b63352e7e6aba6$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $84b63352e7e6aba6$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $84b63352e7e6aba6$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $84b63352e7e6aba6$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $84b63352e7e6aba6$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($84b63352e7e6aba6$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $84b63352e7e6aba6$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $84b63352e7e6aba6$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $84b63352e7e6aba6$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $84b63352e7e6aba6$var$createFiberFromOffscreen(pendingProps, mode, lanes, key) {
    pendingProps = $84b63352e7e6aba6$var$createFiberImplClass(22, pendingProps, key, mode);
    pendingProps.elementType = $84b63352e7e6aba6$var$REACT_OFFSCREEN_TYPE;
    pendingProps.lanes = lanes;
    var primaryChildInstance = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(456));
            if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                var root = $84b63352e7e6aba6$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility |= 2, $84b63352e7e6aba6$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        },
        attach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(456));
            if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                var root = $84b63352e7e6aba6$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility &= -3, $84b63352e7e6aba6$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        }
    };
    pendingProps.stateNode = primaryChildInstance;
    return pendingProps;
}
function $84b63352e7e6aba6$var$createFiberFromText(content, mode, lanes) {
    content = $84b63352e7e6aba6$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $84b63352e7e6aba6$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $84b63352e7e6aba6$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
function $84b63352e7e6aba6$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $84b63352e7e6aba6$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$84b63352e7e6aba6$var$preloadResource(resource)) {
        resource = $84b63352e7e6aba6$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($84b63352e7e6aba6$var$workInProgressRootRenderLanes & 4194176) === $84b63352e7e6aba6$var$workInProgressRootRenderLanes ? null !== $84b63352e7e6aba6$var$shellBoundary : ($84b63352e7e6aba6$var$workInProgressRootRenderLanes & 62914560) !== $84b63352e7e6aba6$var$workInProgressRootRenderLanes && 0 === ($84b63352e7e6aba6$var$workInProgressRootRenderLanes & 536870912) || resource !== $84b63352e7e6aba6$var$shellBoundary)) throw $84b63352e7e6aba6$var$suspendedThenable = $84b63352e7e6aba6$var$noopSuspenseyCommitThenable, $84b63352e7e6aba6$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $84b63352e7e6aba6$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $84b63352e7e6aba6$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $84b63352e7e6aba6$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $84b63352e7e6aba6$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$84b63352e7e6aba6$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$131 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$131 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$131 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$131.sibling = null;
    }
}
function $84b63352e7e6aba6$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags & 31457280, subtreeFlags |= child$132.flags & 31457280, child$132.return = completedWork, child$132 = child$132.sibling;
    else for(child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags, subtreeFlags |= child$132.flags, child$132.return = completedWork, child$132 = child$132.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $84b63352e7e6aba6$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $84b63352e7e6aba6$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $84b63352e7e6aba6$var$bubbleProperties(workInProgress), null;
        case 1:
            return $84b63352e7e6aba6$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $84b63352e7e6aba6$var$popProvider($84b63352e7e6aba6$var$CacheContext);
            $84b63352e7e6aba6$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $84b63352e7e6aba6$var$popHydrationState(workInProgress) ? $84b63352e7e6aba6$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== $84b63352e7e6aba6$var$hydrationErrors && ($84b63352e7e6aba6$var$queueRecoverableErrors($84b63352e7e6aba6$var$hydrationErrors), $84b63352e7e6aba6$var$hydrationErrors = null));
            $84b63352e7e6aba6$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($84b63352e7e6aba6$var$markUpdate(workInProgress), null !== renderLanes ? ($84b63352e7e6aba6$var$bubbleProperties(workInProgress), $84b63352e7e6aba6$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($84b63352e7e6aba6$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($84b63352e7e6aba6$var$markUpdate(workInProgress), $84b63352e7e6aba6$var$bubbleProperties(workInProgress), $84b63352e7e6aba6$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($84b63352e7e6aba6$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $84b63352e7e6aba6$var$markUpdate(workInProgress), $84b63352e7e6aba6$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $84b63352e7e6aba6$var$popHostContext(workInProgress);
            renderLanes = $84b63352e7e6aba6$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $84b63352e7e6aba6$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(166));
                    $84b63352e7e6aba6$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $84b63352e7e6aba6$var$contextStackCursor.current;
                $84b63352e7e6aba6$var$popHydrationState(workInProgress) ? $84b63352e7e6aba6$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $84b63352e7e6aba6$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $84b63352e7e6aba6$var$markUpdate(workInProgress));
            }
            $84b63352e7e6aba6$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $84b63352e7e6aba6$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $84b63352e7e6aba6$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(166));
                    $84b63352e7e6aba6$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $84b63352e7e6aba6$var$contextStackCursor.current;
                if ($84b63352e7e6aba6$var$popHydrationState(workInProgress)) $84b63352e7e6aba6$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $84b63352e7e6aba6$var$getOwnerDocumentFromRootContainer($84b63352e7e6aba6$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$84b63352e7e6aba6$var$internalInstanceKey] = workInProgress;
                    current[$84b63352e7e6aba6$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($84b63352e7e6aba6$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $84b63352e7e6aba6$var$markUpdate(workInProgress);
                }
            }
            $84b63352e7e6aba6$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $84b63352e7e6aba6$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(166));
                current = $84b63352e7e6aba6$var$rootInstanceStackCursor.current;
                if ($84b63352e7e6aba6$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $84b63352e7e6aba6$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$84b63352e7e6aba6$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $84b63352e7e6aba6$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $84b63352e7e6aba6$var$throwOnHydrationMismatch(workInProgress);
                } else current = $84b63352e7e6aba6$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$84b63352e7e6aba6$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $84b63352e7e6aba6$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $84b63352e7e6aba6$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(317));
                        type[$84b63352e7e6aba6$var$internalInstanceKey] = workInProgress;
                    } else $84b63352e7e6aba6$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $84b63352e7e6aba6$var$bubbleProperties(workInProgress);
                    type = !1;
                } else null !== $84b63352e7e6aba6$var$hydrationErrors && ($84b63352e7e6aba6$var$queueRecoverableErrors($84b63352e7e6aba6$var$hydrationErrors), $84b63352e7e6aba6$var$hydrationErrors = null), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $84b63352e7e6aba6$var$popSuspenseHandler(workInProgress), workInProgress;
                    $84b63352e7e6aba6$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $84b63352e7e6aba6$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$144 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$144 = newProps.memoizedState.cachePool.pool);
                cache$144 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $84b63352e7e6aba6$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $84b63352e7e6aba6$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $84b63352e7e6aba6$var$popHostContainer(), null === current && $84b63352e7e6aba6$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $84b63352e7e6aba6$var$bubbleProperties(workInProgress), null;
        case 10:
            return $84b63352e7e6aba6$var$popProvider(workInProgress.type), $84b63352e7e6aba6$var$bubbleProperties(workInProgress), null;
        case 19:
            $84b63352e7e6aba6$var$pop($84b63352e7e6aba6$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $84b63352e7e6aba6$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$144 = type.rendering;
            if (null === cache$144) {
                if (newProps) $84b63352e7e6aba6$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $84b63352e7e6aba6$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$144 = $84b63352e7e6aba6$var$findFirstSuspended(current);
                        if (null !== cache$144) {
                            workInProgress.flags |= 128;
                            $84b63352e7e6aba6$var$cutOffTailIfNeeded(type, !1);
                            current = cache$144.updateQueue;
                            workInProgress.updateQueue = current;
                            $84b63352e7e6aba6$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$84b63352e7e6aba6$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$suspenseStackCursor, $84b63352e7e6aba6$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $84b63352e7e6aba6$var$now() > $84b63352e7e6aba6$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $84b63352e7e6aba6$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $84b63352e7e6aba6$var$findFirstSuspended(cache$144), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $84b63352e7e6aba6$var$scheduleRetryEffect(workInProgress, current), $84b63352e7e6aba6$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$144.alternate && !$84b63352e7e6aba6$var$isHydrating) return $84b63352e7e6aba6$var$bubbleProperties(workInProgress), null;
                    } else 2 * $84b63352e7e6aba6$var$now() - type.renderingStartTime > $84b63352e7e6aba6$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $84b63352e7e6aba6$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$144.sibling = workInProgress.child, workInProgress.child = cache$144) : (current = type.last, null !== current ? current.sibling = cache$144 : workInProgress.child = cache$144, type.last = cache$144);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $84b63352e7e6aba6$var$now(), workInProgress.sibling = null, current = $84b63352e7e6aba6$var$suspenseStackCursor.current, $84b63352e7e6aba6$var$push($84b63352e7e6aba6$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $84b63352e7e6aba6$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $84b63352e7e6aba6$var$popSuspenseHandler(workInProgress), $84b63352e7e6aba6$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($84b63352e7e6aba6$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $84b63352e7e6aba6$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $84b63352e7e6aba6$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $84b63352e7e6aba6$var$pop($84b63352e7e6aba6$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $84b63352e7e6aba6$var$popProvider($84b63352e7e6aba6$var$CacheContext), $84b63352e7e6aba6$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
    }
    throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $84b63352e7e6aba6$var$unwindWork(current, workInProgress) {
    $84b63352e7e6aba6$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $84b63352e7e6aba6$var$popProvider($84b63352e7e6aba6$var$CacheContext), $84b63352e7e6aba6$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $84b63352e7e6aba6$var$popHostContext(workInProgress), null;
        case 13:
            $84b63352e7e6aba6$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(340));
                $84b63352e7e6aba6$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $84b63352e7e6aba6$var$pop($84b63352e7e6aba6$var$suspenseStackCursor), null;
        case 4:
            return $84b63352e7e6aba6$var$popHostContainer(), null;
        case 10:
            return $84b63352e7e6aba6$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $84b63352e7e6aba6$var$popSuspenseHandler(workInProgress), $84b63352e7e6aba6$var$popHiddenContext(), null !== current && $84b63352e7e6aba6$var$pop($84b63352e7e6aba6$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $84b63352e7e6aba6$var$popProvider($84b63352e7e6aba6$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $84b63352e7e6aba6$var$unwindInterruptedWork(current, interruptedWork) {
    $84b63352e7e6aba6$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $84b63352e7e6aba6$var$popProvider($84b63352e7e6aba6$var$CacheContext);
            $84b63352e7e6aba6$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $84b63352e7e6aba6$var$popHostContext(interruptedWork);
            break;
        case 4:
            $84b63352e7e6aba6$var$popHostContainer();
            break;
        case 13:
            $84b63352e7e6aba6$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $84b63352e7e6aba6$var$pop($84b63352e7e6aba6$var$suspenseStackCursor);
            break;
        case 10:
            $84b63352e7e6aba6$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $84b63352e7e6aba6$var$popSuspenseHandler(interruptedWork);
            $84b63352e7e6aba6$var$popHiddenContext();
            null !== current && $84b63352e7e6aba6$var$pop($84b63352e7e6aba6$var$resumedCache);
            break;
        case 24:
            $84b63352e7e6aba6$var$popProvider($84b63352e7e6aba6$var$CacheContext);
    }
}
var $84b63352e7e6aba6$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $84b63352e7e6aba6$var$readContext($84b63352e7e6aba6$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $84b63352e7e6aba6$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $84b63352e7e6aba6$var$executionContext = 0, $84b63352e7e6aba6$var$workInProgressRoot = null, $84b63352e7e6aba6$var$workInProgress = null, $84b63352e7e6aba6$var$workInProgressRootRenderLanes = 0, $84b63352e7e6aba6$var$workInProgressSuspendedReason = 0, $84b63352e7e6aba6$var$workInProgressThrownValue = null, $84b63352e7e6aba6$var$workInProgressRootDidSkipSuspendedSiblings = !1, $84b63352e7e6aba6$var$workInProgressRootIsPrerendering = !1, $84b63352e7e6aba6$var$workInProgressRootDidAttachPingListener = !1, $84b63352e7e6aba6$var$entangledRenderLanes = 0, $84b63352e7e6aba6$var$workInProgressRootExitStatus = 0, $84b63352e7e6aba6$var$workInProgressRootSkippedLanes = 0, $84b63352e7e6aba6$var$workInProgressRootInterleavedUpdatedLanes = 0, $84b63352e7e6aba6$var$workInProgressRootPingedLanes = 0, $84b63352e7e6aba6$var$workInProgressDeferredLane = 0, $84b63352e7e6aba6$var$workInProgressSuspendedRetryLanes = 0, $84b63352e7e6aba6$var$workInProgressRootConcurrentErrors = null, $84b63352e7e6aba6$var$workInProgressRootRecoverableErrors = null, $84b63352e7e6aba6$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $84b63352e7e6aba6$var$globalMostRecentFallbackTime = 0, $84b63352e7e6aba6$var$workInProgressRootRenderTargetTime = Infinity, $84b63352e7e6aba6$var$workInProgressTransitions = null, $84b63352e7e6aba6$var$legacyErrorBoundariesThatAlreadyFailed = null, $84b63352e7e6aba6$var$rootDoesHavePassiveEffects = !1, $84b63352e7e6aba6$var$rootWithPendingPassiveEffects = null, $84b63352e7e6aba6$var$pendingPassiveEffectsLanes = 0, $84b63352e7e6aba6$var$pendingPassiveEffectsRemainingLanes = 0, $84b63352e7e6aba6$var$pendingPassiveTransitions = null, $84b63352e7e6aba6$var$nestedUpdateCount = 0, $84b63352e7e6aba6$var$rootWithNestedUpdates = null;
function $84b63352e7e6aba6$var$requestUpdateLane() {
    if (0 !== ($84b63352e7e6aba6$var$executionContext & 2) && 0 !== $84b63352e7e6aba6$var$workInProgressRootRenderLanes) return $84b63352e7e6aba6$var$workInProgressRootRenderLanes & -$84b63352e7e6aba6$var$workInProgressRootRenderLanes;
    if (null !== $84b63352e7e6aba6$var$ReactSharedInternals.T) {
        var actionScopeLane = $84b63352e7e6aba6$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $84b63352e7e6aba6$var$requestTransitionLane();
    }
    return $84b63352e7e6aba6$var$resolveUpdatePriority();
}
function $84b63352e7e6aba6$var$requestDeferredLane() {
    0 === $84b63352e7e6aba6$var$workInProgressDeferredLane && ($84b63352e7e6aba6$var$workInProgressDeferredLane = 0 === ($84b63352e7e6aba6$var$workInProgressRootRenderLanes & 536870912) || $84b63352e7e6aba6$var$isHydrating ? $84b63352e7e6aba6$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $84b63352e7e6aba6$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $84b63352e7e6aba6$var$workInProgressDeferredLane;
}
function $84b63352e7e6aba6$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $84b63352e7e6aba6$var$workInProgressRoot && 2 === $84b63352e7e6aba6$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) $84b63352e7e6aba6$var$prepareFreshStack(root, 0), $84b63352e7e6aba6$var$markRootSuspended(root, $84b63352e7e6aba6$var$workInProgressRootRenderLanes, $84b63352e7e6aba6$var$workInProgressDeferredLane, !1);
    $84b63352e7e6aba6$var$markRootUpdated$1(root, lane);
    if (0 === ($84b63352e7e6aba6$var$executionContext & 2) || root !== $84b63352e7e6aba6$var$workInProgressRoot) root === $84b63352e7e6aba6$var$workInProgressRoot && (0 === ($84b63352e7e6aba6$var$executionContext & 2) && ($84b63352e7e6aba6$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $84b63352e7e6aba6$var$workInProgressRootExitStatus && $84b63352e7e6aba6$var$markRootSuspended(root, $84b63352e7e6aba6$var$workInProgressRootRenderLanes, $84b63352e7e6aba6$var$workInProgressDeferredLane, !1)), $84b63352e7e6aba6$var$ensureRootIsScheduled(root);
}
function $84b63352e7e6aba6$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($84b63352e7e6aba6$var$executionContext & 6)) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || $84b63352e7e6aba6$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $84b63352e7e6aba6$var$renderRootConcurrent(root$jscomp$0, lanes) : $84b63352e7e6aba6$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $84b63352e7e6aba6$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $84b63352e7e6aba6$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else if (6 === exitStatus) $84b63352e7e6aba6$var$markRootSuspended(root$jscomp$0, lanes, 0, !$84b63352e7e6aba6$var$workInProgressRootDidSkipSuspendedSiblings);
        else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$84b63352e7e6aba6$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $84b63352e7e6aba6$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $84b63352e7e6aba6$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($84b63352e7e6aba6$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $84b63352e7e6aba6$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($84b63352e7e6aba6$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $84b63352e7e6aba6$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $84b63352e7e6aba6$var$workInProgressRootRecoverableErrors;
                            $84b63352e7e6aba6$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && $84b63352e7e6aba6$var$queueRecoverableErrors(renderWasConcurrent);
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $84b63352e7e6aba6$var$prepareFreshStack(root$jscomp$0, 0);
                $84b63352e7e6aba6$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                switch(exitStatus){
                    case 0:
                    case 1:
                        throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194176) === lanes) {
                            $84b63352e7e6aba6$var$markRootSuspended(shouldTimeSlice, lanes, $84b63352e7e6aba6$var$workInProgressDeferredLane, !$84b63352e7e6aba6$var$workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        }
                        break;
                    case 2:
                        $84b63352e7e6aba6$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(329));
                }
                shouldTimeSlice.finishedWork = forceSync;
                shouldTimeSlice.finishedLanes = lanes;
                if ((lanes & 62914560) === lanes && (renderWasConcurrent = $84b63352e7e6aba6$var$globalMostRecentFallbackTime + 300 - $84b63352e7e6aba6$var$now(), 10 < renderWasConcurrent)) {
                    $84b63352e7e6aba6$var$markRootSuspended(shouldTimeSlice, lanes, $84b63352e7e6aba6$var$workInProgressDeferredLane, !$84b63352e7e6aba6$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $84b63352e7e6aba6$var$getNextLanes(shouldTimeSlice, 0)) break a;
                    shouldTimeSlice.timeoutHandle = $84b63352e7e6aba6$var$scheduleTimeout($84b63352e7e6aba6$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $84b63352e7e6aba6$var$workInProgressRootRecoverableErrors, $84b63352e7e6aba6$var$workInProgressTransitions, $84b63352e7e6aba6$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $84b63352e7e6aba6$var$workInProgressDeferredLane, $84b63352e7e6aba6$var$workInProgressRootInterleavedUpdatedLanes, $84b63352e7e6aba6$var$workInProgressSuspendedRetryLanes, $84b63352e7e6aba6$var$workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                    break a;
                }
                $84b63352e7e6aba6$var$commitRootWhenReady(shouldTimeSlice, forceSync, $84b63352e7e6aba6$var$workInProgressRootRecoverableErrors, $84b63352e7e6aba6$var$workInProgressTransitions, $84b63352e7e6aba6$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $84b63352e7e6aba6$var$workInProgressDeferredLane, $84b63352e7e6aba6$var$workInProgressRootInterleavedUpdatedLanes, $84b63352e7e6aba6$var$workInProgressSuspendedRetryLanes, $84b63352e7e6aba6$var$workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $84b63352e7e6aba6$var$ensureRootIsScheduled(root$jscomp$0);
}
function $84b63352e7e6aba6$var$queueRecoverableErrors(errors) {
    null === $84b63352e7e6aba6$var$workInProgressRootRecoverableErrors ? $84b63352e7e6aba6$var$workInProgressRootRecoverableErrors = errors : $84b63352e7e6aba6$var$workInProgressRootRecoverableErrors.push.apply($84b63352e7e6aba6$var$workInProgressRootRecoverableErrors, errors);
}
function $84b63352e7e6aba6$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var subtreeFlags = finishedWork.subtreeFlags;
    if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if ($84b63352e7e6aba6$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $84b63352e7e6aba6$var$noop
        }, $84b63352e7e6aba6$var$accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = $84b63352e7e6aba6$var$waitForCommitToBeReady(), null !== finishedWork) {
            root.cancelPendingCommit = finishedWork($84b63352e7e6aba6$var$commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
            $84b63352e7e6aba6$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $84b63352e7e6aba6$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
}
function $84b63352e7e6aba6$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$84b63352e7e6aba6$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $84b63352e7e6aba6$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$84b63352e7e6aba6$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$84b63352e7e6aba6$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $84b63352e7e6aba6$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $84b63352e7e6aba6$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $84b63352e7e6aba6$var$flushSyncWork$1() {
    return 0 === ($84b63352e7e6aba6$var$executionContext & 6) ? ($84b63352e7e6aba6$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $84b63352e7e6aba6$var$resetWorkInProgressStack() {
    if (null !== $84b63352e7e6aba6$var$workInProgress) {
        if (0 === $84b63352e7e6aba6$var$workInProgressSuspendedReason) var interruptedWork = $84b63352e7e6aba6$var$workInProgress.return;
        else interruptedWork = $84b63352e7e6aba6$var$workInProgress, $84b63352e7e6aba6$var$lastContextDependency = $84b63352e7e6aba6$var$currentlyRenderingFiber = null, $84b63352e7e6aba6$var$resetHooksOnUnwind(interruptedWork), $84b63352e7e6aba6$var$thenableState$1 = null, $84b63352e7e6aba6$var$thenableIndexCounter$1 = 0, interruptedWork = $84b63352e7e6aba6$var$workInProgress;
        for(; null !== interruptedWork;)$84b63352e7e6aba6$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $84b63352e7e6aba6$var$workInProgress = null;
    }
}
function $84b63352e7e6aba6$var$prepareFreshStack(root, lanes) {
    root.finishedWork = null;
    root.finishedLanes = 0;
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $84b63352e7e6aba6$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $84b63352e7e6aba6$var$resetWorkInProgressStack();
    $84b63352e7e6aba6$var$workInProgressRoot = root;
    $84b63352e7e6aba6$var$workInProgress = timeoutHandle = $84b63352e7e6aba6$var$createWorkInProgress(root.current, null);
    $84b63352e7e6aba6$var$workInProgressRootRenderLanes = lanes;
    $84b63352e7e6aba6$var$workInProgressSuspendedReason = 0;
    $84b63352e7e6aba6$var$workInProgressThrownValue = null;
    $84b63352e7e6aba6$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $84b63352e7e6aba6$var$workInProgressRootIsPrerendering = $84b63352e7e6aba6$var$checkIfRootIsPrerendering(root, lanes);
    $84b63352e7e6aba6$var$workInProgressRootDidAttachPingListener = !1;
    $84b63352e7e6aba6$var$workInProgressSuspendedRetryLanes = $84b63352e7e6aba6$var$workInProgressDeferredLane = $84b63352e7e6aba6$var$workInProgressRootPingedLanes = $84b63352e7e6aba6$var$workInProgressRootInterleavedUpdatedLanes = $84b63352e7e6aba6$var$workInProgressRootSkippedLanes = $84b63352e7e6aba6$var$workInProgressRootExitStatus = 0;
    $84b63352e7e6aba6$var$workInProgressRootRecoverableErrors = $84b63352e7e6aba6$var$workInProgressRootConcurrentErrors = null;
    $84b63352e7e6aba6$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $84b63352e7e6aba6$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $84b63352e7e6aba6$var$entangledRenderLanes = lanes;
    $84b63352e7e6aba6$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $84b63352e7e6aba6$var$handleThrow(root, thrownValue) {
    $84b63352e7e6aba6$var$currentlyRenderingFiber$1 = null;
    $84b63352e7e6aba6$var$ReactSharedInternals.H = $84b63352e7e6aba6$var$ContextOnlyDispatcher;
    thrownValue === $84b63352e7e6aba6$var$SuspenseException ? (thrownValue = $84b63352e7e6aba6$var$getSuspendedThenable(), $84b63352e7e6aba6$var$workInProgressSuspendedReason = 3) : thrownValue === $84b63352e7e6aba6$var$SuspenseyCommitException ? (thrownValue = $84b63352e7e6aba6$var$getSuspendedThenable(), $84b63352e7e6aba6$var$workInProgressSuspendedReason = 4) : $84b63352e7e6aba6$var$workInProgressSuspendedReason = thrownValue === $84b63352e7e6aba6$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $84b63352e7e6aba6$var$workInProgressThrownValue = thrownValue;
    null === $84b63352e7e6aba6$var$workInProgress && ($84b63352e7e6aba6$var$workInProgressRootExitStatus = 1, $84b63352e7e6aba6$var$logUncaughtError(root, $84b63352e7e6aba6$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $84b63352e7e6aba6$var$pushDispatcher() {
    var prevDispatcher = $84b63352e7e6aba6$var$ReactSharedInternals.H;
    $84b63352e7e6aba6$var$ReactSharedInternals.H = $84b63352e7e6aba6$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $84b63352e7e6aba6$var$ContextOnlyDispatcher : prevDispatcher;
}
function $84b63352e7e6aba6$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $84b63352e7e6aba6$var$ReactSharedInternals.A;
    $84b63352e7e6aba6$var$ReactSharedInternals.A = $84b63352e7e6aba6$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $84b63352e7e6aba6$var$renderDidSuspendDelayIfPossible() {
    $84b63352e7e6aba6$var$workInProgressRootExitStatus = 4;
    $84b63352e7e6aba6$var$workInProgressRootDidSkipSuspendedSiblings || ($84b63352e7e6aba6$var$workInProgressRootRenderLanes & 4194176) !== $84b63352e7e6aba6$var$workInProgressRootRenderLanes && null !== $84b63352e7e6aba6$var$suspenseHandlerStackCursor.current || ($84b63352e7e6aba6$var$workInProgressRootIsPrerendering = !0);
    0 === ($84b63352e7e6aba6$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($84b63352e7e6aba6$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $84b63352e7e6aba6$var$workInProgressRoot || $84b63352e7e6aba6$var$markRootSuspended($84b63352e7e6aba6$var$workInProgressRoot, $84b63352e7e6aba6$var$workInProgressRootRenderLanes, $84b63352e7e6aba6$var$workInProgressDeferredLane, !1);
}
function $84b63352e7e6aba6$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $84b63352e7e6aba6$var$executionContext;
    $84b63352e7e6aba6$var$executionContext |= 2;
    var prevDispatcher = $84b63352e7e6aba6$var$pushDispatcher(), prevAsyncDispatcher = $84b63352e7e6aba6$var$pushAsyncDispatcher();
    if ($84b63352e7e6aba6$var$workInProgressRoot !== root || $84b63352e7e6aba6$var$workInProgressRootRenderLanes !== lanes) $84b63352e7e6aba6$var$workInProgressTransitions = null, $84b63352e7e6aba6$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $84b63352e7e6aba6$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $84b63352e7e6aba6$var$workInProgressSuspendedReason && null !== $84b63352e7e6aba6$var$workInProgress) {
            var unitOfWork = $84b63352e7e6aba6$var$workInProgress, thrownValue = $84b63352e7e6aba6$var$workInProgressThrownValue;
            switch($84b63352e7e6aba6$var$workInProgressSuspendedReason){
                case 8:
                    $84b63352e7e6aba6$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 6:
                    null === $84b63352e7e6aba6$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $84b63352e7e6aba6$var$workInProgressSuspendedReason;
                    $84b63352e7e6aba6$var$workInProgressSuspendedReason = 0;
                    $84b63352e7e6aba6$var$workInProgressThrownValue = null;
                    $84b63352e7e6aba6$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $84b63352e7e6aba6$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $84b63352e7e6aba6$var$workInProgressSuspendedReason, $84b63352e7e6aba6$var$workInProgressSuspendedReason = 0, $84b63352e7e6aba6$var$workInProgressThrownValue = null, $84b63352e7e6aba6$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $84b63352e7e6aba6$var$workLoopSync();
        exitStatus = $84b63352e7e6aba6$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$164) {
        $84b63352e7e6aba6$var$handleThrow(root, thrownValue$164);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $84b63352e7e6aba6$var$lastContextDependency = $84b63352e7e6aba6$var$currentlyRenderingFiber = null;
    $84b63352e7e6aba6$var$executionContext = prevExecutionContext;
    $84b63352e7e6aba6$var$ReactSharedInternals.H = prevDispatcher;
    $84b63352e7e6aba6$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $84b63352e7e6aba6$var$workInProgress && ($84b63352e7e6aba6$var$workInProgressRoot = null, $84b63352e7e6aba6$var$workInProgressRootRenderLanes = 0, $84b63352e7e6aba6$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $84b63352e7e6aba6$var$workLoopSync() {
    for(; null !== $84b63352e7e6aba6$var$workInProgress;)$84b63352e7e6aba6$var$performUnitOfWork($84b63352e7e6aba6$var$workInProgress);
}
function $84b63352e7e6aba6$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $84b63352e7e6aba6$var$executionContext;
    $84b63352e7e6aba6$var$executionContext |= 2;
    var prevDispatcher = $84b63352e7e6aba6$var$pushDispatcher(), prevAsyncDispatcher = $84b63352e7e6aba6$var$pushAsyncDispatcher();
    $84b63352e7e6aba6$var$workInProgressRoot !== root || $84b63352e7e6aba6$var$workInProgressRootRenderLanes !== lanes ? ($84b63352e7e6aba6$var$workInProgressTransitions = null, $84b63352e7e6aba6$var$workInProgressRootRenderTargetTime = $84b63352e7e6aba6$var$now() + 500, $84b63352e7e6aba6$var$prepareFreshStack(root, lanes)) : $84b63352e7e6aba6$var$workInProgressRootIsPrerendering = $84b63352e7e6aba6$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $84b63352e7e6aba6$var$workInProgressSuspendedReason && null !== $84b63352e7e6aba6$var$workInProgress) {
            lanes = $84b63352e7e6aba6$var$workInProgress;
            var thrownValue = $84b63352e7e6aba6$var$workInProgressThrownValue;
            b: switch($84b63352e7e6aba6$var$workInProgressSuspendedReason){
                case 1:
                    $84b63352e7e6aba6$var$workInProgressSuspendedReason = 0;
                    $84b63352e7e6aba6$var$workInProgressThrownValue = null;
                    $84b63352e7e6aba6$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                    if ($84b63352e7e6aba6$var$isThenableResolved(thrownValue)) {
                        $84b63352e7e6aba6$var$workInProgressSuspendedReason = 0;
                        $84b63352e7e6aba6$var$workInProgressThrownValue = null;
                        $84b63352e7e6aba6$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 === $84b63352e7e6aba6$var$workInProgressSuspendedReason && $84b63352e7e6aba6$var$workInProgressRoot === root && ($84b63352e7e6aba6$var$workInProgressSuspendedReason = 7);
                        $84b63352e7e6aba6$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $84b63352e7e6aba6$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $84b63352e7e6aba6$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $84b63352e7e6aba6$var$isThenableResolved(thrownValue) ? ($84b63352e7e6aba6$var$workInProgressSuspendedReason = 0, $84b63352e7e6aba6$var$workInProgressThrownValue = null, $84b63352e7e6aba6$var$replaySuspendedUnitOfWork(lanes)) : ($84b63352e7e6aba6$var$workInProgressSuspendedReason = 0, $84b63352e7e6aba6$var$workInProgressThrownValue = null, $84b63352e7e6aba6$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($84b63352e7e6aba6$var$workInProgress.tag){
                        case 26:
                            resource = $84b63352e7e6aba6$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $84b63352e7e6aba6$var$workInProgress;
                            if (resource ? $84b63352e7e6aba6$var$preloadResource(resource) : 1) {
                                $84b63352e7e6aba6$var$workInProgressSuspendedReason = 0;
                                $84b63352e7e6aba6$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $84b63352e7e6aba6$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($84b63352e7e6aba6$var$workInProgress = returnFiber, $84b63352e7e6aba6$var$completeUnitOfWork(returnFiber)) : $84b63352e7e6aba6$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $84b63352e7e6aba6$var$workInProgressSuspendedReason = 0;
                    $84b63352e7e6aba6$var$workInProgressThrownValue = null;
                    $84b63352e7e6aba6$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $84b63352e7e6aba6$var$workInProgressSuspendedReason = 0;
                    $84b63352e7e6aba6$var$workInProgressThrownValue = null;
                    $84b63352e7e6aba6$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $84b63352e7e6aba6$var$resetWorkInProgressStack();
                    $84b63352e7e6aba6$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(462));
            }
        }
        $84b63352e7e6aba6$var$workLoopConcurrent();
        break;
    } catch (thrownValue$166) {
        $84b63352e7e6aba6$var$handleThrow(root, thrownValue$166);
    }
    while (1);
    $84b63352e7e6aba6$var$lastContextDependency = $84b63352e7e6aba6$var$currentlyRenderingFiber = null;
    $84b63352e7e6aba6$var$ReactSharedInternals.H = prevDispatcher;
    $84b63352e7e6aba6$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $84b63352e7e6aba6$var$executionContext = prevExecutionContext;
    if (null !== $84b63352e7e6aba6$var$workInProgress) return 0;
    $84b63352e7e6aba6$var$workInProgressRoot = null;
    $84b63352e7e6aba6$var$workInProgressRootRenderLanes = 0;
    $84b63352e7e6aba6$var$finishQueueingConcurrentUpdates();
    return $84b63352e7e6aba6$var$workInProgressRootExitStatus;
}
function $84b63352e7e6aba6$var$workLoopConcurrent() {
    for(; null !== $84b63352e7e6aba6$var$workInProgress && !$84b63352e7e6aba6$var$shouldYield();)$84b63352e7e6aba6$var$performUnitOfWork($84b63352e7e6aba6$var$workInProgress);
}
function $84b63352e7e6aba6$var$performUnitOfWork(unitOfWork) {
    var next = $84b63352e7e6aba6$var$beginWork(unitOfWork.alternate, unitOfWork, $84b63352e7e6aba6$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $84b63352e7e6aba6$var$completeUnitOfWork(unitOfWork) : $84b63352e7e6aba6$var$workInProgress = next;
}
function $84b63352e7e6aba6$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $84b63352e7e6aba6$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $84b63352e7e6aba6$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $84b63352e7e6aba6$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $84b63352e7e6aba6$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $84b63352e7e6aba6$var$resetHooksOnUnwind(next);
        default:
            $84b63352e7e6aba6$var$unwindInterruptedWork(current, next), next = $84b63352e7e6aba6$var$workInProgress = $84b63352e7e6aba6$var$resetWorkInProgress(next, $84b63352e7e6aba6$var$entangledRenderLanes), next = $84b63352e7e6aba6$var$beginWork(current, next, $84b63352e7e6aba6$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $84b63352e7e6aba6$var$completeUnitOfWork(unitOfWork) : $84b63352e7e6aba6$var$workInProgress = next;
}
function $84b63352e7e6aba6$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $84b63352e7e6aba6$var$lastContextDependency = $84b63352e7e6aba6$var$currentlyRenderingFiber = null;
    $84b63352e7e6aba6$var$resetHooksOnUnwind(unitOfWork);
    $84b63352e7e6aba6$var$thenableState$1 = null;
    $84b63352e7e6aba6$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($84b63352e7e6aba6$var$throwException(root, returnFiber, unitOfWork, thrownValue, $84b63352e7e6aba6$var$workInProgressRootRenderLanes)) {
            $84b63352e7e6aba6$var$workInProgressRootExitStatus = 1;
            $84b63352e7e6aba6$var$logUncaughtError(root, $84b63352e7e6aba6$var$createCapturedValueAtFiber(thrownValue, root.current));
            $84b63352e7e6aba6$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $84b63352e7e6aba6$var$workInProgress = returnFiber, error;
        $84b63352e7e6aba6$var$workInProgressRootExitStatus = 1;
        $84b63352e7e6aba6$var$logUncaughtError(root, $84b63352e7e6aba6$var$createCapturedValueAtFiber(thrownValue, root.current));
        $84b63352e7e6aba6$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($84b63352e7e6aba6$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($84b63352e7e6aba6$var$workInProgressRootIsPrerendering || 0 !== ($84b63352e7e6aba6$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($84b63352e7e6aba6$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $84b63352e7e6aba6$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $84b63352e7e6aba6$var$unwindUnitOfWork(unitOfWork, root);
    } else $84b63352e7e6aba6$var$completeUnitOfWork(unitOfWork);
}
function $84b63352e7e6aba6$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $84b63352e7e6aba6$var$unwindUnitOfWork(completedWork, $84b63352e7e6aba6$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $84b63352e7e6aba6$var$completeWork(completedWork.alternate, completedWork, $84b63352e7e6aba6$var$entangledRenderLanes);
        if (null !== next) {
            $84b63352e7e6aba6$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $84b63352e7e6aba6$var$workInProgress = completedWork;
            return;
        }
        $84b63352e7e6aba6$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $84b63352e7e6aba6$var$workInProgressRootExitStatus && ($84b63352e7e6aba6$var$workInProgressRootExitStatus = 5);
}
function $84b63352e7e6aba6$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $84b63352e7e6aba6$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $84b63352e7e6aba6$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $84b63352e7e6aba6$var$workInProgress = unitOfWork;
            return;
        }
        $84b63352e7e6aba6$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $84b63352e7e6aba6$var$workInProgressRootExitStatus = 6;
    $84b63352e7e6aba6$var$workInProgress = null;
}
function $84b63352e7e6aba6$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var prevTransition = $84b63352e7e6aba6$var$ReactSharedInternals.T, previousUpdateLanePriority = $84b63352e7e6aba6$var$ReactDOMSharedInternals.p;
    try {
        $84b63352e7e6aba6$var$ReactDOMSharedInternals.p = 2, $84b63352e7e6aba6$var$ReactSharedInternals.T = null, $84b63352e7e6aba6$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    } finally{
        $84b63352e7e6aba6$var$ReactSharedInternals.T = prevTransition, $84b63352e7e6aba6$var$ReactDOMSharedInternals.p = previousUpdateLanePriority;
    }
}
function $84b63352e7e6aba6$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
    do $84b63352e7e6aba6$var$flushPassiveEffects();
    while (null !== $84b63352e7e6aba6$var$rootWithPendingPassiveEffects);
    if (0 !== ($84b63352e7e6aba6$var$executionContext & 6)) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(327));
    var finishedWork = root.finishedWork;
    didIncludeRenderPhaseUpdate = root.finishedLanes;
    if (null === finishedWork) return null;
    root.finishedWork = null;
    root.finishedLanes = 0;
    if (finishedWork === root.current) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(177));
    root.callbackNode = null;
    root.callbackPriority = 0;
    root.cancelPendingCommit = null;
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    remainingLanes |= $84b63352e7e6aba6$var$concurrentlyUpdatedLanes;
    $84b63352e7e6aba6$var$markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    root === $84b63352e7e6aba6$var$workInProgressRoot && ($84b63352e7e6aba6$var$workInProgress = $84b63352e7e6aba6$var$workInProgressRoot = null, $84b63352e7e6aba6$var$workInProgressRootRenderLanes = 0);
    0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || $84b63352e7e6aba6$var$rootDoesHavePassiveEffects || ($84b63352e7e6aba6$var$rootDoesHavePassiveEffects = !0, $84b63352e7e6aba6$var$pendingPassiveEffectsRemainingLanes = remainingLanes, $84b63352e7e6aba6$var$pendingPassiveTransitions = transitions, $84b63352e7e6aba6$var$scheduleCallback$1($84b63352e7e6aba6$var$NormalPriority$1, function() {
        $84b63352e7e6aba6$var$flushPassiveEffects(!0);
        return null;
    }));
    transitions = 0 !== (finishedWork.flags & 15990);
    0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = $84b63352e7e6aba6$var$ReactSharedInternals.T, $84b63352e7e6aba6$var$ReactSharedInternals.T = null, spawnedLane = $84b63352e7e6aba6$var$ReactDOMSharedInternals.p, $84b63352e7e6aba6$var$ReactDOMSharedInternals.p = 2, updatedLanes = $84b63352e7e6aba6$var$executionContext, $84b63352e7e6aba6$var$executionContext |= 4, $84b63352e7e6aba6$var$commitBeforeMutationEffects(root, finishedWork), $84b63352e7e6aba6$var$commitMutationEffectsOnFiber(finishedWork, root), $84b63352e7e6aba6$var$restoreSelection($84b63352e7e6aba6$var$selectionInformation, root.containerInfo), $84b63352e7e6aba6$var$_enabled = !!$84b63352e7e6aba6$var$eventsEnabled, $84b63352e7e6aba6$var$selectionInformation = $84b63352e7e6aba6$var$eventsEnabled = null, root.current = finishedWork, $84b63352e7e6aba6$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), $84b63352e7e6aba6$var$requestPaint(), $84b63352e7e6aba6$var$executionContext = updatedLanes, $84b63352e7e6aba6$var$ReactDOMSharedInternals.p = spawnedLane, $84b63352e7e6aba6$var$ReactSharedInternals.T = transitions) : root.current = finishedWork;
    $84b63352e7e6aba6$var$rootDoesHavePassiveEffects ? ($84b63352e7e6aba6$var$rootDoesHavePassiveEffects = !1, $84b63352e7e6aba6$var$rootWithPendingPassiveEffects = root, $84b63352e7e6aba6$var$pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : $84b63352e7e6aba6$var$releaseRootPooledCache(root, remainingLanes);
    remainingLanes = root.pendingLanes;
    0 === remainingLanes && ($84b63352e7e6aba6$var$legacyErrorBoundariesThatAlreadyFailed = null);
    $84b63352e7e6aba6$var$onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
    $84b63352e7e6aba6$var$ensureRootIsScheduled(root);
    if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
        componentStack: remainingLanes.stack
    });
    0 !== ($84b63352e7e6aba6$var$pendingPassiveEffectsLanes & 3) && $84b63352e7e6aba6$var$flushPassiveEffects();
    remainingLanes = root.pendingLanes;
    0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === $84b63352e7e6aba6$var$rootWithNestedUpdates ? $84b63352e7e6aba6$var$nestedUpdateCount++ : ($84b63352e7e6aba6$var$nestedUpdateCount = 0, $84b63352e7e6aba6$var$rootWithNestedUpdates = root) : $84b63352e7e6aba6$var$nestedUpdateCount = 0;
    $84b63352e7e6aba6$var$flushSyncWorkAcrossRoots_impl(0, !1);
    return null;
}
function $84b63352e7e6aba6$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $84b63352e7e6aba6$var$releaseCache(remainingLanes)));
}
function $84b63352e7e6aba6$var$flushPassiveEffects() {
    if (null !== $84b63352e7e6aba6$var$rootWithPendingPassiveEffects) {
        var root$170 = $84b63352e7e6aba6$var$rootWithPendingPassiveEffects, remainingLanes = $84b63352e7e6aba6$var$pendingPassiveEffectsRemainingLanes;
        $84b63352e7e6aba6$var$pendingPassiveEffectsRemainingLanes = 0;
        var renderPriority = $84b63352e7e6aba6$var$lanesToEventPriority($84b63352e7e6aba6$var$pendingPassiveEffectsLanes), prevTransition = $84b63352e7e6aba6$var$ReactSharedInternals.T, previousPriority = $84b63352e7e6aba6$var$ReactDOMSharedInternals.p;
        try {
            $84b63352e7e6aba6$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
            $84b63352e7e6aba6$var$ReactSharedInternals.T = null;
            if (null === $84b63352e7e6aba6$var$rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
            else {
                renderPriority = $84b63352e7e6aba6$var$pendingPassiveTransitions;
                $84b63352e7e6aba6$var$pendingPassiveTransitions = null;
                var root = $84b63352e7e6aba6$var$rootWithPendingPassiveEffects, lanes = $84b63352e7e6aba6$var$pendingPassiveEffectsLanes;
                $84b63352e7e6aba6$var$rootWithPendingPassiveEffects = null;
                $84b63352e7e6aba6$var$pendingPassiveEffectsLanes = 0;
                if (0 !== ($84b63352e7e6aba6$var$executionContext & 6)) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(331));
                var prevExecutionContext = $84b63352e7e6aba6$var$executionContext;
                $84b63352e7e6aba6$var$executionContext |= 4;
                $84b63352e7e6aba6$var$commitPassiveUnmountOnFiber(root.current);
                $84b63352e7e6aba6$var$commitPassiveMountOnFiber(root, root.current, lanes, renderPriority);
                $84b63352e7e6aba6$var$executionContext = prevExecutionContext;
                $84b63352e7e6aba6$var$flushSyncWorkAcrossRoots_impl(0, !1);
                if ($84b63352e7e6aba6$var$injectedHook && "function" === typeof $84b63352e7e6aba6$var$injectedHook.onPostCommitFiberRoot) try {
                    $84b63352e7e6aba6$var$injectedHook.onPostCommitFiberRoot($84b63352e7e6aba6$var$rendererID, root);
                } catch (err) {}
                JSCompiler_inline_result = !0;
            }
            return JSCompiler_inline_result;
        } finally{
            $84b63352e7e6aba6$var$ReactDOMSharedInternals.p = previousPriority, $84b63352e7e6aba6$var$ReactSharedInternals.T = prevTransition, $84b63352e7e6aba6$var$releaseRootPooledCache(root$170, remainingLanes);
        }
    }
    return !1;
}
function $84b63352e7e6aba6$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $84b63352e7e6aba6$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $84b63352e7e6aba6$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $84b63352e7e6aba6$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($84b63352e7e6aba6$var$markRootUpdated$1(rootFiber, 2), $84b63352e7e6aba6$var$ensureRootIsScheduled(rootFiber));
}
function $84b63352e7e6aba6$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $84b63352e7e6aba6$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $84b63352e7e6aba6$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $84b63352e7e6aba6$var$legacyErrorBoundariesThatAlreadyFailed || !$84b63352e7e6aba6$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $84b63352e7e6aba6$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $84b63352e7e6aba6$var$createClassErrorUpdate(2);
                instance = $84b63352e7e6aba6$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($84b63352e7e6aba6$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $84b63352e7e6aba6$var$markRootUpdated$1(instance, 2), $84b63352e7e6aba6$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $84b63352e7e6aba6$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $84b63352e7e6aba6$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($84b63352e7e6aba6$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $84b63352e7e6aba6$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $84b63352e7e6aba6$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $84b63352e7e6aba6$var$workInProgressRoot === root && ($84b63352e7e6aba6$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $84b63352e7e6aba6$var$workInProgressRootExitStatus || 3 === $84b63352e7e6aba6$var$workInProgressRootExitStatus && ($84b63352e7e6aba6$var$workInProgressRootRenderLanes & 62914560) === $84b63352e7e6aba6$var$workInProgressRootRenderLanes && 300 > $84b63352e7e6aba6$var$now() - $84b63352e7e6aba6$var$globalMostRecentFallbackTime ? 0 === ($84b63352e7e6aba6$var$executionContext & 2) && $84b63352e7e6aba6$var$prepareFreshStack(root, 0) : $84b63352e7e6aba6$var$workInProgressRootPingedLanes |= pingedLanes, $84b63352e7e6aba6$var$workInProgressSuspendedRetryLanes === $84b63352e7e6aba6$var$workInProgressRootRenderLanes && ($84b63352e7e6aba6$var$workInProgressSuspendedRetryLanes = 0));
    $84b63352e7e6aba6$var$ensureRootIsScheduled(root);
}
function $84b63352e7e6aba6$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $84b63352e7e6aba6$var$claimNextRetryLane());
    boundaryFiber = $84b63352e7e6aba6$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($84b63352e7e6aba6$var$markRootUpdated$1(boundaryFiber, retryLane), $84b63352e7e6aba6$var$ensureRootIsScheduled(boundaryFiber));
}
function $84b63352e7e6aba6$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $84b63352e7e6aba6$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $84b63352e7e6aba6$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $84b63352e7e6aba6$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $84b63352e7e6aba6$var$scheduleCallback$1(priorityLevel, callback) {
    return $84b63352e7e6aba6$var$scheduleCallback$3(priorityLevel, callback);
}
var $84b63352e7e6aba6$var$firstScheduledRoot = null, $84b63352e7e6aba6$var$lastScheduledRoot = null, $84b63352e7e6aba6$var$didScheduleMicrotask = !1, $84b63352e7e6aba6$var$mightHavePendingSyncWork = !1, $84b63352e7e6aba6$var$isFlushingWork = !1, $84b63352e7e6aba6$var$currentEventTransitionLane = 0;
function $84b63352e7e6aba6$var$ensureRootIsScheduled(root) {
    root !== $84b63352e7e6aba6$var$lastScheduledRoot && null === root.next && (null === $84b63352e7e6aba6$var$lastScheduledRoot ? $84b63352e7e6aba6$var$firstScheduledRoot = $84b63352e7e6aba6$var$lastScheduledRoot = root : $84b63352e7e6aba6$var$lastScheduledRoot = $84b63352e7e6aba6$var$lastScheduledRoot.next = root);
    $84b63352e7e6aba6$var$mightHavePendingSyncWork = !0;
    $84b63352e7e6aba6$var$didScheduleMicrotask || ($84b63352e7e6aba6$var$didScheduleMicrotask = !0, $84b63352e7e6aba6$var$scheduleImmediateTask($84b63352e7e6aba6$var$processRootScheduleInMicrotask));
}
function $84b63352e7e6aba6$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$84b63352e7e6aba6$var$isFlushingWork && $84b63352e7e6aba6$var$mightHavePendingSyncWork) {
        $84b63352e7e6aba6$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$172 = $84b63352e7e6aba6$var$firstScheduledRoot; null !== root$172;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$172.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$172.suspendedLanes, pingedLanes = root$172.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $84b63352e7e6aba6$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $84b63352e7e6aba6$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $84b63352e7e6aba6$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $84b63352e7e6aba6$var$getNextLanes(root$172, root$172 === $84b63352e7e6aba6$var$workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || $84b63352e7e6aba6$var$checkIfRootIsPrerendering(root$172, JSCompiler_inline_result) || (didPerformSomeWork = !0, $84b63352e7e6aba6$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                }
                root$172 = root$172.next;
            }
        }while (didPerformSomeWork);
        $84b63352e7e6aba6$var$isFlushingWork = !1;
    }
}
function $84b63352e7e6aba6$var$processRootScheduleInMicrotask() {
    $84b63352e7e6aba6$var$mightHavePendingSyncWork = $84b63352e7e6aba6$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $84b63352e7e6aba6$var$currentEventTransitionLane && ($84b63352e7e6aba6$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $84b63352e7e6aba6$var$currentEventTransitionLane), $84b63352e7e6aba6$var$currentEventTransitionLane = 0);
    for(var currentTime = $84b63352e7e6aba6$var$now(), prev = null, root = $84b63352e7e6aba6$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $84b63352e7e6aba6$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $84b63352e7e6aba6$var$firstScheduledRoot = next : prev.next = next, null === next && ($84b63352e7e6aba6$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $84b63352e7e6aba6$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $84b63352e7e6aba6$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $84b63352e7e6aba6$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $84b63352e7e6aba6$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $84b63352e7e6aba6$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $84b63352e7e6aba6$var$workInProgressRoot;
    suspendedLanes = $84b63352e7e6aba6$var$workInProgressRootRenderLanes;
    suspendedLanes = $84b63352e7e6aba6$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && 2 === $84b63352e7e6aba6$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $84b63352e7e6aba6$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $84b63352e7e6aba6$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $84b63352e7e6aba6$var$cancelCallback$1(pingedLanes);
        switch($84b63352e7e6aba6$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $84b63352e7e6aba6$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $84b63352e7e6aba6$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $84b63352e7e6aba6$var$IdlePriority;
                break;
            default:
                suspendedLanes = $84b63352e7e6aba6$var$NormalPriority$1;
        }
        pingedLanes = $84b63352e7e6aba6$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $84b63352e7e6aba6$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $84b63352e7e6aba6$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $84b63352e7e6aba6$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    var originalCallbackNode = root.callbackNode;
    if ($84b63352e7e6aba6$var$flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $84b63352e7e6aba6$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $84b63352e7e6aba6$var$getNextLanes(root, root === $84b63352e7e6aba6$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $84b63352e7e6aba6$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $84b63352e7e6aba6$var$scheduleTaskForRootDuringMicrotask(root, $84b63352e7e6aba6$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $84b63352e7e6aba6$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $84b63352e7e6aba6$var$performSyncWorkOnRoot(root, lanes) {
    if ($84b63352e7e6aba6$var$flushPassiveEffects()) return null;
    $84b63352e7e6aba6$var$performWorkOnRoot(root, lanes, !0);
}
function $84b63352e7e6aba6$var$scheduleImmediateTask(cb) {
    $84b63352e7e6aba6$var$scheduleMicrotask(function() {
        0 !== ($84b63352e7e6aba6$var$executionContext & 6) ? $84b63352e7e6aba6$var$scheduleCallback$3($84b63352e7e6aba6$var$ImmediatePriority, cb) : cb();
    });
}
function $84b63352e7e6aba6$var$requestTransitionLane() {
    0 === $84b63352e7e6aba6$var$currentEventTransitionLane && ($84b63352e7e6aba6$var$currentEventTransitionLane = $84b63352e7e6aba6$var$claimNextTransitionLane());
    return $84b63352e7e6aba6$var$currentEventTransitionLane;
}
function $84b63352e7e6aba6$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $84b63352e7e6aba6$var$sanitizeURL("" + actionProp);
}
function $84b63352e7e6aba6$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $84b63352e7e6aba6$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $84b63352e7e6aba6$var$coerceFormActionProp((nativeEventTarget[$84b63352e7e6aba6$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$84b63352e7e6aba6$var$internalPropsKey] || null) ? $84b63352e7e6aba6$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $84b63352e7e6aba6$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $84b63352e7e6aba6$var$currentEventTransitionLane) {
                                var formData = submitter ? $84b63352e7e6aba6$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $84b63352e7e6aba6$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $84b63352e7e6aba6$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $84b63352e7e6aba6$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $84b63352e7e6aba6$var$i$jscomp$inline_1439 = 0; $84b63352e7e6aba6$var$i$jscomp$inline_1439 < $84b63352e7e6aba6$var$simpleEventPluginEvents.length; $84b63352e7e6aba6$var$i$jscomp$inline_1439++){
    var $84b63352e7e6aba6$var$eventName$jscomp$inline_1440 = $84b63352e7e6aba6$var$simpleEventPluginEvents[$84b63352e7e6aba6$var$i$jscomp$inline_1439], $84b63352e7e6aba6$var$domEventName$jscomp$inline_1441 = $84b63352e7e6aba6$var$eventName$jscomp$inline_1440.toLowerCase(), $84b63352e7e6aba6$var$capitalizedEvent$jscomp$inline_1442 = $84b63352e7e6aba6$var$eventName$jscomp$inline_1440[0].toUpperCase() + $84b63352e7e6aba6$var$eventName$jscomp$inline_1440.slice(1);
    $84b63352e7e6aba6$var$registerSimpleEvent($84b63352e7e6aba6$var$domEventName$jscomp$inline_1441, "on" + $84b63352e7e6aba6$var$capitalizedEvent$jscomp$inline_1442);
}
$84b63352e7e6aba6$var$registerSimpleEvent($84b63352e7e6aba6$var$ANIMATION_END, "onAnimationEnd");
$84b63352e7e6aba6$var$registerSimpleEvent($84b63352e7e6aba6$var$ANIMATION_ITERATION, "onAnimationIteration");
$84b63352e7e6aba6$var$registerSimpleEvent($84b63352e7e6aba6$var$ANIMATION_START, "onAnimationStart");
$84b63352e7e6aba6$var$registerSimpleEvent("dblclick", "onDoubleClick");
$84b63352e7e6aba6$var$registerSimpleEvent("focusin", "onFocus");
$84b63352e7e6aba6$var$registerSimpleEvent("focusout", "onBlur");
$84b63352e7e6aba6$var$registerSimpleEvent($84b63352e7e6aba6$var$TRANSITION_RUN, "onTransitionRun");
$84b63352e7e6aba6$var$registerSimpleEvent($84b63352e7e6aba6$var$TRANSITION_START, "onTransitionStart");
$84b63352e7e6aba6$var$registerSimpleEvent($84b63352e7e6aba6$var$TRANSITION_CANCEL, "onTransitionCancel");
$84b63352e7e6aba6$var$registerSimpleEvent($84b63352e7e6aba6$var$TRANSITION_END, "onTransitionEnd");
$84b63352e7e6aba6$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$84b63352e7e6aba6$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$84b63352e7e6aba6$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$84b63352e7e6aba6$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$84b63352e7e6aba6$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$84b63352e7e6aba6$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$84b63352e7e6aba6$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$84b63352e7e6aba6$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$84b63352e7e6aba6$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$84b63352e7e6aba6$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $84b63352e7e6aba6$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $84b63352e7e6aba6$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($84b63352e7e6aba6$var$mediaEventTypes));
function $84b63352e7e6aba6$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $84b63352e7e6aba6$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $84b63352e7e6aba6$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $84b63352e7e6aba6$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$84b63352e7e6aba6$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$84b63352e7e6aba6$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($84b63352e7e6aba6$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $84b63352e7e6aba6$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $84b63352e7e6aba6$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $84b63352e7e6aba6$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $84b63352e7e6aba6$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$84b63352e7e6aba6$var$listeningMarker]) {
        rootContainerElement[$84b63352e7e6aba6$var$listeningMarker] = !0;
        $84b63352e7e6aba6$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($84b63352e7e6aba6$var$nonDelegatedEvents.has(domEventName) || $84b63352e7e6aba6$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $84b63352e7e6aba6$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$84b63352e7e6aba6$var$listeningMarker] || (ownerDocument[$84b63352e7e6aba6$var$listeningMarker] = !0, $84b63352e7e6aba6$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $84b63352e7e6aba6$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($84b63352e7e6aba6$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $84b63352e7e6aba6$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $84b63352e7e6aba6$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $84b63352e7e6aba6$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$84b63352e7e6aba6$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $84b63352e7e6aba6$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer || 8 === container.nodeType && container.parentNode === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if (3 === grandTag || 4 === grandTag) {
                    if (grandTag = nodeTag.stateNode.containerInfo, grandTag === targetContainer || 8 === grandTag.nodeType && grandTag.parentNode === targetContainer) return;
                }
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $84b63352e7e6aba6$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $84b63352e7e6aba6$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $84b63352e7e6aba6$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $84b63352e7e6aba6$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $84b63352e7e6aba6$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $84b63352e7e6aba6$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $84b63352e7e6aba6$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $84b63352e7e6aba6$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $84b63352e7e6aba6$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $84b63352e7e6aba6$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $84b63352e7e6aba6$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $84b63352e7e6aba6$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $84b63352e7e6aba6$var$SyntheticTouchEvent;
                        break;
                    case $84b63352e7e6aba6$var$ANIMATION_END:
                    case $84b63352e7e6aba6$var$ANIMATION_ITERATION:
                    case $84b63352e7e6aba6$var$ANIMATION_START:
                        SyntheticEventCtor = $84b63352e7e6aba6$var$SyntheticAnimationEvent;
                        break;
                    case $84b63352e7e6aba6$var$TRANSITION_END:
                        SyntheticEventCtor = $84b63352e7e6aba6$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $84b63352e7e6aba6$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $84b63352e7e6aba6$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $84b63352e7e6aba6$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $84b63352e7e6aba6$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $84b63352e7e6aba6$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $84b63352e7e6aba6$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($84b63352e7e6aba6$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $84b63352e7e6aba6$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($84b63352e7e6aba6$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$84b63352e7e6aba6$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $84b63352e7e6aba6$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $84b63352e7e6aba6$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $84b63352e7e6aba6$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $84b63352e7e6aba6$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $84b63352e7e6aba6$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $84b63352e7e6aba6$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $84b63352e7e6aba6$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $84b63352e7e6aba6$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $84b63352e7e6aba6$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $84b63352e7e6aba6$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $84b63352e7e6aba6$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $84b63352e7e6aba6$var$getParent(inCapturePhase);
                                reactEventName = $84b63352e7e6aba6$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $84b63352e7e6aba6$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $84b63352e7e6aba6$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $84b63352e7e6aba6$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $84b63352e7e6aba6$var$getTargetInstForChangeEvent;
                else if ($84b63352e7e6aba6$var$isTextInputElement(reactName)) {
                    if ($84b63352e7e6aba6$var$isInputEventSupported) getTargetInstFunc = $84b63352e7e6aba6$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $84b63352e7e6aba6$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $84b63352e7e6aba6$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $84b63352e7e6aba6$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $84b63352e7e6aba6$var$getTargetInstForChangeEvent) : getTargetInstFunc = $84b63352e7e6aba6$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $84b63352e7e6aba6$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $84b63352e7e6aba6$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $84b63352e7e6aba6$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($84b63352e7e6aba6$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $84b63352e7e6aba6$var$activeElement = handleEventFunc, $84b63352e7e6aba6$var$activeElementInst = targetInst, $84b63352e7e6aba6$var$lastSelection = null;
                    break;
                case "focusout":
                    $84b63352e7e6aba6$var$lastSelection = $84b63352e7e6aba6$var$activeElementInst = $84b63352e7e6aba6$var$activeElement = null;
                    break;
                case "mousedown":
                    $84b63352e7e6aba6$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $84b63352e7e6aba6$var$mouseDown = !1;
                    $84b63352e7e6aba6$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($84b63352e7e6aba6$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $84b63352e7e6aba6$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($84b63352e7e6aba6$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $84b63352e7e6aba6$var$isComposing ? $84b63352e7e6aba6$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($84b63352e7e6aba6$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($84b63352e7e6aba6$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $84b63352e7e6aba6$var$isComposing && (fallbackData = $84b63352e7e6aba6$var$getData()) : ($84b63352e7e6aba6$var$root = nativeEventTarget, $84b63352e7e6aba6$var$startText = "value" in $84b63352e7e6aba6$var$root ? $84b63352e7e6aba6$var$root.value : $84b63352e7e6aba6$var$root.textContent, $84b63352e7e6aba6$var$isComposing = !0)), handleEventFunc = $84b63352e7e6aba6$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $84b63352e7e6aba6$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $84b63352e7e6aba6$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $84b63352e7e6aba6$var$canUseTextInputEvent ? $84b63352e7e6aba6$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $84b63352e7e6aba6$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $84b63352e7e6aba6$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $84b63352e7e6aba6$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $84b63352e7e6aba6$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $84b63352e7e6aba6$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $84b63352e7e6aba6$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $84b63352e7e6aba6$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $84b63352e7e6aba6$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($84b63352e7e6aba6$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $84b63352e7e6aba6$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($84b63352e7e6aba6$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        targetFiber = targetFiber.return;
    }
    return listeners;
}
function $84b63352e7e6aba6$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $84b63352e7e6aba6$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $84b63352e7e6aba6$var$getListener(target, registrationName), null != stateNode && listeners.unshift($84b63352e7e6aba6$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $84b63352e7e6aba6$var$getListener(target, registrationName), null != stateNode && listeners.push($84b63352e7e6aba6$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $84b63352e7e6aba6$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $84b63352e7e6aba6$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $84b63352e7e6aba6$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($84b63352e7e6aba6$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($84b63352e7e6aba6$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $84b63352e7e6aba6$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $84b63352e7e6aba6$var$normalizeMarkupForTextOrAttribute(clientText);
    return $84b63352e7e6aba6$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $84b63352e7e6aba6$var$noop$1() {}
function $84b63352e7e6aba6$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $84b63352e7e6aba6$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $84b63352e7e6aba6$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $84b63352e7e6aba6$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $84b63352e7e6aba6$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $84b63352e7e6aba6$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $84b63352e7e6aba6$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $84b63352e7e6aba6$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $84b63352e7e6aba6$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $84b63352e7e6aba6$var$setProp(domElement, tag, "name", props.name, props, null), $84b63352e7e6aba6$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $84b63352e7e6aba6$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $84b63352e7e6aba6$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($84b63352e7e6aba6$var$setProp(domElement, tag, "encType", props.encType, props, null), $84b63352e7e6aba6$var$setProp(domElement, tag, "method", props.method, props, null), $84b63352e7e6aba6$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $84b63352e7e6aba6$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $84b63352e7e6aba6$var$noop$1);
            break;
        case "onScroll":
            null != value && $84b63352e7e6aba6$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $84b63352e7e6aba6$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $84b63352e7e6aba6$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("toggle", domElement);
            $84b63352e7e6aba6$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $84b63352e7e6aba6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $84b63352e7e6aba6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $84b63352e7e6aba6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $84b63352e7e6aba6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $84b63352e7e6aba6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $84b63352e7e6aba6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $84b63352e7e6aba6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $84b63352e7e6aba6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $84b63352e7e6aba6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $84b63352e7e6aba6$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $84b63352e7e6aba6$var$aliases.get(key) || key, $84b63352e7e6aba6$var$setValueForAttribute(domElement, key, value);
    }
}
function $84b63352e7e6aba6$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $84b63352e7e6aba6$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $84b63352e7e6aba6$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $84b63352e7e6aba6$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $84b63352e7e6aba6$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $84b63352e7e6aba6$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $84b63352e7e6aba6$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$84b63352e7e6aba6$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$84b63352e7e6aba6$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $84b63352e7e6aba6$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $84b63352e7e6aba6$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("error", domElement);
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(137, tag));
                    default:
                        $84b63352e7e6aba6$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $84b63352e7e6aba6$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $84b63352e7e6aba6$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$186 = props[hasSrc];
                if (null != propValue$186) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$186;
                        break;
                    case "type":
                        propValue = propValue$186;
                        break;
                    case "checked":
                        checked = propValue$186;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$186;
                        break;
                    case "value":
                        propKey = propValue$186;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$186;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$186) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $84b63352e7e6aba6$var$setProp(domElement, tag, hasSrc, propValue$186, props, null);
                }
            }
            $84b63352e7e6aba6$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $84b63352e7e6aba6$var$track(domElement);
            return;
        case "select":
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $84b63352e7e6aba6$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $84b63352e7e6aba6$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $84b63352e7e6aba6$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(91));
                    break;
                default:
                    $84b63352e7e6aba6$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $84b63352e7e6aba6$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $84b63352e7e6aba6$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $84b63352e7e6aba6$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("cancel", domElement);
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $84b63352e7e6aba6$var$mediaEventTypes.length; hasSrc++)$84b63352e7e6aba6$var$listenToNonDelegatedEvent($84b63352e7e6aba6$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("error", domElement);
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $84b63352e7e6aba6$var$listenToNonDelegatedEvent("error", domElement), $84b63352e7e6aba6$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(137, tag));
                default:
                    $84b63352e7e6aba6$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($84b63352e7e6aba6$var$isCustomElement(tag)) {
                for(propValue$186 in props)props.hasOwnProperty(propValue$186) && (hasSrc = props[propValue$186], void 0 !== hasSrc && $84b63352e7e6aba6$var$setPropOnCustomElement(domElement, tag, propValue$186, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $84b63352e7e6aba6$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $84b63352e7e6aba6$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $84b63352e7e6aba6$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$203 in nextProps){
                var propKey = nextProps[propKey$203];
                lastProp = lastProps[propKey$203];
                if (nextProps.hasOwnProperty(propKey$203) && (null != propKey || null != lastProp)) switch(propKey$203){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $84b63352e7e6aba6$var$setProp(domElement, tag, propKey$203, propKey, nextProps, lastProp);
                }
            }
            $84b63352e7e6aba6$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$203 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $84b63352e7e6aba6$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$203 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $84b63352e7e6aba6$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$203 ? $84b63352e7e6aba6$var$updateOptions(domElement, !!lastProps, propKey$203, !1) : !!nextProps !== !!lastProps && (null != tag ? $84b63352e7e6aba6$var$updateOptions(domElement, !!lastProps, tag, !0) : $84b63352e7e6aba6$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$203 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $84b63352e7e6aba6$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$203 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $84b63352e7e6aba6$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $84b63352e7e6aba6$var$updateTextarea(domElement, propKey$203, propKey);
            return;
        case "option":
            for(var propKey$219 in lastProps)if (propKey$203 = lastProps[propKey$219], lastProps.hasOwnProperty(propKey$219) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$219)) switch(propKey$219){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $84b63352e7e6aba6$var$setProp(domElement, tag, propKey$219, null, nextProps, propKey$203);
            }
            for(lastDefaultValue in nextProps)if (propKey$203 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$203 && "function" !== typeof propKey$203 && "symbol" !== typeof propKey$203;
                    break;
                default:
                    $84b63352e7e6aba6$var$setProp(domElement, tag, lastDefaultValue, propKey$203, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$224 in lastProps)propKey$203 = lastProps[propKey$224], lastProps.hasOwnProperty(propKey$224) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$224) && $84b63352e7e6aba6$var$setProp(domElement, tag, propKey$224, null, nextProps, propKey$203);
            for(checked in nextProps)if (propKey$203 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$203) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $84b63352e7e6aba6$var$setProp(domElement, tag, checked, propKey$203, nextProps, propKey);
            }
            return;
        default:
            if ($84b63352e7e6aba6$var$isCustomElement(tag)) {
                for(var propKey$229 in lastProps)propKey$203 = lastProps[propKey$229], lastProps.hasOwnProperty(propKey$229) && void 0 !== propKey$203 && !nextProps.hasOwnProperty(propKey$229) && $84b63352e7e6aba6$var$setPropOnCustomElement(domElement, tag, propKey$229, void 0, nextProps, propKey$203);
                for(defaultChecked in nextProps)propKey$203 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$203 === propKey || void 0 === propKey$203 && void 0 === propKey || $84b63352e7e6aba6$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$203, nextProps, propKey);
                return;
            }
    }
    for(var propKey$234 in lastProps)propKey$203 = lastProps[propKey$234], lastProps.hasOwnProperty(propKey$234) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$234) && $84b63352e7e6aba6$var$setProp(domElement, tag, propKey$234, null, nextProps, propKey$203);
    for(lastProp in nextProps)propKey$203 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$203 === propKey || null == propKey$203 && null == propKey || $84b63352e7e6aba6$var$setProp(domElement, tag, lastProp, propKey$203, nextProps, propKey);
}
var $84b63352e7e6aba6$var$eventsEnabled = null, $84b63352e7e6aba6$var$selectionInformation = null;
function $84b63352e7e6aba6$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $84b63352e7e6aba6$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $84b63352e7e6aba6$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $84b63352e7e6aba6$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $84b63352e7e6aba6$var$currentPopstateTransitionEvent = null;
function $84b63352e7e6aba6$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $84b63352e7e6aba6$var$currentPopstateTransitionEvent) return !1;
        $84b63352e7e6aba6$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $84b63352e7e6aba6$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $84b63352e7e6aba6$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $84b63352e7e6aba6$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $84b63352e7e6aba6$var$localPromise = "function" === typeof Promise ? Promise : void 0, $84b63352e7e6aba6$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $84b63352e7e6aba6$var$localPromise ? function(callback) {
    return $84b63352e7e6aba6$var$localPromise.resolve(null).then(callback).catch($84b63352e7e6aba6$var$handleErrorInNextTick);
} : $84b63352e7e6aba6$var$scheduleTimeout;
function $84b63352e7e6aba6$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $84b63352e7e6aba6$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $84b63352e7e6aba6$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" !== node && "$?" !== node && "$!" !== node || depth++;
        }
        node = nextNode;
    }while (node);
    $84b63352e7e6aba6$var$retryIfBlockedOn(suspenseInstance);
}
function $84b63352e7e6aba6$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $84b63352e7e6aba6$var$clearContainerSparingly(node);
                $84b63352e7e6aba6$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $84b63352e7e6aba6$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$84b63352e7e6aba6$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $84b63352e7e6aba6$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $84b63352e7e6aba6$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $84b63352e7e6aba6$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $84b63352e7e6aba6$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
function $84b63352e7e6aba6$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $84b63352e7e6aba6$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $84b63352e7e6aba6$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(451));
    }
}
var $84b63352e7e6aba6$var$preloadPropsMap = new Map(), $84b63352e7e6aba6$var$preconnectsSet = new Set();
function $84b63352e7e6aba6$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : container.ownerDocument;
}
var $84b63352e7e6aba6$var$previousDispatcher = $84b63352e7e6aba6$var$ReactDOMSharedInternals.d;
$84b63352e7e6aba6$var$ReactDOMSharedInternals.d = {
    f: $84b63352e7e6aba6$var$flushSyncWork,
    r: $84b63352e7e6aba6$var$requestFormReset,
    D: $84b63352e7e6aba6$var$prefetchDNS,
    C: $84b63352e7e6aba6$var$preconnect,
    L: $84b63352e7e6aba6$var$preload,
    m: $84b63352e7e6aba6$var$preloadModule,
    X: $84b63352e7e6aba6$var$preinitScript,
    S: $84b63352e7e6aba6$var$preinitStyle,
    M: $84b63352e7e6aba6$var$preinitModuleScript
};
function $84b63352e7e6aba6$var$flushSyncWork() {
    var previousWasRendering = $84b63352e7e6aba6$var$previousDispatcher.f(), wasRendering = $84b63352e7e6aba6$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $84b63352e7e6aba6$var$requestFormReset(form) {
    var formInst = $84b63352e7e6aba6$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $84b63352e7e6aba6$var$requestFormReset$1(formInst) : $84b63352e7e6aba6$var$previousDispatcher.r(form);
}
var $84b63352e7e6aba6$var$globalDocument = "undefined" === typeof document ? null : document;
function $84b63352e7e6aba6$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $84b63352e7e6aba6$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $84b63352e7e6aba6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $84b63352e7e6aba6$var$preconnectsSet.has(limitedEscapedHref) || ($84b63352e7e6aba6$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $84b63352e7e6aba6$var$setInitialProperties(href, "link", rel), $84b63352e7e6aba6$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $84b63352e7e6aba6$var$prefetchDNS(href) {
    $84b63352e7e6aba6$var$previousDispatcher.D(href);
    $84b63352e7e6aba6$var$preconnectAs("dns-prefetch", href, null);
}
function $84b63352e7e6aba6$var$preconnect(href, crossOrigin) {
    $84b63352e7e6aba6$var$previousDispatcher.C(href, crossOrigin);
    $84b63352e7e6aba6$var$preconnectAs("preconnect", href, crossOrigin);
}
function $84b63352e7e6aba6$var$preload(href, as, options) {
    $84b63352e7e6aba6$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $84b63352e7e6aba6$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $84b63352e7e6aba6$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $84b63352e7e6aba6$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $84b63352e7e6aba6$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $84b63352e7e6aba6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $84b63352e7e6aba6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $84b63352e7e6aba6$var$getStyleKey(href);
                break;
            case "script":
                key = $84b63352e7e6aba6$var$getScriptKey(href);
        }
        $84b63352e7e6aba6$var$preloadPropsMap.has(key) || (href = $84b63352e7e6aba6$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $84b63352e7e6aba6$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($84b63352e7e6aba6$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($84b63352e7e6aba6$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $84b63352e7e6aba6$var$setInitialProperties(as, "link", href), $84b63352e7e6aba6$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $84b63352e7e6aba6$var$preloadModule(href, options) {
    $84b63352e7e6aba6$var$previousDispatcher.m(href, options);
    var ownerDocument = $84b63352e7e6aba6$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $84b63352e7e6aba6$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $84b63352e7e6aba6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $84b63352e7e6aba6$var$getScriptKey(href);
        }
        if (!$84b63352e7e6aba6$var$preloadPropsMap.has(key) && (href = $84b63352e7e6aba6$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $84b63352e7e6aba6$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($84b63352e7e6aba6$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $84b63352e7e6aba6$var$setInitialProperties(as, "link", href);
            $84b63352e7e6aba6$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $84b63352e7e6aba6$var$preinitStyle(href, precedence, options) {
    $84b63352e7e6aba6$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $84b63352e7e6aba6$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $84b63352e7e6aba6$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $84b63352e7e6aba6$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($84b63352e7e6aba6$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $84b63352e7e6aba6$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $84b63352e7e6aba6$var$preloadPropsMap.get(key)) && $84b63352e7e6aba6$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $84b63352e7e6aba6$var$markNodeAsHoistable(link);
                $84b63352e7e6aba6$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $84b63352e7e6aba6$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $84b63352e7e6aba6$var$preinitScript(src, options) {
    $84b63352e7e6aba6$var$previousDispatcher.X(src, options);
    var ownerDocument = $84b63352e7e6aba6$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $84b63352e7e6aba6$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $84b63352e7e6aba6$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($84b63352e7e6aba6$var$getScriptSelectorFromKey(key)), resource || (src = $84b63352e7e6aba6$var$assign({
            src: src,
            async: !0
        }, options), (options = $84b63352e7e6aba6$var$preloadPropsMap.get(key)) && $84b63352e7e6aba6$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $84b63352e7e6aba6$var$markNodeAsHoistable(resource), $84b63352e7e6aba6$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $84b63352e7e6aba6$var$preinitModuleScript(src, options) {
    $84b63352e7e6aba6$var$previousDispatcher.M(src, options);
    var ownerDocument = $84b63352e7e6aba6$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $84b63352e7e6aba6$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $84b63352e7e6aba6$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($84b63352e7e6aba6$var$getScriptSelectorFromKey(key)), resource || (src = $84b63352e7e6aba6$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $84b63352e7e6aba6$var$preloadPropsMap.get(key)) && $84b63352e7e6aba6$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $84b63352e7e6aba6$var$markNodeAsHoistable(resource), $84b63352e7e6aba6$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $84b63352e7e6aba6$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $84b63352e7e6aba6$var$rootInstanceStackCursor.current) ? $84b63352e7e6aba6$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $84b63352e7e6aba6$var$getStyleKey(pendingProps.href), pendingProps = $84b63352e7e6aba6$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $84b63352e7e6aba6$var$getStyleKey(pendingProps.href);
                var styles$242 = $84b63352e7e6aba6$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$243 = styles$242.get(type);
                resource$243 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$243 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$242.set(type, resource$243), (styles$242 = JSCompiler_inline_result.querySelector($84b63352e7e6aba6$var$getStylesheetSelectorFromKey(type))) && !styles$242._p && (resource$243.instance = styles$242, resource$243.state.loading = 5), $84b63352e7e6aba6$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $84b63352e7e6aba6$var$preloadPropsMap.set(type, pendingProps), styles$242 || $84b63352e7e6aba6$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$243.state)));
                if (currentProps && null === currentResource) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(528, ""));
                return resource$243;
            }
            if (currentProps && null !== currentResource) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $84b63352e7e6aba6$var$getScriptKey(pendingProps), pendingProps = $84b63352e7e6aba6$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(444, type));
    }
}
function $84b63352e7e6aba6$var$getStyleKey(href) {
    return 'href="' + $84b63352e7e6aba6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $84b63352e7e6aba6$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $84b63352e7e6aba6$var$stylesheetPropsFromRawProps(rawProps) {
    return $84b63352e7e6aba6$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $84b63352e7e6aba6$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $84b63352e7e6aba6$var$setInitialProperties(key, "link", preloadProps), $84b63352e7e6aba6$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $84b63352e7e6aba6$var$getScriptKey(src) {
    return '[src="' + $84b63352e7e6aba6$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $84b63352e7e6aba6$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $84b63352e7e6aba6$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $84b63352e7e6aba6$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $84b63352e7e6aba6$var$markNodeAsHoistable(instance), instance;
            var styleProps = $84b63352e7e6aba6$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $84b63352e7e6aba6$var$markNodeAsHoistable(instance);
            $84b63352e7e6aba6$var$setInitialProperties(instance, "style", styleProps);
            $84b63352e7e6aba6$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $84b63352e7e6aba6$var$getStyleKey(props.href);
            var instance$248 = hoistableRoot.querySelector($84b63352e7e6aba6$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$248) return resource.state.loading |= 4, resource.instance = instance$248, $84b63352e7e6aba6$var$markNodeAsHoistable(instance$248), instance$248;
            instance = $84b63352e7e6aba6$var$stylesheetPropsFromRawProps(props);
            (styleProps = $84b63352e7e6aba6$var$preloadPropsMap.get(styleProps)) && $84b63352e7e6aba6$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$248 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $84b63352e7e6aba6$var$markNodeAsHoistable(instance$248);
            var linkInstance = instance$248;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $84b63352e7e6aba6$var$setInitialProperties(instance$248, "link", instance);
            resource.state.loading |= 4;
            $84b63352e7e6aba6$var$insertStylesheet(instance$248, props.precedence, hoistableRoot);
            return resource.instance = instance$248;
        case "script":
            instance$248 = $84b63352e7e6aba6$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($84b63352e7e6aba6$var$getScriptSelectorFromKey(instance$248))) return resource.instance = styleProps, $84b63352e7e6aba6$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $84b63352e7e6aba6$var$preloadPropsMap.get(instance$248)) instance = $84b63352e7e6aba6$var$assign({}, props), $84b63352e7e6aba6$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $84b63352e7e6aba6$var$markNodeAsHoistable(styleProps);
            $84b63352e7e6aba6$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $84b63352e7e6aba6$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $84b63352e7e6aba6$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $84b63352e7e6aba6$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $84b63352e7e6aba6$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $84b63352e7e6aba6$var$tagCaches = null;
function $84b63352e7e6aba6$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $84b63352e7e6aba6$var$tagCaches) {
        var cache = new Map();
        var caches = $84b63352e7e6aba6$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $84b63352e7e6aba6$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$84b63352e7e6aba6$var$internalHoistableMarker] || node[$84b63352e7e6aba6$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $84b63352e7e6aba6$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $84b63352e7e6aba6$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $84b63352e7e6aba6$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $84b63352e7e6aba6$var$suspendedState = null;
function $84b63352e7e6aba6$var$noop() {}
function $84b63352e7e6aba6$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $84b63352e7e6aba6$var$suspendedState) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(475));
    var state = $84b63352e7e6aba6$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $84b63352e7e6aba6$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($84b63352e7e6aba6$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $84b63352e7e6aba6$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $84b63352e7e6aba6$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $84b63352e7e6aba6$var$stylesheetPropsFromRawProps(props);
            (key = $84b63352e7e6aba6$var$preloadPropsMap.get(key)) && $84b63352e7e6aba6$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $84b63352e7e6aba6$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $84b63352e7e6aba6$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $84b63352e7e6aba6$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $84b63352e7e6aba6$var$waitForCommitToBeReady() {
    if (null === $84b63352e7e6aba6$var$suspendedState) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(475));
    var state = $84b63352e7e6aba6$var$suspendedState;
    state.stylesheets && 0 === state.count && $84b63352e7e6aba6$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $84b63352e7e6aba6$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $84b63352e7e6aba6$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $84b63352e7e6aba6$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $84b63352e7e6aba6$var$precedencesByRoot = null;
function $84b63352e7e6aba6$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $84b63352e7e6aba6$var$precedencesByRoot = new Map(), resources.forEach($84b63352e7e6aba6$var$insertStylesheetIntoRoot, state), $84b63352e7e6aba6$var$precedencesByRoot = null, $84b63352e7e6aba6$var$onUnsuspend.call(state));
}
function $84b63352e7e6aba6$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $84b63352e7e6aba6$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $84b63352e7e6aba6$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $84b63352e7e6aba6$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $84b63352e7e6aba6$var$HostTransitionContext = {
    $$typeof: $84b63352e7e6aba6$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $84b63352e7e6aba6$var$sharedNotPendingObject,
    _currentValue2: $84b63352e7e6aba6$var$sharedNotPendingObject,
    _threadCount: 0
};
function $84b63352e7e6aba6$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $84b63352e7e6aba6$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $84b63352e7e6aba6$var$createLaneMap(0);
    this.hiddenUpdates = $84b63352e7e6aba6$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $84b63352e7e6aba6$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $84b63352e7e6aba6$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $84b63352e7e6aba6$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $84b63352e7e6aba6$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $84b63352e7e6aba6$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $84b63352e7e6aba6$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $84b63352e7e6aba6$var$emptyContextObject;
    parentComponent = $84b63352e7e6aba6$var$emptyContextObject;
    return parentComponent;
}
function $84b63352e7e6aba6$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $84b63352e7e6aba6$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $84b63352e7e6aba6$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $84b63352e7e6aba6$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($84b63352e7e6aba6$var$scheduleUpdateOnFiber(element, rootFiber, lane), $84b63352e7e6aba6$var$entangleTransitions(element, rootFiber, lane));
}
function $84b63352e7e6aba6$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $84b63352e7e6aba6$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $84b63352e7e6aba6$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $84b63352e7e6aba6$var$markRetryLaneImpl(fiber, retryLane);
}
function $84b63352e7e6aba6$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $84b63352e7e6aba6$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $84b63352e7e6aba6$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $84b63352e7e6aba6$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $84b63352e7e6aba6$var$_enabled = !0;
function $84b63352e7e6aba6$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $84b63352e7e6aba6$var$ReactSharedInternals.T;
    $84b63352e7e6aba6$var$ReactSharedInternals.T = null;
    var previousPriority = $84b63352e7e6aba6$var$ReactDOMSharedInternals.p;
    try {
        $84b63352e7e6aba6$var$ReactDOMSharedInternals.p = 2, $84b63352e7e6aba6$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $84b63352e7e6aba6$var$ReactDOMSharedInternals.p = previousPriority, $84b63352e7e6aba6$var$ReactSharedInternals.T = prevTransition;
    }
}
function $84b63352e7e6aba6$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $84b63352e7e6aba6$var$ReactSharedInternals.T;
    $84b63352e7e6aba6$var$ReactSharedInternals.T = null;
    var previousPriority = $84b63352e7e6aba6$var$ReactDOMSharedInternals.p;
    try {
        $84b63352e7e6aba6$var$ReactDOMSharedInternals.p = 8, $84b63352e7e6aba6$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $84b63352e7e6aba6$var$ReactDOMSharedInternals.p = previousPriority, $84b63352e7e6aba6$var$ReactSharedInternals.T = prevTransition;
    }
}
function $84b63352e7e6aba6$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($84b63352e7e6aba6$var$_enabled) {
        var blockedOn = $84b63352e7e6aba6$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $84b63352e7e6aba6$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $84b63352e7e6aba6$var$return_targetInst, targetContainer), $84b63352e7e6aba6$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($84b63352e7e6aba6$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($84b63352e7e6aba6$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $84b63352e7e6aba6$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $84b63352e7e6aba6$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $84b63352e7e6aba6$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $84b63352e7e6aba6$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $84b63352e7e6aba6$var$ensureRootIsScheduled(fiber);
                                0 === ($84b63352e7e6aba6$var$executionContext & 6) && ($84b63352e7e6aba6$var$workInProgressRootRenderTargetTime = $84b63352e7e6aba6$var$now() + 500, $84b63352e7e6aba6$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $84b63352e7e6aba6$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $84b63352e7e6aba6$var$scheduleUpdateOnFiber(root, fiber, 2), $84b63352e7e6aba6$var$flushSyncWork$1(), $84b63352e7e6aba6$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $84b63352e7e6aba6$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $84b63352e7e6aba6$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $84b63352e7e6aba6$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $84b63352e7e6aba6$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $84b63352e7e6aba6$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $84b63352e7e6aba6$var$getEventTarget(nativeEvent);
    return $84b63352e7e6aba6$var$findInstanceBlockingTarget(nativeEvent);
}
var $84b63352e7e6aba6$var$return_targetInst = null;
function $84b63352e7e6aba6$var$findInstanceBlockingTarget(targetNode) {
    $84b63352e7e6aba6$var$return_targetInst = null;
    targetNode = $84b63352e7e6aba6$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $84b63352e7e6aba6$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $84b63352e7e6aba6$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $84b63352e7e6aba6$var$return_targetInst = targetNode;
    return null;
}
function $84b63352e7e6aba6$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($84b63352e7e6aba6$var$getCurrentPriorityLevel()){
                case $84b63352e7e6aba6$var$ImmediatePriority:
                    return 2;
                case $84b63352e7e6aba6$var$UserBlockingPriority:
                    return 8;
                case $84b63352e7e6aba6$var$NormalPriority$1:
                case $84b63352e7e6aba6$var$LowPriority:
                    return 32;
                case $84b63352e7e6aba6$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $84b63352e7e6aba6$var$hasScheduledReplayAttempt = !1, $84b63352e7e6aba6$var$queuedFocus = null, $84b63352e7e6aba6$var$queuedDrag = null, $84b63352e7e6aba6$var$queuedMouse = null, $84b63352e7e6aba6$var$queuedPointers = new Map(), $84b63352e7e6aba6$var$queuedPointerCaptures = new Map(), $84b63352e7e6aba6$var$queuedExplicitHydrationTargets = [], $84b63352e7e6aba6$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $84b63352e7e6aba6$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $84b63352e7e6aba6$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $84b63352e7e6aba6$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $84b63352e7e6aba6$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $84b63352e7e6aba6$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $84b63352e7e6aba6$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $84b63352e7e6aba6$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $84b63352e7e6aba6$var$getInstanceFromNode(blockedOn), null !== blockedOn && $84b63352e7e6aba6$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $84b63352e7e6aba6$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $84b63352e7e6aba6$var$queuedFocus = $84b63352e7e6aba6$var$accumulateOrCreateContinuousQueuedReplayableEvent($84b63352e7e6aba6$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $84b63352e7e6aba6$var$queuedDrag = $84b63352e7e6aba6$var$accumulateOrCreateContinuousQueuedReplayableEvent($84b63352e7e6aba6$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $84b63352e7e6aba6$var$queuedMouse = $84b63352e7e6aba6$var$accumulateOrCreateContinuousQueuedReplayableEvent($84b63352e7e6aba6$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $84b63352e7e6aba6$var$queuedPointers.set(pointerId, $84b63352e7e6aba6$var$accumulateOrCreateContinuousQueuedReplayableEvent($84b63352e7e6aba6$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $84b63352e7e6aba6$var$queuedPointerCaptures.set(pointerId, $84b63352e7e6aba6$var$accumulateOrCreateContinuousQueuedReplayableEvent($84b63352e7e6aba6$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $84b63352e7e6aba6$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $84b63352e7e6aba6$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $84b63352e7e6aba6$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $84b63352e7e6aba6$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $84b63352e7e6aba6$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $84b63352e7e6aba6$var$requestUpdateLane(), root = $84b63352e7e6aba6$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $84b63352e7e6aba6$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $84b63352e7e6aba6$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $84b63352e7e6aba6$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $84b63352e7e6aba6$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $84b63352e7e6aba6$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $84b63352e7e6aba6$var$currentReplayingEvent = null;
        } else return targetContainers = $84b63352e7e6aba6$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $84b63352e7e6aba6$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $84b63352e7e6aba6$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $84b63352e7e6aba6$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $84b63352e7e6aba6$var$replayUnblockedEvents() {
    $84b63352e7e6aba6$var$hasScheduledReplayAttempt = !1;
    null !== $84b63352e7e6aba6$var$queuedFocus && $84b63352e7e6aba6$var$attemptReplayContinuousQueuedEvent($84b63352e7e6aba6$var$queuedFocus) && ($84b63352e7e6aba6$var$queuedFocus = null);
    null !== $84b63352e7e6aba6$var$queuedDrag && $84b63352e7e6aba6$var$attemptReplayContinuousQueuedEvent($84b63352e7e6aba6$var$queuedDrag) && ($84b63352e7e6aba6$var$queuedDrag = null);
    null !== $84b63352e7e6aba6$var$queuedMouse && $84b63352e7e6aba6$var$attemptReplayContinuousQueuedEvent($84b63352e7e6aba6$var$queuedMouse) && ($84b63352e7e6aba6$var$queuedMouse = null);
    $84b63352e7e6aba6$var$queuedPointers.forEach($84b63352e7e6aba6$var$attemptReplayContinuousQueuedEventInMap);
    $84b63352e7e6aba6$var$queuedPointerCaptures.forEach($84b63352e7e6aba6$var$attemptReplayContinuousQueuedEventInMap);
}
function $84b63352e7e6aba6$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $84b63352e7e6aba6$var$hasScheduledReplayAttempt || ($84b63352e7e6aba6$var$hasScheduledReplayAttempt = !0, $4mq2P.unstable_scheduleCallback($4mq2P.unstable_NormalPriority, $84b63352e7e6aba6$var$replayUnblockedEvents)));
}
var $84b63352e7e6aba6$var$lastScheduledReplayQueue = null;
function $84b63352e7e6aba6$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $84b63352e7e6aba6$var$lastScheduledReplayQueue !== formReplayingQueue && ($84b63352e7e6aba6$var$lastScheduledReplayQueue = formReplayingQueue, $4mq2P.unstable_scheduleCallback($4mq2P.unstable_NormalPriority, function() {
        $84b63352e7e6aba6$var$lastScheduledReplayQueue === formReplayingQueue && ($84b63352e7e6aba6$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $84b63352e7e6aba6$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $84b63352e7e6aba6$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $84b63352e7e6aba6$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $84b63352e7e6aba6$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $84b63352e7e6aba6$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $84b63352e7e6aba6$var$queuedFocus && $84b63352e7e6aba6$var$scheduleCallbackIfUnblocked($84b63352e7e6aba6$var$queuedFocus, unblocked);
    null !== $84b63352e7e6aba6$var$queuedDrag && $84b63352e7e6aba6$var$scheduleCallbackIfUnblocked($84b63352e7e6aba6$var$queuedDrag, unblocked);
    null !== $84b63352e7e6aba6$var$queuedMouse && $84b63352e7e6aba6$var$scheduleCallbackIfUnblocked($84b63352e7e6aba6$var$queuedMouse, unblocked);
    $84b63352e7e6aba6$var$queuedPointers.forEach(unblock);
    $84b63352e7e6aba6$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $84b63352e7e6aba6$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $84b63352e7e6aba6$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $84b63352e7e6aba6$var$queuedExplicitHydrationTargets.length && (i = $84b63352e7e6aba6$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$84b63352e7e6aba6$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $84b63352e7e6aba6$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$84b63352e7e6aba6$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $84b63352e7e6aba6$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$84b63352e7e6aba6$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $84b63352e7e6aba6$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $84b63352e7e6aba6$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $84b63352e7e6aba6$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$84b63352e7e6aba6$var$ReactDOMHydrationRoot.prototype.render = $84b63352e7e6aba6$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(409));
    var current = root.current, lane = $84b63352e7e6aba6$var$requestUpdateLane();
    $84b63352e7e6aba6$var$updateContainerImpl(current, lane, children, root, null, null);
};
$84b63352e7e6aba6$var$ReactDOMHydrationRoot.prototype.unmount = $84b63352e7e6aba6$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        0 === root.tag && $84b63352e7e6aba6$var$flushPassiveEffects();
        $84b63352e7e6aba6$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $84b63352e7e6aba6$var$flushSyncWork$1();
        container[$84b63352e7e6aba6$var$internalContainerInstanceKey] = null;
    }
};
function $84b63352e7e6aba6$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$84b63352e7e6aba6$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $84b63352e7e6aba6$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $84b63352e7e6aba6$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $84b63352e7e6aba6$var$queuedExplicitHydrationTargets[i].priority; i++);
        $84b63352e7e6aba6$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $84b63352e7e6aba6$var$attemptExplicitHydrationTarget(target);
    }
};
var $84b63352e7e6aba6$var$isomorphicReactPackageVersion$jscomp$inline_1686 = $h5vr1.version;
if ("19.0.0" !== $84b63352e7e6aba6$var$isomorphicReactPackageVersion$jscomp$inline_1686) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(527, $84b63352e7e6aba6$var$isomorphicReactPackageVersion$jscomp$inline_1686, "19.0.0"));
$84b63352e7e6aba6$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $84b63352e7e6aba6$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $84b63352e7e6aba6$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $84b63352e7e6aba6$var$internals$jscomp$inline_2165 = {
    bundleType: 0,
    version: "19.0.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $84b63352e7e6aba6$var$ReactSharedInternals,
    findFiberByHostInstance: $84b63352e7e6aba6$var$getClosestInstanceFromNode,
    reconcilerVersion: "19.0.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $84b63352e7e6aba6$var$hook$jscomp$inline_2166 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$84b63352e7e6aba6$var$hook$jscomp$inline_2166.isDisabled && $84b63352e7e6aba6$var$hook$jscomp$inline_2166.supportsFiber) try {
        $84b63352e7e6aba6$var$rendererID = $84b63352e7e6aba6$var$hook$jscomp$inline_2166.inject($84b63352e7e6aba6$var$internals$jscomp$inline_2165), $84b63352e7e6aba6$var$injectedHook = $84b63352e7e6aba6$var$hook$jscomp$inline_2166;
    } catch (err) {}
}
$84b63352e7e6aba6$export$882461b6382ed46c = function(container, options) {
    if (!$84b63352e7e6aba6$var$isValidContainer(container)) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $84b63352e7e6aba6$var$defaultOnUncaughtError, onCaughtError = $84b63352e7e6aba6$var$defaultOnCaughtError, onRecoverableError = $84b63352e7e6aba6$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $84b63352e7e6aba6$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$84b63352e7e6aba6$var$internalContainerInstanceKey] = options.current;
    $84b63352e7e6aba6$var$listenToAllSupportedEvents(8 === container.nodeType ? container.parentNode : container);
    return new $84b63352e7e6aba6$var$ReactDOMRoot(options);
};
$84b63352e7e6aba6$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$84b63352e7e6aba6$var$isValidContainer(container)) throw Error($84b63352e7e6aba6$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $84b63352e7e6aba6$var$defaultOnUncaughtError, onCaughtError = $84b63352e7e6aba6$var$defaultOnCaughtError, onRecoverableError = $84b63352e7e6aba6$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $84b63352e7e6aba6$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $84b63352e7e6aba6$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $84b63352e7e6aba6$var$requestUpdateLane();
    identifierPrefix = $84b63352e7e6aba6$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $84b63352e7e6aba6$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    initialChildren.current.lanes = isStrictMode;
    $84b63352e7e6aba6$var$markRootUpdated$1(initialChildren, isStrictMode);
    $84b63352e7e6aba6$var$ensureRootIsScheduled(initialChildren);
    container[$84b63352e7e6aba6$var$internalContainerInstanceKey] = initialChildren.current;
    $84b63352e7e6aba6$var$listenToAllSupportedEvents(container);
    return new $84b63352e7e6aba6$var$ReactDOMHydrationRoot(initialChildren);
};
$84b63352e7e6aba6$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("4mq2P", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6JvY4"));

});
parcelRegister("6JvY4", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $4e6fbe2d0b9256bb$export$c4744153514ff05d, (v) => $4e6fbe2d0b9256bb$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $4e6fbe2d0b9256bb$export$3e506c1ccc9cc1a7, (v) => $4e6fbe2d0b9256bb$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $4e6fbe2d0b9256bb$export$e26fe2ed2fa76875, (v) => $4e6fbe2d0b9256bb$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $4e6fbe2d0b9256bb$export$502329bbf4b505b1, (v) => $4e6fbe2d0b9256bb$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $4e6fbe2d0b9256bb$export$6e3807111c4874c4, (v) => $4e6fbe2d0b9256bb$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $4e6fbe2d0b9256bb$export$c27134553091fb3a, (v) => $4e6fbe2d0b9256bb$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $4e6fbe2d0b9256bb$export$33ee1acdc04fd2a2, (v) => $4e6fbe2d0b9256bb$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $4e6fbe2d0b9256bb$export$b00a404bbd5edef2, (v) => $4e6fbe2d0b9256bb$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $4e6fbe2d0b9256bb$export$8352ce38b91d0c62, (v) => $4e6fbe2d0b9256bb$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $4e6fbe2d0b9256bb$export$d66a1c1c77bd778b, (v) => $4e6fbe2d0b9256bb$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $4e6fbe2d0b9256bb$export$d3dfb8e4810cb555, (v) => $4e6fbe2d0b9256bb$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $4e6fbe2d0b9256bb$export$839f9183b0465a69, (v) => $4e6fbe2d0b9256bb$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $4e6fbe2d0b9256bb$export$72fdf0e06517287b, (v) => $4e6fbe2d0b9256bb$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $4e6fbe2d0b9256bb$export$4b844e58a3e414b4, (v) => $4e6fbe2d0b9256bb$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $4e6fbe2d0b9256bb$export$816d2913ae6b83b1, (v) => $4e6fbe2d0b9256bb$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $4e6fbe2d0b9256bb$export$61bcfe829111a1d0, (v) => $4e6fbe2d0b9256bb$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $4e6fbe2d0b9256bb$export$7ee8c9beb337bc3f, (v) => $4e6fbe2d0b9256bb$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $4e6fbe2d0b9256bb$export$b5836b71941fa3ed, (v) => $4e6fbe2d0b9256bb$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $4e6fbe2d0b9256bb$export$cf845f2c119da08a, (v) => $4e6fbe2d0b9256bb$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4e6fbe2d0b9256bb$export$c4744153514ff05d;
var $4e6fbe2d0b9256bb$export$3e506c1ccc9cc1a7;
var $4e6fbe2d0b9256bb$export$e26fe2ed2fa76875;
var $4e6fbe2d0b9256bb$export$502329bbf4b505b1;
var $4e6fbe2d0b9256bb$export$6e3807111c4874c4;
var $4e6fbe2d0b9256bb$export$c27134553091fb3a;
var $4e6fbe2d0b9256bb$export$33ee1acdc04fd2a2;
var $4e6fbe2d0b9256bb$export$b00a404bbd5edef2;
var $4e6fbe2d0b9256bb$export$8352ce38b91d0c62;
var $4e6fbe2d0b9256bb$export$d66a1c1c77bd778b;
var $4e6fbe2d0b9256bb$export$d3dfb8e4810cb555;
var $4e6fbe2d0b9256bb$export$839f9183b0465a69;
var $4e6fbe2d0b9256bb$export$72fdf0e06517287b;
var $4e6fbe2d0b9256bb$export$4b844e58a3e414b4;
var $4e6fbe2d0b9256bb$export$816d2913ae6b83b1;
var $4e6fbe2d0b9256bb$export$61bcfe829111a1d0;
var $4e6fbe2d0b9256bb$export$7ee8c9beb337bc3f;
var $4e6fbe2d0b9256bb$export$b5836b71941fa3ed;
var $4e6fbe2d0b9256bb$export$cf845f2c119da08a;
"use strict";
function $4e6fbe2d0b9256bb$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $4e6fbe2d0b9256bb$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $4e6fbe2d0b9256bb$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $4e6fbe2d0b9256bb$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $4e6fbe2d0b9256bb$var$compare(left, last)) rightIndex < length && 0 > $4e6fbe2d0b9256bb$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $4e6fbe2d0b9256bb$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $4e6fbe2d0b9256bb$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$4e6fbe2d0b9256bb$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $4e6fbe2d0b9256bb$var$localPerformance = performance;
    $4e6fbe2d0b9256bb$export$c4744153514ff05d = function() {
        return $4e6fbe2d0b9256bb$var$localPerformance.now();
    };
} else {
    var $4e6fbe2d0b9256bb$var$localDate = Date, $4e6fbe2d0b9256bb$var$initialTime = $4e6fbe2d0b9256bb$var$localDate.now();
    $4e6fbe2d0b9256bb$export$c4744153514ff05d = function() {
        return $4e6fbe2d0b9256bb$var$localDate.now() - $4e6fbe2d0b9256bb$var$initialTime;
    };
}
var $4e6fbe2d0b9256bb$var$taskQueue = [], $4e6fbe2d0b9256bb$var$timerQueue = [], $4e6fbe2d0b9256bb$var$taskIdCounter = 1, $4e6fbe2d0b9256bb$var$currentTask = null, $4e6fbe2d0b9256bb$var$currentPriorityLevel = 3, $4e6fbe2d0b9256bb$var$isPerformingWork = !1, $4e6fbe2d0b9256bb$var$isHostCallbackScheduled = !1, $4e6fbe2d0b9256bb$var$isHostTimeoutScheduled = !1, $4e6fbe2d0b9256bb$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $4e6fbe2d0b9256bb$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $4e6fbe2d0b9256bb$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $4e6fbe2d0b9256bb$var$advanceTimers(currentTime) {
    for(var timer = $4e6fbe2d0b9256bb$var$peek($4e6fbe2d0b9256bb$var$timerQueue); null !== timer;){
        if (null === timer.callback) $4e6fbe2d0b9256bb$var$pop($4e6fbe2d0b9256bb$var$timerQueue);
        else if (timer.startTime <= currentTime) $4e6fbe2d0b9256bb$var$pop($4e6fbe2d0b9256bb$var$timerQueue), timer.sortIndex = timer.expirationTime, $4e6fbe2d0b9256bb$var$push($4e6fbe2d0b9256bb$var$taskQueue, timer);
        else break;
        timer = $4e6fbe2d0b9256bb$var$peek($4e6fbe2d0b9256bb$var$timerQueue);
    }
}
function $4e6fbe2d0b9256bb$var$handleTimeout(currentTime) {
    $4e6fbe2d0b9256bb$var$isHostTimeoutScheduled = !1;
    $4e6fbe2d0b9256bb$var$advanceTimers(currentTime);
    if (!$4e6fbe2d0b9256bb$var$isHostCallbackScheduled) {
        if (null !== $4e6fbe2d0b9256bb$var$peek($4e6fbe2d0b9256bb$var$taskQueue)) $4e6fbe2d0b9256bb$var$isHostCallbackScheduled = !0, $4e6fbe2d0b9256bb$var$requestHostCallback();
        else {
            var firstTimer = $4e6fbe2d0b9256bb$var$peek($4e6fbe2d0b9256bb$var$timerQueue);
            null !== firstTimer && $4e6fbe2d0b9256bb$var$requestHostTimeout($4e6fbe2d0b9256bb$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $4e6fbe2d0b9256bb$var$isMessageLoopRunning = !1, $4e6fbe2d0b9256bb$var$taskTimeoutID = -1, $4e6fbe2d0b9256bb$var$frameInterval = 5, $4e6fbe2d0b9256bb$var$startTime = -1;
function $4e6fbe2d0b9256bb$var$shouldYieldToHost() {
    return $4e6fbe2d0b9256bb$export$c4744153514ff05d() - $4e6fbe2d0b9256bb$var$startTime < $4e6fbe2d0b9256bb$var$frameInterval ? !1 : !0;
}
function $4e6fbe2d0b9256bb$var$performWorkUntilDeadline() {
    if ($4e6fbe2d0b9256bb$var$isMessageLoopRunning) {
        var currentTime = $4e6fbe2d0b9256bb$export$c4744153514ff05d();
        $4e6fbe2d0b9256bb$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $4e6fbe2d0b9256bb$var$isHostCallbackScheduled = !1;
                $4e6fbe2d0b9256bb$var$isHostTimeoutScheduled && ($4e6fbe2d0b9256bb$var$isHostTimeoutScheduled = !1, $4e6fbe2d0b9256bb$var$localClearTimeout($4e6fbe2d0b9256bb$var$taskTimeoutID), $4e6fbe2d0b9256bb$var$taskTimeoutID = -1);
                $4e6fbe2d0b9256bb$var$isPerformingWork = !0;
                var previousPriorityLevel = $4e6fbe2d0b9256bb$var$currentPriorityLevel;
                try {
                    b: {
                        $4e6fbe2d0b9256bb$var$advanceTimers(currentTime);
                        for($4e6fbe2d0b9256bb$var$currentTask = $4e6fbe2d0b9256bb$var$peek($4e6fbe2d0b9256bb$var$taskQueue); null !== $4e6fbe2d0b9256bb$var$currentTask && !($4e6fbe2d0b9256bb$var$currentTask.expirationTime > currentTime && $4e6fbe2d0b9256bb$var$shouldYieldToHost());){
                            var callback = $4e6fbe2d0b9256bb$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $4e6fbe2d0b9256bb$var$currentTask.callback = null;
                                $4e6fbe2d0b9256bb$var$currentPriorityLevel = $4e6fbe2d0b9256bb$var$currentTask.priorityLevel;
                                var continuationCallback = callback($4e6fbe2d0b9256bb$var$currentTask.expirationTime <= currentTime);
                                currentTime = $4e6fbe2d0b9256bb$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $4e6fbe2d0b9256bb$var$currentTask.callback = continuationCallback;
                                    $4e6fbe2d0b9256bb$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $4e6fbe2d0b9256bb$var$currentTask === $4e6fbe2d0b9256bb$var$peek($4e6fbe2d0b9256bb$var$taskQueue) && $4e6fbe2d0b9256bb$var$pop($4e6fbe2d0b9256bb$var$taskQueue);
                                $4e6fbe2d0b9256bb$var$advanceTimers(currentTime);
                            } else $4e6fbe2d0b9256bb$var$pop($4e6fbe2d0b9256bb$var$taskQueue);
                            $4e6fbe2d0b9256bb$var$currentTask = $4e6fbe2d0b9256bb$var$peek($4e6fbe2d0b9256bb$var$taskQueue);
                        }
                        if (null !== $4e6fbe2d0b9256bb$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $4e6fbe2d0b9256bb$var$peek($4e6fbe2d0b9256bb$var$timerQueue);
                            null !== firstTimer && $4e6fbe2d0b9256bb$var$requestHostTimeout($4e6fbe2d0b9256bb$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $4e6fbe2d0b9256bb$var$currentTask = null, $4e6fbe2d0b9256bb$var$currentPriorityLevel = previousPriorityLevel, $4e6fbe2d0b9256bb$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $4e6fbe2d0b9256bb$var$schedulePerformWorkUntilDeadline() : $4e6fbe2d0b9256bb$var$isMessageLoopRunning = !1;
        }
    }
}
var $4e6fbe2d0b9256bb$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $4e6fbe2d0b9256bb$var$localSetImmediate) $4e6fbe2d0b9256bb$var$schedulePerformWorkUntilDeadline = function() {
    $4e6fbe2d0b9256bb$var$localSetImmediate($4e6fbe2d0b9256bb$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $4e6fbe2d0b9256bb$var$channel = new MessageChannel(), $4e6fbe2d0b9256bb$var$port = $4e6fbe2d0b9256bb$var$channel.port2;
    $4e6fbe2d0b9256bb$var$channel.port1.onmessage = $4e6fbe2d0b9256bb$var$performWorkUntilDeadline;
    $4e6fbe2d0b9256bb$var$schedulePerformWorkUntilDeadline = function() {
        $4e6fbe2d0b9256bb$var$port.postMessage(null);
    };
} else $4e6fbe2d0b9256bb$var$schedulePerformWorkUntilDeadline = function() {
    $4e6fbe2d0b9256bb$var$localSetTimeout($4e6fbe2d0b9256bb$var$performWorkUntilDeadline, 0);
};
function $4e6fbe2d0b9256bb$var$requestHostCallback() {
    $4e6fbe2d0b9256bb$var$isMessageLoopRunning || ($4e6fbe2d0b9256bb$var$isMessageLoopRunning = !0, $4e6fbe2d0b9256bb$var$schedulePerformWorkUntilDeadline());
}
function $4e6fbe2d0b9256bb$var$requestHostTimeout(callback, ms) {
    $4e6fbe2d0b9256bb$var$taskTimeoutID = $4e6fbe2d0b9256bb$var$localSetTimeout(function() {
        callback($4e6fbe2d0b9256bb$export$c4744153514ff05d());
    }, ms);
}
$4e6fbe2d0b9256bb$export$3e506c1ccc9cc1a7 = 5;
$4e6fbe2d0b9256bb$export$e26fe2ed2fa76875 = 1;
$4e6fbe2d0b9256bb$export$502329bbf4b505b1 = 4;
$4e6fbe2d0b9256bb$export$6e3807111c4874c4 = 3;
$4e6fbe2d0b9256bb$export$c27134553091fb3a = null;
$4e6fbe2d0b9256bb$export$33ee1acdc04fd2a2 = 2;
$4e6fbe2d0b9256bb$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$4e6fbe2d0b9256bb$export$8352ce38b91d0c62 = function() {
    $4e6fbe2d0b9256bb$var$isHostCallbackScheduled || $4e6fbe2d0b9256bb$var$isPerformingWork || ($4e6fbe2d0b9256bb$var$isHostCallbackScheduled = !0, $4e6fbe2d0b9256bb$var$requestHostCallback());
};
$4e6fbe2d0b9256bb$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $4e6fbe2d0b9256bb$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$4e6fbe2d0b9256bb$export$d3dfb8e4810cb555 = function() {
    return $4e6fbe2d0b9256bb$var$currentPriorityLevel;
};
$4e6fbe2d0b9256bb$export$839f9183b0465a69 = function() {
    return $4e6fbe2d0b9256bb$var$peek($4e6fbe2d0b9256bb$var$taskQueue);
};
$4e6fbe2d0b9256bb$export$72fdf0e06517287b = function(eventHandler) {
    switch($4e6fbe2d0b9256bb$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $4e6fbe2d0b9256bb$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $4e6fbe2d0b9256bb$var$currentPriorityLevel;
    $4e6fbe2d0b9256bb$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $4e6fbe2d0b9256bb$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$4e6fbe2d0b9256bb$export$4b844e58a3e414b4 = function() {};
$4e6fbe2d0b9256bb$export$816d2913ae6b83b1 = function() {};
$4e6fbe2d0b9256bb$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $4e6fbe2d0b9256bb$var$currentPriorityLevel;
    $4e6fbe2d0b9256bb$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $4e6fbe2d0b9256bb$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$4e6fbe2d0b9256bb$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $4e6fbe2d0b9256bb$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $4e6fbe2d0b9256bb$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $4e6fbe2d0b9256bb$var$push($4e6fbe2d0b9256bb$var$timerQueue, priorityLevel), null === $4e6fbe2d0b9256bb$var$peek($4e6fbe2d0b9256bb$var$taskQueue) && priorityLevel === $4e6fbe2d0b9256bb$var$peek($4e6fbe2d0b9256bb$var$timerQueue) && ($4e6fbe2d0b9256bb$var$isHostTimeoutScheduled ? ($4e6fbe2d0b9256bb$var$localClearTimeout($4e6fbe2d0b9256bb$var$taskTimeoutID), $4e6fbe2d0b9256bb$var$taskTimeoutID = -1) : $4e6fbe2d0b9256bb$var$isHostTimeoutScheduled = !0, $4e6fbe2d0b9256bb$var$requestHostTimeout($4e6fbe2d0b9256bb$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $4e6fbe2d0b9256bb$var$push($4e6fbe2d0b9256bb$var$taskQueue, priorityLevel), $4e6fbe2d0b9256bb$var$isHostCallbackScheduled || $4e6fbe2d0b9256bb$var$isPerformingWork || ($4e6fbe2d0b9256bb$var$isHostCallbackScheduled = !0, $4e6fbe2d0b9256bb$var$requestHostCallback()));
    return priorityLevel;
};
$4e6fbe2d0b9256bb$export$b5836b71941fa3ed = $4e6fbe2d0b9256bb$var$shouldYieldToHost;
$4e6fbe2d0b9256bb$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $4e6fbe2d0b9256bb$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $4e6fbe2d0b9256bb$var$currentPriorityLevel;
        $4e6fbe2d0b9256bb$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $4e6fbe2d0b9256bb$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("h5vr1", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2jkU8"));

});

parcelRegister("kxWH7", function(module, exports) {
'use strict';
function $ef546b363ace2b10$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($ef546b363ace2b10$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$ef546b363ace2b10$var$checkDCE();

module.exports = (parcelRequire("ds4Mo"));

});
parcelRegister("ds4Mo", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $9cb198ffe841f5e2$export$69ce8ef3fe5cead0, (v) => $9cb198ffe841f5e2$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $9cb198ffe841f5e2$export$d39a5bbd09211389, (v) => $9cb198ffe841f5e2$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $9cb198ffe841f5e2$export$cd75ccfd720a3cd4, (v) => $9cb198ffe841f5e2$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $9cb198ffe841f5e2$export$a0816fa17a9e79be, (v) => $9cb198ffe841f5e2$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $9cb198ffe841f5e2$export$7292efcadded39f3, (v) => $9cb198ffe841f5e2$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $9cb198ffe841f5e2$export$da407abadb9b8f86, (v) => $9cb198ffe841f5e2$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $9cb198ffe841f5e2$export$314cfea32580671c, (v) => $9cb198ffe841f5e2$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $9cb198ffe841f5e2$export$513ccb98c53b8039, (v) => $9cb198ffe841f5e2$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $9cb198ffe841f5e2$export$dbca993bc2d264a, (v) => $9cb198ffe841f5e2$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $9cb198ffe841f5e2$export$4797a8006f0655d0, (v) => $9cb198ffe841f5e2$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $9cb198ffe841f5e2$export$c78a37762a8d58e1, (v) => $9cb198ffe841f5e2$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $9cb198ffe841f5e2$export$606f11b2eb45ecc6, (v) => $9cb198ffe841f5e2$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $9cb198ffe841f5e2$export$f7e8a0bf92324b1e, (v) => $9cb198ffe841f5e2$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $9cb198ffe841f5e2$export$83d89fbfd8236492, (v) => $9cb198ffe841f5e2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9cb198ffe841f5e2$export$69ce8ef3fe5cead0;
var $9cb198ffe841f5e2$export$d39a5bbd09211389;
var $9cb198ffe841f5e2$export$cd75ccfd720a3cd4;
var $9cb198ffe841f5e2$export$a0816fa17a9e79be;
var $9cb198ffe841f5e2$export$7292efcadded39f3;
var $9cb198ffe841f5e2$export$da407abadb9b8f86;
var $9cb198ffe841f5e2$export$314cfea32580671c;
var $9cb198ffe841f5e2$export$513ccb98c53b8039;
var $9cb198ffe841f5e2$export$dbca993bc2d264a;
var $9cb198ffe841f5e2$export$4797a8006f0655d0;
var $9cb198ffe841f5e2$export$c78a37762a8d58e1;
var $9cb198ffe841f5e2$export$606f11b2eb45ecc6;
var $9cb198ffe841f5e2$export$f7e8a0bf92324b1e;
var $9cb198ffe841f5e2$export$83d89fbfd8236492;
"use strict";

var $h5vr1 = parcelRequire("h5vr1");
function $9cb198ffe841f5e2$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $9cb198ffe841f5e2$var$noop() {}
var $9cb198ffe841f5e2$var$Internals = {
    d: {
        f: $9cb198ffe841f5e2$var$noop,
        r: function() {
            throw Error($9cb198ffe841f5e2$var$formatProdErrorMessage(522));
        },
        D: $9cb198ffe841f5e2$var$noop,
        C: $9cb198ffe841f5e2$var$noop,
        L: $9cb198ffe841f5e2$var$noop,
        m: $9cb198ffe841f5e2$var$noop,
        X: $9cb198ffe841f5e2$var$noop,
        S: $9cb198ffe841f5e2$var$noop,
        M: $9cb198ffe841f5e2$var$noop
    },
    p: 0,
    findDOMNode: null
}, $9cb198ffe841f5e2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $9cb198ffe841f5e2$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $9cb198ffe841f5e2$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $9cb198ffe841f5e2$var$ReactSharedInternals = $h5vr1.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $9cb198ffe841f5e2$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$9cb198ffe841f5e2$export$69ce8ef3fe5cead0 = $9cb198ffe841f5e2$var$Internals;
$9cb198ffe841f5e2$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($9cb198ffe841f5e2$var$formatProdErrorMessage(299));
    return $9cb198ffe841f5e2$var$createPortal$1(children, container, null, key);
};
$9cb198ffe841f5e2$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $9cb198ffe841f5e2$var$ReactSharedInternals.T, previousUpdatePriority = $9cb198ffe841f5e2$var$Internals.p;
    try {
        if ($9cb198ffe841f5e2$var$ReactSharedInternals.T = null, $9cb198ffe841f5e2$var$Internals.p = 2, fn) return fn();
    } finally{
        $9cb198ffe841f5e2$var$ReactSharedInternals.T = previousTransition, $9cb198ffe841f5e2$var$Internals.p = previousUpdatePriority, $9cb198ffe841f5e2$var$Internals.d.f();
    }
};
$9cb198ffe841f5e2$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $9cb198ffe841f5e2$var$Internals.d.C(href, options));
};
$9cb198ffe841f5e2$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $9cb198ffe841f5e2$var$Internals.d.D(href);
};
$9cb198ffe841f5e2$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $9cb198ffe841f5e2$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $9cb198ffe841f5e2$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $9cb198ffe841f5e2$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$9cb198ffe841f5e2$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $9cb198ffe841f5e2$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $9cb198ffe841f5e2$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $9cb198ffe841f5e2$var$Internals.d.M(href);
    }
};
$9cb198ffe841f5e2$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $9cb198ffe841f5e2$var$getCrossOriginStringAs(as, options.crossOrigin);
        $9cb198ffe841f5e2$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$9cb198ffe841f5e2$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $9cb198ffe841f5e2$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $9cb198ffe841f5e2$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $9cb198ffe841f5e2$var$Internals.d.m(href);
    }
};
$9cb198ffe841f5e2$export$4797a8006f0655d0 = function(form) {
    $9cb198ffe841f5e2$var$Internals.d.r(form);
};
$9cb198ffe841f5e2$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$9cb198ffe841f5e2$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $9cb198ffe841f5e2$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$9cb198ffe841f5e2$export$f7e8a0bf92324b1e = function() {
    return $9cb198ffe841f5e2$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$9cb198ffe841f5e2$export$83d89fbfd8236492 = "19.0.0";

});



var $0ba4b23d4df9096e$exports = {};
'use strict';

$0ba4b23d4df9096e$exports = (parcelRequire("9VihW"));



var $h5vr1 = parcelRequire("h5vr1");
var $96cc4d1b2f01a6e0$exports = {};
'use strict';
function $96cc4d1b2f01a6e0$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($96cc4d1b2f01a6e0$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$96cc4d1b2f01a6e0$var$checkDCE();

$96cc4d1b2f01a6e0$exports = (parcelRequire("boq7L"));




var $h5vr1 = parcelRequire("h5vr1");
// src/index.ts
// src/hooks/useChain.ts
// src/index.ts
var $7d76cf194f836d34$var$updateQueue = $7d76cf194f836d34$var$makeQueue();
var $7d76cf194f836d34$export$27f233d61a9e2fa4 = (fn)=>$7d76cf194f836d34$var$schedule(fn, $7d76cf194f836d34$var$updateQueue);
var $7d76cf194f836d34$var$writeQueue = $7d76cf194f836d34$var$makeQueue();
$7d76cf194f836d34$export$27f233d61a9e2fa4.write = (fn)=>$7d76cf194f836d34$var$schedule(fn, $7d76cf194f836d34$var$writeQueue);
var $7d76cf194f836d34$var$onStartQueue = $7d76cf194f836d34$var$makeQueue();
$7d76cf194f836d34$export$27f233d61a9e2fa4.onStart = (fn)=>$7d76cf194f836d34$var$schedule(fn, $7d76cf194f836d34$var$onStartQueue);
var $7d76cf194f836d34$var$onFrameQueue = $7d76cf194f836d34$var$makeQueue();
$7d76cf194f836d34$export$27f233d61a9e2fa4.onFrame = (fn)=>$7d76cf194f836d34$var$schedule(fn, $7d76cf194f836d34$var$onFrameQueue);
var $7d76cf194f836d34$var$onFinishQueue = $7d76cf194f836d34$var$makeQueue();
$7d76cf194f836d34$export$27f233d61a9e2fa4.onFinish = (fn)=>$7d76cf194f836d34$var$schedule(fn, $7d76cf194f836d34$var$onFinishQueue);
var $7d76cf194f836d34$var$timeouts = [];
$7d76cf194f836d34$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $7d76cf194f836d34$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $7d76cf194f836d34$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $7d76cf194f836d34$var$timeouts.splice(i, 1);
        $7d76cf194f836d34$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $7d76cf194f836d34$var$timeouts.splice($7d76cf194f836d34$var$findTimeout(time), 0, timeout);
    $7d76cf194f836d34$var$pendingCount += 1;
    $7d76cf194f836d34$var$start();
    return timeout;
};
var $7d76cf194f836d34$var$findTimeout = (time)=>~(~$7d76cf194f836d34$var$timeouts.findIndex((t)=>t.time > time) || ~$7d76cf194f836d34$var$timeouts.length);
$7d76cf194f836d34$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $7d76cf194f836d34$var$onStartQueue.delete(fn);
    $7d76cf194f836d34$var$onFrameQueue.delete(fn);
    $7d76cf194f836d34$var$onFinishQueue.delete(fn);
    $7d76cf194f836d34$var$updateQueue.delete(fn);
    $7d76cf194f836d34$var$writeQueue.delete(fn);
};
$7d76cf194f836d34$export$27f233d61a9e2fa4.sync = (fn)=>{
    $7d76cf194f836d34$var$sync = true;
    $7d76cf194f836d34$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $7d76cf194f836d34$var$sync = false;
};
$7d76cf194f836d34$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $7d76cf194f836d34$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $7d76cf194f836d34$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $7d76cf194f836d34$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
$7d76cf194f836d34$export$27f233d61a9e2fa4.use = (impl)=>$7d76cf194f836d34$var$nativeRaf = impl;
$7d76cf194f836d34$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$7d76cf194f836d34$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$7d76cf194f836d34$export$27f233d61a9e2fa4.catch = console.error;
$7d76cf194f836d34$export$27f233d61a9e2fa4.frameLoop = "always";
$7d76cf194f836d34$export$27f233d61a9e2fa4.advance = ()=>{
    if ($7d76cf194f836d34$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $7d76cf194f836d34$var$update();
};
var $7d76cf194f836d34$var$ts = -1;
var $7d76cf194f836d34$var$pendingCount = 0;
var $7d76cf194f836d34$var$sync = false;
function $7d76cf194f836d34$var$schedule(fn, queue) {
    if ($7d76cf194f836d34$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $7d76cf194f836d34$var$start();
    }
}
function $7d76cf194f836d34$var$start() {
    if ($7d76cf194f836d34$var$ts < 0) {
        $7d76cf194f836d34$var$ts = 0;
        if ($7d76cf194f836d34$export$27f233d61a9e2fa4.frameLoop !== "demand") $7d76cf194f836d34$var$nativeRaf($7d76cf194f836d34$var$loop);
    }
}
function $7d76cf194f836d34$var$stop() {
    $7d76cf194f836d34$var$ts = -1;
}
function $7d76cf194f836d34$var$loop() {
    if (~$7d76cf194f836d34$var$ts) {
        $7d76cf194f836d34$var$nativeRaf($7d76cf194f836d34$var$loop);
        $7d76cf194f836d34$export$27f233d61a9e2fa4.batchedUpdates($7d76cf194f836d34$var$update);
    }
}
function $7d76cf194f836d34$var$update() {
    const prevTs = $7d76cf194f836d34$var$ts;
    $7d76cf194f836d34$var$ts = $7d76cf194f836d34$export$27f233d61a9e2fa4.now();
    const count = $7d76cf194f836d34$var$findTimeout($7d76cf194f836d34$var$ts);
    if (count) {
        $7d76cf194f836d34$var$eachSafely($7d76cf194f836d34$var$timeouts.splice(0, count), (t)=>t.handler());
        $7d76cf194f836d34$var$pendingCount -= count;
    }
    if (!$7d76cf194f836d34$var$pendingCount) {
        $7d76cf194f836d34$var$stop();
        return;
    }
    $7d76cf194f836d34$var$onStartQueue.flush();
    $7d76cf194f836d34$var$updateQueue.flush(prevTs ? Math.min(64, $7d76cf194f836d34$var$ts - prevTs) : 16.667);
    $7d76cf194f836d34$var$onFrameQueue.flush();
    $7d76cf194f836d34$var$writeQueue.flush();
    $7d76cf194f836d34$var$onFinishQueue.flush();
}
function $7d76cf194f836d34$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $7d76cf194f836d34$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $7d76cf194f836d34$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $7d76cf194f836d34$var$pendingCount -= current.size;
                $7d76cf194f836d34$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $7d76cf194f836d34$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $7d76cf194f836d34$var$eachSafely(values, each) {
    values.forEach((value)=>{
        try {
            each(value);
        } catch (e) {
            $7d76cf194f836d34$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
var $7d76cf194f836d34$export$ef91a23fc803e177 = {
    /** The number of pending tasks */ count () {
        return $7d76cf194f836d34$var$pendingCount;
    },
    /** Whether there's a raf update loop running */ isRunning () {
        return $7d76cf194f836d34$var$ts >= 0;
    },
    /** Clear internal state. Never call from update loop! */ clear () {
        $7d76cf194f836d34$var$ts = -1;
        $7d76cf194f836d34$var$timeouts = [];
        $7d76cf194f836d34$var$onStartQueue = $7d76cf194f836d34$var$makeQueue();
        $7d76cf194f836d34$var$updateQueue = $7d76cf194f836d34$var$makeQueue();
        $7d76cf194f836d34$var$onFrameQueue = $7d76cf194f836d34$var$makeQueue();
        $7d76cf194f836d34$var$writeQueue = $7d76cf194f836d34$var$makeQueue();
        $7d76cf194f836d34$var$onFinishQueue = $7d76cf194f836d34$var$makeQueue();
        $7d76cf194f836d34$var$pendingCount = 0;
    }
};



var $h5vr1 = parcelRequire("h5vr1");
var $92af15b8a2030588$var$__defProp = Object.defineProperty;
var $92af15b8a2030588$var$__export = (target, all)=>{
    for(var name in all)$92af15b8a2030588$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $92af15b8a2030588$export$cceeabf822b64fc0 = {};
$92af15b8a2030588$var$__export($92af15b8a2030588$export$cceeabf822b64fc0, {
    assign: ()=>$92af15b8a2030588$var$assign,
    colors: ()=>$92af15b8a2030588$var$colors,
    createStringInterpolator: ()=>$92af15b8a2030588$var$createStringInterpolator,
    skipAnimation: ()=>$92af15b8a2030588$var$skipAnimation,
    to: ()=>$92af15b8a2030588$var$to,
    willAdvance: ()=>$92af15b8a2030588$var$willAdvance
});
// src/helpers.ts
function $92af15b8a2030588$export$8793edee2d425525() {}
var $92af15b8a2030588$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
var $92af15b8a2030588$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function $92af15b8a2030588$export$248d38f6296296c5(a, b) {
    if ($92af15b8a2030588$export$226b3eccf92c9ed9.arr(a)) {
        if (!$92af15b8a2030588$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $92af15b8a2030588$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $92af15b8a2030588$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($92af15b8a2030588$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $92af15b8a2030588$export$45b10814cc054894 = (a)=>$92af15b8a2030588$export$226b3eccf92c9ed9.und(a) ? [] : $92af15b8a2030588$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $92af15b8a2030588$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $92af15b8a2030588$export$79b2f7037acddd43(items, iterator);
    }
}
var $92af15b8a2030588$export$7ba486852759e806 = (queue, ...args)=>$92af15b8a2030588$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
var $92af15b8a2030588$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var $92af15b8a2030588$var$createStringInterpolator;
var $92af15b8a2030588$var$to;
var $92af15b8a2030588$var$colors = null;
var $92af15b8a2030588$var$skipAnimation = false;
var $92af15b8a2030588$var$willAdvance = $92af15b8a2030588$export$8793edee2d425525;
var $92af15b8a2030588$var$assign = (globals)=>{
    if (globals.to) $92af15b8a2030588$var$to = globals.to;
    if (globals.now) (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).now = globals.now;
    if (globals.colors !== void 0) $92af15b8a2030588$var$colors = globals.colors;
    if (globals.skipAnimation != null) $92af15b8a2030588$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $92af15b8a2030588$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $92af15b8a2030588$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).frameLoop = globals.frameLoop;
};
var $92af15b8a2030588$var$startQueue = /* @__PURE__ */ new Set();
var $92af15b8a2030588$var$currentFrame = [];
var $92af15b8a2030588$var$prevFrame = [];
var $92af15b8a2030588$var$priority = 0;
var $92af15b8a2030588$export$a57f5080a3bcc90a = {
    get idle () {
        return !$92af15b8a2030588$var$startQueue.size && !$92af15b8a2030588$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($92af15b8a2030588$var$priority > animation.priority) {
            $92af15b8a2030588$var$startQueue.add(animation);
            (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).onStart($92af15b8a2030588$var$flushStartQueue);
        } else {
            $92af15b8a2030588$var$startSafely(animation);
            (0, $7d76cf194f836d34$export$27f233d61a9e2fa4)($92af15b8a2030588$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $92af15b8a2030588$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($92af15b8a2030588$var$priority) (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).onFrame(()=>$92af15b8a2030588$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $92af15b8a2030588$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $92af15b8a2030588$var$currentFrame.splice(prevIndex, 1);
                $92af15b8a2030588$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        $92af15b8a2030588$var$currentFrame = [];
        $92af15b8a2030588$var$startQueue.clear();
    }
};
function $92af15b8a2030588$var$flushStartQueue() {
    $92af15b8a2030588$var$startQueue.forEach($92af15b8a2030588$var$startSafely);
    $92af15b8a2030588$var$startQueue.clear();
    (0, $7d76cf194f836d34$export$27f233d61a9e2fa4)($92af15b8a2030588$var$advance);
}
function $92af15b8a2030588$var$startSafely(animation) {
    if (!$92af15b8a2030588$var$currentFrame.includes(animation)) $92af15b8a2030588$var$startUnsafely(animation);
}
function $92af15b8a2030588$var$startUnsafely(animation) {
    $92af15b8a2030588$var$currentFrame.splice($92af15b8a2030588$var$findIndex($92af15b8a2030588$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $92af15b8a2030588$var$advance(dt) {
    const nextFrame = $92af15b8a2030588$var$prevFrame;
    for(let i = 0; i < $92af15b8a2030588$var$currentFrame.length; i++){
        const animation = $92af15b8a2030588$var$currentFrame[i];
        $92af15b8a2030588$var$priority = animation.priority;
        if (!animation.idle) {
            $92af15b8a2030588$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $92af15b8a2030588$var$priority = 0;
    $92af15b8a2030588$var$prevFrame = $92af15b8a2030588$var$currentFrame;
    $92af15b8a2030588$var$prevFrame.length = 0;
    $92af15b8a2030588$var$currentFrame = nextFrame;
    return $92af15b8a2030588$var$currentFrame.length > 0;
}
function $92af15b8a2030588$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $92af15b8a2030588$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var $92af15b8a2030588$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $92af15b8a2030588$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $92af15b8a2030588$var$PERCENTAGE = $92af15b8a2030588$var$NUMBER + "%";
function $92af15b8a2030588$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $92af15b8a2030588$export$8972dc0e6ad9238f = new RegExp("rgb" + $92af15b8a2030588$var$call($92af15b8a2030588$var$NUMBER, $92af15b8a2030588$var$NUMBER, $92af15b8a2030588$var$NUMBER));
var $92af15b8a2030588$export$4e46ac54fc82cf3b = new RegExp("rgba" + $92af15b8a2030588$var$call($92af15b8a2030588$var$NUMBER, $92af15b8a2030588$var$NUMBER, $92af15b8a2030588$var$NUMBER, $92af15b8a2030588$var$NUMBER));
var $92af15b8a2030588$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $92af15b8a2030588$var$call($92af15b8a2030588$var$NUMBER, $92af15b8a2030588$var$PERCENTAGE, $92af15b8a2030588$var$PERCENTAGE));
var $92af15b8a2030588$export$810b04175080204c = new RegExp("hsla" + $92af15b8a2030588$var$call($92af15b8a2030588$var$NUMBER, $92af15b8a2030588$var$PERCENTAGE, $92af15b8a2030588$var$PERCENTAGE, $92af15b8a2030588$var$NUMBER));
var $92af15b8a2030588$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $92af15b8a2030588$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $92af15b8a2030588$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $92af15b8a2030588$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $92af15b8a2030588$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $92af15b8a2030588$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($92af15b8a2030588$var$colors && $92af15b8a2030588$var$colors[color] !== void 0) return $92af15b8a2030588$var$colors[color];
    if (match = $92af15b8a2030588$export$8972dc0e6ad9238f.exec(color)) return ($92af15b8a2030588$var$parse255(match[1]) << 24 | // r
    $92af15b8a2030588$var$parse255(match[2]) << 16 | // g
    $92af15b8a2030588$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $92af15b8a2030588$export$4e46ac54fc82cf3b.exec(color)) return ($92af15b8a2030588$var$parse255(match[1]) << 24 | // r
    $92af15b8a2030588$var$parse255(match[2]) << 16 | // g
    $92af15b8a2030588$var$parse255(match[3]) << 8 | // b
    $92af15b8a2030588$var$parse1(match[4])) >>> // a
    0;
    if (match = $92af15b8a2030588$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $92af15b8a2030588$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $92af15b8a2030588$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $92af15b8a2030588$export$8f4a7c0bb78e6ea8.exec(color)) return ($92af15b8a2030588$var$hslToRgb($92af15b8a2030588$var$parse360(match[1]), // h
    $92af15b8a2030588$var$parsePercentage(match[2]), // s
    $92af15b8a2030588$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $92af15b8a2030588$export$810b04175080204c.exec(color)) return ($92af15b8a2030588$var$hslToRgb($92af15b8a2030588$var$parse360(match[1]), // h
    $92af15b8a2030588$var$parsePercentage(match[2]), // s
    $92af15b8a2030588$var$parsePercentage(match[3])) | $92af15b8a2030588$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $92af15b8a2030588$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $92af15b8a2030588$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $92af15b8a2030588$var$hue2rgb(p, q, h + 1 / 3);
    const g = $92af15b8a2030588$var$hue2rgb(p, q, h);
    const b = $92af15b8a2030588$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $92af15b8a2030588$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $92af15b8a2030588$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $92af15b8a2030588$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $92af15b8a2030588$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function $92af15b8a2030588$export$61db176b839af1f(input) {
    let int32Color = $92af15b8a2030588$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var $92af15b8a2030588$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($92af15b8a2030588$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($92af15b8a2030588$export$226b3eccf92c9ed9.arr(range)) return $92af15b8a2030588$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($92af15b8a2030588$export$226b3eccf92c9ed9.str(range.output[0])) return $92af15b8a2030588$var$createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = $92af15b8a2030588$var$findRange(input, inputRange);
        return $92af15b8a2030588$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $92af15b8a2030588$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $92af15b8a2030588$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $92af15b8a2030588$var$steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $92af15b8a2030588$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
var $92af15b8a2030588$var$c1 = 1.70158;
var $92af15b8a2030588$var$c2 = $92af15b8a2030588$var$c1 * 1.525;
var $92af15b8a2030588$var$c3 = $92af15b8a2030588$var$c1 + 1;
var $92af15b8a2030588$var$c4 = 2 * Math.PI / 3;
var $92af15b8a2030588$var$c5 = 2 * Math.PI / 4.5;
var $92af15b8a2030588$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $92af15b8a2030588$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$92af15b8a2030588$var$c3 * x * x * x - $92af15b8a2030588$var$c1 * x * x,
    easeOutBack: (x)=>1 + $92af15b8a2030588$var$c3 * Math.pow(x - 1, 3) + $92af15b8a2030588$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($92af15b8a2030588$var$c2 + 1) * 2 * x - $92af15b8a2030588$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($92af15b8a2030588$var$c2 + 1) * (x * 2 - 2) + $92af15b8a2030588$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $92af15b8a2030588$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $92af15b8a2030588$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $92af15b8a2030588$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $92af15b8a2030588$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $92af15b8a2030588$var$bounceOut(1 - x),
    easeOutBounce: $92af15b8a2030588$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $92af15b8a2030588$var$bounceOut(1 - 2 * x)) / 2 : (1 + $92af15b8a2030588$var$bounceOut(2 * x - 1)) / 2,
    steps: $92af15b8a2030588$var$steps
};
// src/fluids.ts
var $92af15b8a2030588$var$$get = Symbol.for("FluidValue.get");
var $92af15b8a2030588$var$$observers = Symbol.for("FluidValue.observers");
var $92af15b8a2030588$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$92af15b8a2030588$var$$get]);
var $92af15b8a2030588$export$e37b7520edd66839 = (arg)=>arg && arg[$92af15b8a2030588$var$$get] ? arg[$92af15b8a2030588$var$$get]() : arg;
var $92af15b8a2030588$export$133f54e9f7cf1796 = (target)=>target[$92af15b8a2030588$var$$observers] || null;
function $92af15b8a2030588$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $92af15b8a2030588$export$31752c40a5fab62a(target, event) {
    const observers = target[$92af15b8a2030588$var$$observers];
    if (observers) observers.forEach((observer2)=>{
        $92af15b8a2030588$export$8cbca1207adce0c0(observer2, event);
    });
}
$92af15b8a2030588$var$$get, $92af15b8a2030588$var$$observers;
var $92af15b8a2030588$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $92af15b8a2030588$export$a3b4618659637aa3(this, get);
    }
};
var $92af15b8a2030588$export$a3b4618659637aa3 = (target, get)=>$92af15b8a2030588$var$setHidden(target, $92af15b8a2030588$var$$get, get);
function $92af15b8a2030588$export$72d604e3f8d000a5(target, observer2) {
    if (target[$92af15b8a2030588$var$$get]) {
        let observers = target[$92af15b8a2030588$var$$observers];
        if (!observers) $92af15b8a2030588$var$setHidden(target, $92af15b8a2030588$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $92af15b8a2030588$export$7a0eb830d336339b(target, observer2) {
    const observers = target[$92af15b8a2030588$var$$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$92af15b8a2030588$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $92af15b8a2030588$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var $92af15b8a2030588$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $92af15b8a2030588$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $92af15b8a2030588$var$unitRegex = new RegExp(`(${$92af15b8a2030588$var$numberRegex.source})(%|[a-z]+)`, "i");
var $92af15b8a2030588$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $92af15b8a2030588$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $92af15b8a2030588$var$variableToRgba = (input)=>{
    const [token, fallback] = $92af15b8a2030588$var$parseCSSVariable(input);
    if (!token || $92af15b8a2030588$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $92af15b8a2030588$var$cssVariableRegex.test(fallback)) return $92af15b8a2030588$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $92af15b8a2030588$var$parseCSSVariable = (current)=>{
    const match = $92af15b8a2030588$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $92af15b8a2030588$var$namedColorRegex;
var $92af15b8a2030588$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var $92af15b8a2030588$export$4759a013d387347a = (config)=>{
    if (!$92af15b8a2030588$var$namedColorRegex) $92af15b8a2030588$var$namedColorRegex = $92af15b8a2030588$var$colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys($92af15b8a2030588$var$colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return $92af15b8a2030588$export$e37b7520edd66839(value).replace($92af15b8a2030588$var$cssVariableRegex, $92af15b8a2030588$var$variableToRgba).replace($92af15b8a2030588$var$colorRegex, $92af15b8a2030588$export$61db176b839af1f).replace($92af15b8a2030588$var$namedColorRegex, $92af15b8a2030588$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($92af15b8a2030588$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>$92af15b8a2030588$export$b12af43b97697ef5({
            ...config,
            output: output2
        }));
    return (input)=>{
        const missingUnit = !$92af15b8a2030588$var$unitRegex.test(output[0]) && output.find((value)=>$92af15b8a2030588$var$unitRegex.test(value))?.replace($92af15b8a2030588$var$numberRegex, "");
        let i = 0;
        return output[0].replace($92af15b8a2030588$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($92af15b8a2030588$var$rgbaRegex, $92af15b8a2030588$var$rgbaRound);
    };
};
// src/deprecations.ts
var $92af15b8a2030588$export$82e9f45cca5ba907 = "react-spring: ";
var $92af15b8a2030588$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$92af15b8a2030588$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var $92af15b8a2030588$var$warnInterpolate = $92af15b8a2030588$export$d2de3aaeafa91619(console.warn);
function $92af15b8a2030588$export$2abfcde8ae218ba8() {
    $92af15b8a2030588$var$warnInterpolate(`${$92af15b8a2030588$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var $92af15b8a2030588$var$warnDirectCall = $92af15b8a2030588$export$d2de3aaeafa91619(console.warn);
function $92af15b8a2030588$export$d99d974913ad3b12() {
    $92af15b8a2030588$var$warnDirectCall(`${$92af15b8a2030588$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function $92af15b8a2030588$export$75bed621f62abfa9(value) {
    return $92af15b8a2030588$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$92af15b8a2030588$export$48d7c418edadb60c() && $92af15b8a2030588$var$cssVariableRegex.test(value) || value in ($92af15b8a2030588$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $92af15b8a2030588$var$observer;
var $92af15b8a2030588$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $92af15b8a2030588$var$handleObservation = (entries)=>entries.forEach(({ target: target, contentRect: contentRect })=>{
        return $92af15b8a2030588$var$resizeHandlers.get(target)?.forEach((handler)=>handler(contentRect));
    });
function $92af15b8a2030588$var$resizeElement(handler, target) {
    if (!$92af15b8a2030588$var$observer) {
        if (typeof ResizeObserver !== "undefined") $92af15b8a2030588$var$observer = new ResizeObserver($92af15b8a2030588$var$handleObservation);
    }
    let elementHandlers = $92af15b8a2030588$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $92af15b8a2030588$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($92af15b8a2030588$var$observer) $92af15b8a2030588$var$observer.observe(target);
    return ()=>{
        const elementHandlers2 = $92af15b8a2030588$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && $92af15b8a2030588$var$observer) $92af15b8a2030588$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $92af15b8a2030588$var$listeners = /* @__PURE__ */ new Set();
var $92af15b8a2030588$var$cleanupWindowResizeHandler;
var $92af15b8a2030588$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $92af15b8a2030588$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var $92af15b8a2030588$var$resizeWindow = (callback)=>{
    $92af15b8a2030588$var$listeners.add(callback);
    if (!$92af15b8a2030588$var$cleanupWindowResizeHandler) $92af15b8a2030588$var$cleanupWindowResizeHandler = $92af15b8a2030588$var$createResizeHandler();
    return ()=>{
        $92af15b8a2030588$var$listeners.delete(callback);
        if (!$92af15b8a2030588$var$listeners.size && $92af15b8a2030588$var$cleanupWindowResizeHandler) {
            $92af15b8a2030588$var$cleanupWindowResizeHandler();
            $92af15b8a2030588$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $92af15b8a2030588$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement } = {})=>{
    if (container === document.documentElement) return $92af15b8a2030588$var$resizeWindow(callback);
    else return $92af15b8a2030588$var$resizeElement(callback, container);
};
// src/progress.ts
var $92af15b8a2030588$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var $92af15b8a2030588$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $92af15b8a2030588$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length, position: position } = $92af15b8a2030588$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container[`scroll${length}`] - this.container[`client${length}`];
            axis.progress = $92af15b8a2030588$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var $92af15b8a2030588$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $92af15b8a2030588$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $92af15b8a2030588$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $92af15b8a2030588$var$getTarget = (container)=>container === document.documentElement ? window : container;
var $92af15b8a2030588$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement } = {})=>{
    let containerHandlers = $92af15b8a2030588$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $92af15b8a2030588$var$onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new $92af15b8a2030588$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$92af15b8a2030588$var$scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers?.forEach((handler)=>handler.advance());
            return true;
        };
        $92af15b8a2030588$var$scrollListeners.set(container, listener);
        const target = $92af15b8a2030588$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $92af15b8a2030588$var$resizeListeners.set(container, $92af15b8a2030588$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $92af15b8a2030588$var$scrollListeners.get(container);
    (0, $7d76cf194f836d34$export$27f233d61a9e2fa4)(animateScroll);
    return ()=>{
        (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).cancel(animateScroll);
        const containerHandlers2 = $92af15b8a2030588$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = $92af15b8a2030588$var$scrollListeners.get(container);
        $92af15b8a2030588$var$scrollListeners.delete(container);
        if (listener) {
            $92af15b8a2030588$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            $92af15b8a2030588$var$resizeListeners.get(container)?.();
        }
    };
};
function $92af15b8a2030588$export$fe4300aa8eebea86(init) {
    const ref = (0, $h5vr1.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $92af15b8a2030588$export$700979bc83e7db82 = $92af15b8a2030588$export$48d7c418edadb60c() ? (0, $h5vr1.useEffect) : (0, $h5vr1.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $92af15b8a2030588$var$useIsMounted = ()=>{
    const isMounted = (0, $h5vr1.useRef)(false);
    $92af15b8a2030588$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $92af15b8a2030588$export$91db9bc4f8ac944a() {
    const update = (0, $h5vr1.useState)()[1];
    const isMounted = $92af15b8a2030588$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update(Math.random());
    };
}
function $92af15b8a2030588$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $h5vr1.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $h5vr1.useRef)(void 0);
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $92af15b8a2030588$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $h5vr1.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $92af15b8a2030588$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $92af15b8a2030588$export$392544347a18b6ea = (effect)=>(0, $h5vr1.useEffect)(effect, $92af15b8a2030588$var$emptyDeps);
var $92af15b8a2030588$var$emptyDeps = [];
function $92af15b8a2030588$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $h5vr1.useRef)(void 0);
    (0, $h5vr1.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var $92af15b8a2030588$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $h5vr1.useState)(null);
    $92af15b8a2030588$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $92af15b8a2030588$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        if (mql.addEventListener) mql.addEventListener("change", handleMediaChange);
        else mql.addListener(handleMediaChange);
        return ()=>{
            if (mql.removeEventListener) mql.removeEventListener("change", handleMediaChange);
            else mql.removeListener(handleMediaChange);
        };
    }, []);
    return reducedMotion;
};



var $h5vr1 = parcelRequire("h5vr1");
// src/Animated.ts


var $h5vr1 = parcelRequire("h5vr1");
var $8e9f814fe52bc087$var$$node = Symbol.for("Animated:node");
var $8e9f814fe52bc087$export$3df5e165e801a70f = (value)=>!!value && value[$8e9f814fe52bc087$var$$node] === value;
var $8e9f814fe52bc087$export$6b63995194a3a9e4 = (owner)=>owner && owner[$8e9f814fe52bc087$var$$node];
var $8e9f814fe52bc087$export$b553cb5b22b81b04 = (owner, node)=>(0, $92af15b8a2030588$export$5c74248ea0e35446)(owner, $8e9f814fe52bc087$var$$node, node);
var $8e9f814fe52bc087$export$ccab2b64c5d440 = (owner)=>owner && owner[$8e9f814fe52bc087$var$$node] && owner[$8e9f814fe52bc087$var$$node].getPayload();
var $8e9f814fe52bc087$export$31627395a3b18e54 = class {
    constructor(){
        $8e9f814fe52bc087$export$b553cb5b22b81b04(this, this);
    }
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
};
var $8e9f814fe52bc087$export$cb1e8f3c05d37ad5 = class _AnimatedValue extends $8e9f814fe52bc087$export$31627395a3b18e54 {
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).num(this._value)) this.lastPosition = this._value;
    }
    /** @internal */ static create(value) {
        return new _AnimatedValue(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
};
var $8e9f814fe52bc087$export$f6c6c4cbd7fa5b93 = class _AnimatedString extends $8e9f814fe52bc087$export$cb1e8f3c05d37ad5 {
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $92af15b8a2030588$export$b12af43b97697ef5)({
            output: [
                value,
                value
            ]
        });
    }
    /** @internal */ static create(value) {
        return new _AnimatedString(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $92af15b8a2030588$export$b12af43b97697ef5)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
};
// src/context.ts
var $8e9f814fe52bc087$var$TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var $8e9f814fe52bc087$export$f1b0b9e366a6e2d4 = class extends $8e9f814fe52bc087$export$31627395a3b18e54 {
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
    getValue(animated) {
        const values = {};
        (0, $92af15b8a2030588$export$f4c6fe153f5a944e)(this.source, (source, key)=>{
            if ($8e9f814fe52bc087$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $92af15b8a2030588$export$57ea7e3a7f6280c7)(source)) values[key] = (0, $92af15b8a2030588$export$e37b7520edd66839)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $92af15b8a2030588$export$79b2f7037acddd43)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $92af15b8a2030588$export$f4c6fe153f5a944e)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($8e9f814fe52bc087$var$TreeContext.dependencies && (0, $92af15b8a2030588$export$57ea7e3a7f6280c7)(source)) $8e9f814fe52bc087$var$TreeContext.dependencies.add(source);
        const payload = $8e9f814fe52bc087$export$ccab2b64c5d440(source);
        if (payload) (0, $92af15b8a2030588$export$79b2f7037acddd43)(payload, (node)=>this.add(node));
    }
};
// src/AnimatedArray.ts
var $8e9f814fe52bc087$export$ede394683406942d = class _AnimatedArray extends $8e9f814fe52bc087$export$f1b0b9e366a6e2d4 {
    constructor(source){
        super(source);
    }
    /** @internal */ static create(source) {
        return new _AnimatedArray(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($8e9f814fe52bc087$var$makeAnimated));
        return true;
    }
};
function $8e9f814fe52bc087$var$makeAnimated(value) {
    const nodeType = (0, $92af15b8a2030588$export$75bed621f62abfa9)(value) ? $8e9f814fe52bc087$export$f6c6c4cbd7fa5b93 : $8e9f814fe52bc087$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $8e9f814fe52bc087$export$e6b77ddbe47b132e(value) {
    const parentNode = $8e9f814fe52bc087$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $92af15b8a2030588$export$226b3eccf92c9ed9).arr(value) ? $8e9f814fe52bc087$export$ede394683406942d : (0, $92af15b8a2030588$export$75bed621f62abfa9)(value) ? $8e9f814fe52bc087$export$f6c6c4cbd7fa5b93 : $8e9f814fe52bc087$export$cb1e8f3c05d37ad5;
}
var $8e9f814fe52bc087$var$withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $h5vr1.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $h5vr1.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $h5vr1.useCallback)((value)=>{
            instanceRef.current = $8e9f814fe52bc087$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $8e9f814fe52bc087$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $92af15b8a2030588$export$91db9bc4f8ac944a)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $8e9f814fe52bc087$var$PropsObserver(callback, deps);
        const observerRef = (0, $h5vr1.useRef)(void 0);
        (0, $92af15b8a2030588$export$700979bc83e7db82)(()=>{
            observerRef.current = observer;
            (0, $92af15b8a2030588$export$79b2f7037acddd43)(deps, (dep)=>(0, $92af15b8a2030588$export$72d604e3f8d000a5)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $92af15b8a2030588$export$79b2f7037acddd43)(observerRef.current.deps, (dep)=>(0, $92af15b8a2030588$export$7a0eb830d336339b)(dep, observerRef.current));
                    (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).cancel(observerRef.current.update);
                }
            };
        });
        (0, $h5vr1.useEffect)(callback, []);
        (0, $92af15b8a2030588$export$392544347a18b6ea)(()=>()=>{
                const observer2 = observerRef.current;
                (0, $92af15b8a2030588$export$79b2f7037acddd43)(observer2.deps, (dep)=>(0, $92af15b8a2030588$export$7a0eb830d336339b)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $h5vr1.createElement(Component, {
            ...usedProps,
            ref: ref
        });
    });
};
var $8e9f814fe52bc087$var$PropsObserver = class {
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
    eventObserved(event) {
        if (event.type == "change") (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).write(this.update);
    }
};
function $8e9f814fe52bc087$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $8e9f814fe52bc087$var$TreeContext.dependencies = dependencies;
    if (props.style) props = {
        ...props,
        style: host.createAnimatedStyle(props.style)
    };
    props = new $8e9f814fe52bc087$export$f1b0b9e366a6e2d4(props);
    $8e9f814fe52bc087$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $8e9f814fe52bc087$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var $8e9f814fe52bc087$var$cacheKey = Symbol.for("AnimatedComponent");
var $8e9f814fe52bc087$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false, createAnimatedStyle: createAnimatedStyle = (style)=>new $8e9f814fe52bc087$export$f1b0b9e366a6e2d4(style), getComponentProps: getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $8e9f814fe52bc087$var$getDisplayName(Component) || "Anonymous";
        if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).str(Component)) Component = animated[Component] || (animated[Component] = $8e9f814fe52bc087$var$withAnimated(Component, hostConfig));
        else Component = Component[$8e9f814fe52bc087$var$cacheKey] || (Component[$8e9f814fe52bc087$var$cacheKey] = $8e9f814fe52bc087$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $92af15b8a2030588$export$f4c6fe153f5a944e)(components, (Component, key)=>{
        if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).arr(components)) key = $8e9f814fe52bc087$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $8e9f814fe52bc087$var$getDisplayName = (arg)=>(0, $92af15b8a2030588$export$226b3eccf92c9ed9).str(arg) ? arg : arg && (0, $92af15b8a2030588$export$226b3eccf92c9ed9).str(arg.displayName) ? arg.displayName : (0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(arg) && arg.name || null;


// src/utils.ts
var $643ec99bbc3fa7f6$export$b24b633b1364b94b = class {
};


function $343926dea5af6acd$var$callProp(value, ...args) {
    return (0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(value) ? value(...args) : value;
}
var $343926dea5af6acd$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(value) ? value(key) : (0, $92af15b8a2030588$export$45b10814cc054894)(value).includes(key)));
var $343926dea5af6acd$var$resolveProp = (prop, key)=>(0, $92af15b8a2030588$export$226b3eccf92c9ed9).obj(prop) ? key && prop[key] : prop;
var $343926dea5af6acd$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var $343926dea5af6acd$var$noopTransform = (value)=>value;
var $343926dea5af6acd$var$getDefaultProps = (props, transform = $343926dea5af6acd$var$noopTransform)=>{
    let keys = $343926dea5af6acd$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var $343926dea5af6acd$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $343926dea5af6acd$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function $343926dea5af6acd$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $92af15b8a2030588$export$f4c6fe153f5a944e)(props, (value, prop)=>{
        if (!$343926dea5af6acd$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $343926dea5af6acd$export$b971039a739bf227(props) {
    const to2 = $343926dea5af6acd$var$getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, $92af15b8a2030588$export$f4c6fe153f5a944e)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return {
        ...props
    };
}
function $343926dea5af6acd$var$computeGoal(value) {
    value = (0, $92af15b8a2030588$export$e37b7520edd66839)(value);
    return (0, $92af15b8a2030588$export$226b3eccf92c9ed9).arr(value) ? value.map($343926dea5af6acd$var$computeGoal) : (0, $92af15b8a2030588$export$75bed621f62abfa9)(value) ? (0, $92af15b8a2030588$export$cceeabf822b64fc0).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $343926dea5af6acd$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $343926dea5af6acd$var$isAsyncTo(to2) {
    return (0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(to2) || (0, $92af15b8a2030588$export$226b3eccf92c9ed9).arr(to2) && (0, $92af15b8a2030588$export$226b3eccf92c9ed9).obj(to2[0]);
}
function $343926dea5af6acd$var$detachRefs(ctrl, ref) {
    ctrl.ref?.delete(ctrl);
    ref?.delete(ctrl);
}
function $343926dea5af6acd$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        ctrl.ref?.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function $343926dea5af6acd$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $92af15b8a2030588$export$700979bc83e7db82)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $92af15b8a2030588$export$79b2f7037acddd43)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $92af15b8a2030588$export$79b2f7037acddd43)(controllers, (ctrl)=>{
                        (0, $92af15b8a2030588$export$79b2f7037acddd43)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $343926dea5af6acd$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $92af15b8a2030588$export$79b2f7037acddd43)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $92af15b8a2030588$export$79b2f7037acddd43)(controllers, (ctrl, i)=>(0, $92af15b8a2030588$export$79b2f7037acddd43)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var $343926dea5af6acd$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var $343926dea5af6acd$var$defaults = {
    ...$343926dea5af6acd$export$e506a1d27d1eaa20.default,
    mass: 1,
    damping: 1,
    easing: (0, $92af15b8a2030588$export$15a0bf1b4bbacad8).linear,
    clamp: false
};
var $343926dea5af6acd$var$AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, $343926dea5af6acd$var$defaults);
    }
};
function $343926dea5af6acd$var$mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = {
            ...defaultConfig
        };
        $343926dea5af6acd$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = {
            ...defaultConfig,
            ...newConfig
        };
    }
    $343926dea5af6acd$var$sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in $343926dea5af6acd$var$defaults)if (config2[key] == null) config2[key] = $343926dea5af6acd$var$defaults[key];
    let { frequency: frequency, damping: damping } = config2;
    const { mass: mass } = config2;
    if (!(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function $343926dea5af6acd$var$sanitizeConfig(config2, props) {
    if (!(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(props.tension) || !(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(props.friction);
        if (isTensionConfig || !(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(props.frequency) || !(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(props.damping) || !(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var $343926dea5af6acd$var$emptyArray = [];
var $343926dea5af6acd$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $343926dea5af6acd$var$emptyArray;
        this.toValues = null;
        this.fromValues = $343926dea5af6acd$var$emptyArray;
        this.config = new $343926dea5af6acd$var$AnimationConfig();
        this.immediate = false;
    }
};
function $343926dea5af6acd$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        let cancel = $343926dea5af6acd$var$matchProp(props.cancel ?? defaultProps?.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(props.pause)) state.paused = $343926dea5af6acd$var$matchProp(props.pause, key);
            let pause = defaultProps?.pause;
            if (pause !== true) pause = state.paused || $343926dea5af6acd$var$matchProp(pause, key);
            delay = $343926dea5af6acd$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $92af15b8a2030588$export$cceeabf822b64fc0).skipAnimation) {
                state.delayed = true;
                timeout = (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start({
                    ...props,
                    callId: callId,
                    cancel: cancel
                }, resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var $343926dea5af6acd$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $343926dea5af6acd$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $343926dea5af6acd$var$getNoopResult(target.get()) : $343926dea5af6acd$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
var $343926dea5af6acd$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
var $343926dea5af6acd$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
var $343926dea5af6acd$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function $343926dea5af6acd$var$runAsync(to2, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = $343926dea5af6acd$var$getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && $343926dea5af6acd$var$getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && $343926dea5af6acd$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $343926dea5af6acd$export$d362d093fa99dc7();
            const skipAnimationSignal = new $343926dea5af6acd$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $92af15b8a2030588$export$cceeabf822b64fc0).skipAnimation) {
                    $343926dea5af6acd$var$stopAsync(state);
                    skipAnimationSignal.result = $343926dea5af6acd$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, $92af15b8a2030588$export$226b3eccf92c9ed9).obj(arg1) ? {
                    ...arg1
                } : {
                    ...arg2,
                    to: arg1
                };
                props2.parentId = callId;
                (0, $92af15b8a2030588$export$f4c6fe153f5a944e)(defaultProps, (value, key)=>{
                    if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, $92af15b8a2030588$export$cceeabf822b64fc0).skipAnimation) {
            $343926dea5af6acd$var$stopAsync(state);
            return $343926dea5af6acd$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $343926dea5af6acd$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $343926dea5af6acd$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $343926dea5af6acd$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(onRest)) (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $343926dea5af6acd$var$stopAsync(state, cancelId) {
    (0, $92af15b8a2030588$export$4909b86c8034bf73)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var $343926dea5af6acd$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $343926dea5af6acd$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var $343926dea5af6acd$var$isFrameValue = (value)=>value instanceof $343926dea5af6acd$export$8229896f80e2495e;
var $343926dea5af6acd$var$nextId = 1;
var $343926dea5af6acd$export$8229896f80e2495e = class extends (0, $92af15b8a2030588$export$aff8e1ac1a016a2) {
    constructor(){
        super(...arguments);
        this.id = $343926dea5af6acd$var$nextId++;
        this._priority = 0;
    }
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $8e9f814fe52bc087$export$6b63995194a3a9e4)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $92af15b8a2030588$export$cceeabf822b64fc0).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $92af15b8a2030588$export$2abfcde8ae218ba8)();
        return (0, $92af15b8a2030588$export$cceeabf822b64fc0).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $92af15b8a2030588$export$31752c40a5fab62a)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $92af15b8a2030588$export$a57f5080a3bcc90a).sort(this);
        (0, $92af15b8a2030588$export$31752c40a5fab62a)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
};
// src/SpringPhase.ts
var $343926dea5af6acd$var$$P = Symbol.for("SpringPhase");
var $343926dea5af6acd$var$HAS_ANIMATED = 1;
var $343926dea5af6acd$var$IS_ANIMATING = 2;
var $343926dea5af6acd$var$IS_PAUSED = 4;
var $343926dea5af6acd$var$hasAnimated = (target)=>(target[$343926dea5af6acd$var$$P] & $343926dea5af6acd$var$HAS_ANIMATED) > 0;
var $343926dea5af6acd$var$isAnimating = (target)=>(target[$343926dea5af6acd$var$$P] & $343926dea5af6acd$var$IS_ANIMATING) > 0;
var $343926dea5af6acd$var$isPaused = (target)=>(target[$343926dea5af6acd$var$$P] & $343926dea5af6acd$var$IS_PAUSED) > 0;
var $343926dea5af6acd$var$setActiveBit = (target, active)=>active ? target[$343926dea5af6acd$var$$P] |= $343926dea5af6acd$var$IS_ANIMATING | $343926dea5af6acd$var$HAS_ANIMATED : target[$343926dea5af6acd$var$$P] &= ~$343926dea5af6acd$var$IS_ANIMATING;
var $343926dea5af6acd$var$setPausedBit = (target, paused)=>paused ? target[$343926dea5af6acd$var$$P] |= $343926dea5af6acd$var$IS_PAUSED : target[$343926dea5af6acd$var$$P] &= ~$343926dea5af6acd$var$IS_PAUSED;
// src/SpringValue.ts
var $343926dea5af6acd$export$5854d13427d5a954 = class extends $343926dea5af6acd$export$8229896f80e2495e {
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new $343926dea5af6acd$var$Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(arg1) || !(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(arg2)) {
            const props = (0, $92af15b8a2030588$export$226b3eccf92c9ed9).obj(arg1) ? {
                ...arg1
            } : {
                ...arg2,
                from: arg1
            };
            if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(props.default)) props.default = true;
            this.start(props);
        }
    }
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($343926dea5af6acd$var$isAnimating(this) || this._state.asyncTo) || $343926dea5af6acd$var$isPaused(this);
    }
    get goal() {
        return (0, $92af15b8a2030588$export$e37b7520edd66839)(this.animation.to);
    }
    get velocity() {
        const node = (0, $8e9f814fe52bc087$export$6b63995194a3a9e4)(this);
        return node instanceof (0, $8e9f814fe52bc087$export$cb1e8f3c05d37ad5) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return $343926dea5af6acd$var$hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return $343926dea5af6acd$var$isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return $343926dea5af6acd$var$isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues } = anim;
        const { config: config2 } = anim;
        const payload = (0, $8e9f814fe52bc087$export$ccab2b64c5d440)(anim.to);
        if (!payload && (0, $92af15b8a2030588$export$57ea7e3a7f6280c7)(anim.to)) toValues = (0, $92af15b8a2030588$export$45b10814cc054894)((0, $92af15b8a2030588$export$e37b7520edd66839)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, $8e9f814fe52bc087$export$f6c6c4cbd7fa5b93) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $92af15b8a2030588$export$226b3eccf92c9ed9).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, $8e9f814fe52bc087$export$6b63995194a3a9e4)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $92af15b8a2030588$export$e37b7520edd66839)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($343926dea5af6acd$var$isAnimating(this)) {
            const { to: to2, config: config2 } = this.animation;
            (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(to2)) queue = [
            (0, $92af15b8a2030588$export$226b3eccf92c9ed9).obj(to2) ? to2 : {
                ...arg2,
                to: to2
            }
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$343926dea5af6acd$var$getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2 } = this.animation;
        this._focus(this.get());
        $343926dea5af6acd$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2, from: from } = props;
        to2 = (0, $92af15b8a2030588$export$226b3eccf92c9ed9).obj(to2) ? to2[key] : to2;
        if (to2 == null || $343926dea5af6acd$var$isAsyncTo(to2)) to2 = void 0;
        from = (0, $92af15b8a2030588$export$226b3eccf92c9ed9).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from: from
        };
        if (!$343926dea5af6acd$var$hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, $92af15b8a2030588$export$e37b7520edd66839)(from);
            if (!(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(from)) this._set(from);
            else if (!(0, $8e9f814fe52bc087$export$6b63995194a3a9e4)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update({ ...props }, isLoop) {
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $343926dea5af6acd$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $343926dea5af6acd$var$resolveProp(value, key) : value));
        $343926dea5af6acd$var$mergeActiveFn(this, props, "onProps");
        $343926dea5af6acd$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $343926dea5af6acd$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$343926dea5af6acd$var$isPaused(this)) {
                        $343926dea5af6acd$var$setPausedBit(this, true);
                        (0, $92af15b8a2030588$export$7ba486852759e806)(state.pauseQueue);
                        $343926dea5af6acd$var$sendEvent(this, "onPause", $343926dea5af6acd$var$getFinishedResult(this, $343926dea5af6acd$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($343926dea5af6acd$var$isPaused(this)) {
                        $343926dea5af6acd$var$setPausedBit(this, false);
                        if ($343926dea5af6acd$var$isAnimating(this)) this._resume();
                        (0, $92af15b8a2030588$export$7ba486852759e806)(state.resumeQueue);
                        $343926dea5af6acd$var$sendEvent(this, "onResume", $343926dea5af6acd$var$getFinishedResult(this, $343926dea5af6acd$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $343926dea5af6acd$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($343926dea5af6acd$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(range.to);
        const hasFromProp = !(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($343926dea5af6acd$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to2 = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, $92af15b8a2030588$export$248d38f6296296c5)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $92af15b8a2030588$export$e37b7520edd66839)(from);
        const hasToChanged = !(0, $92af15b8a2030588$export$248d38f6296296c5)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = $343926dea5af6acd$var$isAsyncTo(props.to);
        const { config: config2 } = anim;
        const { decay: decay, velocity: velocity } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) $343926dea5af6acd$var$mergeConfig(config2, $343926dea5af6acd$var$callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? $343926dea5af6acd$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $8e9f814fe52bc087$export$6b63995194a3a9e4)(this);
        if (!node || (0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(to2)) return resolve($343926dea5af6acd$var$getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(props.reset) ? hasFromProp && !props.default : !(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(from) && $343926dea5af6acd$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $343926dea5af6acd$var$computeGoal(to2);
        const isAnimatable = (0, $92af15b8a2030588$export$226b3eccf92c9ed9).num(goal) || (0, $92af15b8a2030588$export$226b3eccf92c9ed9).arr(goal) || (0, $92af15b8a2030588$export$75bed621f62abfa9)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $343926dea5af6acd$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $8e9f814fe52bc087$export$e6b77ddbe47b132e)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $92af15b8a2030588$export$57ea7e3a7f6280c7)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$343926dea5af6acd$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $92af15b8a2030588$export$248d38f6296296c5)($343926dea5af6acd$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $92af15b8a2030588$export$248d38f6296296c5)(anim.immediate, immediate) && !immediate || !(0, $92af15b8a2030588$export$248d38f6296296c5)(config2.decay, decay) || !(0, $92af15b8a2030588$export$248d38f6296296c5)(config2.velocity, velocity)) started = true;
        }
        if (finished && $343926dea5af6acd$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $92af15b8a2030588$export$57ea7e3a7f6280c7)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $92af15b8a2030588$export$57ea7e3a7f6280c7)(to2) ? null : goalType == (0, $8e9f814fe52bc087$export$f6c6c4cbd7fa5b93) ? [
                    1
                ] : (0, $92af15b8a2030588$export$45b10814cc054894)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $92af15b8a2030588$export$79b2f7037acddd43)($343926dea5af6acd$var$ACTIVE_EVENTS, (type)=>$343926dea5af6acd$var$mergeActiveFn(this, props, type));
                const result = $343926dea5af6acd$var$getFinishedResult(this, $343926dea5af6acd$var$checkFinished(this, prevTo));
                (0, $92af15b8a2030588$export$7ba486852759e806)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest?.(result, this);
                    if (reset) $343926dea5af6acd$var$callProp(defaultProps.onRest, result);
                    else anim.onStart?.(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($343926dea5af6acd$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($343926dea5af6acd$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($343926dea5af6acd$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $92af15b8a2030588$export$133f54e9f7cf1796)(this)) this._detach();
            anim.to = value;
            if ((0, $92af15b8a2030588$export$133f54e9f7cf1796)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2 } = this.animation;
        if ((0, $92af15b8a2030588$export$57ea7e3a7f6280c7)(to2)) {
            (0, $92af15b8a2030588$export$72d604e3f8d000a5)(to2, this);
            if ($343926dea5af6acd$var$isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2 } = this.animation;
        if ((0, $92af15b8a2030588$export$57ea7e3a7f6280c7)(to2)) (0, $92af15b8a2030588$export$7a0eb830d336339b)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, $92af15b8a2030588$export$e37b7520edd66839)(arg);
        if (!(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(value)) {
            const oldNode = (0, $8e9f814fe52bc087$export$6b63995194a3a9e4)(this);
            if (!oldNode || !(0, $92af15b8a2030588$export$248d38f6296296c5)(value, oldNode.getValue())) {
                const nodeType = (0, $8e9f814fe52bc087$export$e6b77ddbe47b132e)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $8e9f814fe52bc087$export$b553cb5b22b81b04)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $8e9f814fe52bc087$export$6b63995194a3a9e4)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $343926dea5af6acd$var$sendEvent(this, "onStart", $343926dea5af6acd$var$getFinishedResult(this, $343926dea5af6acd$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $343926dea5af6acd$var$callProp(this.animation.onChange, value, this);
        }
        $343926dea5af6acd$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, $8e9f814fe52bc087$export$6b63995194a3a9e4)(this).reset((0, $92af15b8a2030588$export$e37b7520edd66839)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$343926dea5af6acd$var$isAnimating(this)) {
            $343926dea5af6acd$var$setActiveBit(this, true);
            if (!$343926dea5af6acd$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $92af15b8a2030588$export$cceeabf822b64fc0).skipAnimation) this.finish();
        else (0, $92af15b8a2030588$export$a57f5080a3bcc90a).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if ($343926dea5af6acd$var$isAnimating(this)) {
            $343926dea5af6acd$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $92af15b8a2030588$export$79b2f7037acddd43)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $92af15b8a2030588$export$31752c40a5fab62a)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $343926dea5af6acd$var$getCancelledResult(this.get()) : $343926dea5af6acd$var$getFinishedResult(this.get(), $343926dea5af6acd$var$checkFinished(this, goal ?? anim.to));
            (0, $92af15b8a2030588$export$7ba486852759e806)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $343926dea5af6acd$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
};
function $343926dea5af6acd$var$checkFinished(target, to2) {
    const goal = $343926dea5af6acd$var$computeGoal(to2);
    const value = $343926dea5af6acd$var$computeGoal(target.get());
    return (0, $92af15b8a2030588$export$248d38f6296296c5)(value, goal);
}
function $343926dea5af6acd$var$createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = $343926dea5af6acd$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $343926dea5af6acd$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $343926dea5af6acd$var$createUpdate({
            ...props,
            loop: loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || $343926dea5af6acd$var$isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset,
            // The "loop" prop can return a "useSpring" props object to
            // override any of the original props.
            ...overrides
        });
    }
}
function $343926dea5af6acd$var$createUpdate(props) {
    const { to: to2, from: from } = props = $343926dea5af6acd$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).obj(to2)) $343926dea5af6acd$var$findDefined(to2, keys);
    if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).obj(from)) $343926dea5af6acd$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $343926dea5af6acd$var$declareUpdate(props) {
    const update2 = $343926dea5af6acd$var$createUpdate(props);
    if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(update2.default)) update2.default = $343926dea5af6acd$var$getDefaultProps(update2);
    return update2;
}
function $343926dea5af6acd$var$findDefined(values, keys) {
    (0, $92af15b8a2030588$export$f4c6fe153f5a944e)(values, (value, key)=>value != null && keys.add(key));
}
var $343926dea5af6acd$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $343926dea5af6acd$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $343926dea5af6acd$var$getDefaultProp(props, type) ? $343926dea5af6acd$var$resolveProp(props[type], target.key) : void 0;
}
function $343926dea5af6acd$var$sendEvent(target, type, ...args) {
    target.animation[type]?.(...args);
    target.defaultProps[type]?.(...args);
}
var $343926dea5af6acd$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $343926dea5af6acd$var$nextId2 = 1;
var $343926dea5af6acd$export$bd0bf19f25da8474 = class {
    constructor(props, flush3){
        this.id = $343926dea5af6acd$var$nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start({
            default: true,
            ...props
        });
    }
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($343926dea5af6acd$var$createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $92af15b8a2030588$export$45b10814cc054894)(props).map($343926dea5af6acd$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $343926dea5af6acd$var$prepareKeys(this, queue);
        return $343926dea5af6acd$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $92af15b8a2030588$export$79b2f7037acddd43)((0, $92af15b8a2030588$export$45b10814cc054894)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $343926dea5af6acd$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $92af15b8a2030588$export$79b2f7037acddd43)((0, $92af15b8a2030588$export$45b10814cc054894)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $92af15b8a2030588$export$79b2f7037acddd43)((0, $92af15b8a2030588$export$45b10814cc054894)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $92af15b8a2030588$export$f4c6fe153f5a944e)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $92af15b8a2030588$export$4909b86c8034bf73)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $92af15b8a2030588$export$4909b86c8034bf73)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $92af15b8a2030588$export$4909b86c8034bf73)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).onFrame(this._onFrame);
    }
};
function $343926dea5af6acd$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$343926dea5af6acd$var$flushUpdate(ctrl, props))).then((results)=>$343926dea5af6acd$var$getCombinedResult(ctrl, results));
}
async function $343926dea5af6acd$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to2, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults2 = (0, $92af15b8a2030588$export$226b3eccf92c9ed9).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $92af15b8a2030588$export$226b3eccf92c9ed9).arr(to2) || (0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, $92af15b8a2030588$export$79b2f7037acddd43)($343926dea5af6acd$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $92af15b8a2030588$export$7ba486852759e806)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $343926dea5af6acd$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($343926dea5af6acd$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $92af15b8a2030588$export$8793edee2d425525),
            resume: (0, $92af15b8a2030588$export$8793edee2d425525),
            start (props2, resolve) {
                if (cancel) {
                    $343926dea5af6acd$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($343926dea5af6acd$var$getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve($343926dea5af6acd$var$runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $343926dea5af6acd$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $343926dea5af6acd$var$createLoopUpdate(props, loop, to2);
        if (nextProps) {
            $343926dea5af6acd$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $343926dea5af6acd$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $343926dea5af6acd$var$getSprings(ctrl, props) {
    const springs = {
        ...ctrl.springs
    };
    if (props) (0, $92af15b8a2030588$export$79b2f7037acddd43)((0, $92af15b8a2030588$export$45b10814cc054894)(props), (props2)=>{
        if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(props2.keys)) props2 = $343926dea5af6acd$var$createUpdate(props2);
        if (!(0, $92af15b8a2030588$export$226b3eccf92c9ed9).obj(props2.to)) props2 = {
            ...props2,
            to: void 0
        };
        $343926dea5af6acd$var$prepareSprings(springs, props2, (key)=>{
            return $343926dea5af6acd$var$createSpring(key);
        });
    });
    $343926dea5af6acd$var$setSprings(ctrl, springs);
    return springs;
}
function $343926dea5af6acd$var$setSprings(ctrl, springs) {
    (0, $92af15b8a2030588$export$f4c6fe153f5a944e)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $92af15b8a2030588$export$72d604e3f8d000a5)(spring, ctrl);
        }
    });
}
function $343926dea5af6acd$var$createSpring(key, observer) {
    const spring = new $343926dea5af6acd$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $92af15b8a2030588$export$72d604e3f8d000a5)(spring, observer);
    return spring;
}
function $343926dea5af6acd$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $92af15b8a2030588$export$79b2f7037acddd43)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $343926dea5af6acd$var$prepareKeys(ctrl, queue) {
    (0, $92af15b8a2030588$export$79b2f7037acddd43)(queue, (props)=>{
        $343926dea5af6acd$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $343926dea5af6acd$var$createSpring(key, ctrl);
        });
    });
}
var $343926dea5af6acd$export$f12a216ec50d2cf1 = $h5vr1.createContext({
    pause: false,
    immediate: false
});
var $343926dea5af6acd$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, $92af15b8a2030588$export$d99d974913ad3b12)();
        const results = [];
        (0, $92af15b8a2030588$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, $92af15b8a2030588$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, $92af15b8a2030588$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $92af15b8a2030588$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            const update2 = (0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, $92af15b8a2030588$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, $92af15b8a2030588$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, $92af15b8a2030588$export$79b2f7037acddd43)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function $343926dea5af6acd$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $h5vr1.useMemo)(()=>propsFn || arguments.length == 3 ? $343926dea5af6acd$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $h5vr1.useRef)(0);
    const forceUpdate = (0, $92af15b8a2030588$export$91db9bc4f8ac944a)();
    const state = (0, $h5vr1.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = $343926dea5af6acd$var$getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $343926dea5af6acd$var$flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    $343926dea5af6acd$var$setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve($343926dea5af6acd$var$flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $h5vr1.useRef)([
        ...state.ctrls
    ]);
    const updates = (0, $h5vr1.useRef)([]);
    const prevLength = (0, $92af15b8a2030588$export$ef7ad0c4e19d7fbf)(length) || 0;
    (0, $h5vr1.useMemo)(()=>{
        (0, $92af15b8a2030588$export$79b2f7037acddd43)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $343926dea5af6acd$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $h5vr1.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $343926dea5af6acd$export$bd0bf19f25da8474(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates.current[i] = $343926dea5af6acd$var$declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$343926dea5af6acd$var$getSprings(ctrl, updates.current[i]));
    const context = (0, $h5vr1.useContext)($343926dea5af6acd$export$f12a216ec50d2cf1);
    const prevContext = (0, $92af15b8a2030588$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $343926dea5af6acd$var$hasProps(context);
    (0, $92af15b8a2030588$export$700979bc83e7db82)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $92af15b8a2030588$export$79b2f7037acddd43)(queue, (cb)=>cb());
        }
        (0, $92af15b8a2030588$export$79b2f7037acddd43)(ctrls.current, (ctrl, i)=>{
            ref?.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates.current[i];
            if (update2) {
                $343926dea5af6acd$var$replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $92af15b8a2030588$export$392544347a18b6ea)(()=>()=>{
            (0, $92af15b8a2030588$export$79b2f7037acddd43)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>({
            ...x
        }));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function $343926dea5af6acd$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(props);
    const [[values], ref] = $343926dea5af6acd$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $343926dea5af6acd$var$initSpringRef = ()=>$343926dea5af6acd$export$2471ae76e2946684();
var $343926dea5af6acd$export$564bff9c23cad2ca = ()=>(0, $h5vr1.useState)($343926dea5af6acd$var$initSpringRef)[0];
var $343926dea5af6acd$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $92af15b8a2030588$export$fe4300aa8eebea86)(()=>new $343926dea5af6acd$export$5854d13427d5a954(initial, props));
    (0, $92af15b8a2030588$export$392544347a18b6ea)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $343926dea5af6acd$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = $343926dea5af6acd$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $92af15b8a2030588$export$700979bc83e7db82)(()=>{
        (0, $92af15b8a2030588$export$79b2f7037acddd43)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $343926dea5af6acd$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef ?? result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function $343926dea5af6acd$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $h5vr1.useMemo)(()=>propsFn || arguments.length == 3 ? $343926dea5af6acd$export$2471ae76e2946684() : void 0, []);
    const items = (0, $92af15b8a2030588$export$45b10814cc054894)(data);
    const transitions = [];
    const usedTransitions = (0, $h5vr1.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $92af15b8a2030588$export$700979bc83e7db82)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $92af15b8a2030588$export$392544347a18b6ea)(()=>{
        (0, $92af15b8a2030588$export$79b2f7037acddd43)(transitions, (t)=>{
            ref?.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $92af15b8a2030588$export$79b2f7037acddd43)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $343926dea5af6acd$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $343926dea5af6acd$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $92af15b8a2030588$export$700979bc83e7db82)(()=>(0, $92af15b8a2030588$export$79b2f7037acddd43)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $343926dea5af6acd$var$detachRefs(ctrl, ref);
            $343926dea5af6acd$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $92af15b8a2030588$export$79b2f7037acddd43)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $92af15b8a2030588$export$79b2f7037acddd43)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new $343926dea5af6acd$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $92af15b8a2030588$export$79b2f7037acddd43)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = {
                    ...t,
                    item: items[keyIndex]
                };
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $92af15b8a2030588$export$91db9bc4f8ac944a)();
    const defaultProps = $343926dea5af6acd$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $h5vr1.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $h5vr1.useRef)(false);
    (0, $92af15b8a2030588$export$79b2f7037acddd43)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = $343926dea5af6acd$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = $343926dea5af6acd$var$callProp(to2, t.item, i);
        to2 = (0, $92af15b8a2030588$export$226b3eccf92c9ed9).obj(to2) ? $343926dea5af6acd$export$b971039a739bf227(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = $343926dea5af6acd$var$callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = {
            ...defaultProps,
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false,
            // Merge any phase-specific props.
            ...to2
        };
        if (phase == "enter" /* ENTER */  && (0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = $343926dea5af6acd$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $343926dea5af6acd$var$callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = $343926dea5af6acd$var$callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $343926dea5af6acd$var$getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $h5vr1.useContext)($343926dea5af6acd$export$f12a216ec50d2cf1);
    const prevContext = (0, $92af15b8a2030588$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $343926dea5af6acd$var$hasProps(context);
    (0, $92af15b8a2030588$export$700979bc83e7db82)(()=>{
        if (hasContext) (0, $92af15b8a2030588$export$79b2f7037acddd43)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $92af15b8a2030588$export$79b2f7037acddd43)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $92af15b8a2030588$export$700979bc83e7db82)(()=>{
        (0, $92af15b8a2030588$export$79b2f7037acddd43)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref?.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                $343926dea5af6acd$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $h5vr1.createElement($h5vr1.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render({
                ...springs
            }, t.item, t, i);
            const key = (0, $92af15b8a2030588$export$226b3eccf92c9ed9).str(t.key) || (0, $92af15b8a2030588$export$226b3eccf92c9ed9).num(t.key) ? t.key : t.ctrl.id;
            const isLegacyReact = $h5vr1.version < "19.0.0";
            const props2 = elem?.props ?? {};
            const elemRef = isLegacyReact ? elem?.ref : props2?.ref;
            return elem && elem.type ? /* @__PURE__ */ $h5vr1.createElement(elem.type, {
                ...props2,
                key: key,
                ref: elemRef
            }) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $343926dea5af6acd$var$nextKey = 1;
function $343926dea5af6acd$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $343926dea5af6acd$var$nextKey++;
        });
    }
    return (0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(keys) ? items : (0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(keys) ? items.map(keys) : (0, $92af15b8a2030588$export$45b10814cc054894)(keys);
}
var $343926dea5af6acd$export$d928051c8cd740b = ({ container: container, ...springOptions } = {})=>{
    const [scrollValues, api] = $343926dea5af6acd$export$c4af9125706c4d30(()=>({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0,
            ...springOptions
        }), []);
    (0, $92af15b8a2030588$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $92af15b8a2030588$export$d4d89fd61e5416ee)(({ x: x, y: y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $92af15b8a2030588$export$79b2f7037acddd43)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $343926dea5af6acd$export$e8b771555dc4a003 = ({ container: container, ...springOptions })=>{
    const [sizeValues, api] = $343926dea5af6acd$export$c4af9125706c4d30(()=>({
            width: 0,
            height: 0,
            ...springOptions
        }), []);
    (0, $92af15b8a2030588$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $92af15b8a2030588$export$45b39e67d4ce4921)(({ width: width, height: height })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0 || springOptions.immediate === true
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $92af15b8a2030588$export$79b2f7037acddd43)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $343926dea5af6acd$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $343926dea5af6acd$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $h5vr1.useState)(false);
    const ref = (0, $h5vr1.useRef)(void 0);
    const propsFn = (0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {}, from: from = {}, ...restSpringProps } = springsProps;
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $343926dea5af6acd$export$c4af9125706c4d30(()=>({
            from: from,
            ...restSpringProps
        }), []);
    (0, $92af15b8a2030588$export$700979bc83e7db82)(()=>{
        const element = ref.current;
        const { root: root, once: once, amount: amount = "any", ...restArgs } = intersectionArguments ?? {};
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $343926dea5af6acd$var$defaultThresholdOptions[amount],
            ...restArgs
        });
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function $343926dea5af6acd$export$a500e5b516cedfc({ children: children, ...props }) {
    return children($343926dea5af6acd$export$c4af9125706c4d30(props));
}
function $343926dea5af6acd$export$3b8b9d47fbf8fd2b({ items: items, children: children, ...props }) {
    const trails = $343926dea5af6acd$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $92af15b8a2030588$export$226b3eccf92c9ed9).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function $343926dea5af6acd$export$be58926105124dd4({ items: items, children: children, ...props }) {
    return $343926dea5af6acd$export$7b286972b8d8ccbf(items, props)(children);
}
var $343926dea5af6acd$export$b0cc4f9860136880 = class extends $343926dea5af6acd$export$8229896f80e2495e {
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $92af15b8a2030588$export$b12af43b97697ef5)(...args);
        const value = this._get();
        const nodeType = (0, $8e9f814fe52bc087$export$e6b77ddbe47b132e)(value);
        (0, $8e9f814fe52bc087$export$b553cb5b22b81b04)(this, nodeType.create(value));
    }
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $92af15b8a2030588$export$248d38f6296296c5)(value, oldValue)) {
            (0, $8e9f814fe52bc087$export$6b63995194a3a9e4)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $343926dea5af6acd$var$checkIdle(this._active)) $343926dea5af6acd$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $92af15b8a2030588$export$226b3eccf92c9ed9).arr(this.source) ? this.source.map((0, $92af15b8a2030588$export$e37b7520edd66839)) : (0, $92af15b8a2030588$export$45b10814cc054894)((0, $92af15b8a2030588$export$e37b7520edd66839)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$343926dea5af6acd$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $92af15b8a2030588$export$79b2f7037acddd43)((0, $8e9f814fe52bc087$export$ccab2b64c5d440)(this), (node)=>{
                node.done = false;
            });
            if ((0, $92af15b8a2030588$export$cceeabf822b64fc0).skipAnimation) {
                (0, $7d76cf194f836d34$export$27f233d61a9e2fa4).batchedUpdates(()=>this.advance());
                $343926dea5af6acd$var$becomeIdle(this);
            } else (0, $92af15b8a2030588$export$a57f5080a3bcc90a).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, $92af15b8a2030588$export$79b2f7037acddd43)((0, $92af15b8a2030588$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $92af15b8a2030588$export$57ea7e3a7f6280c7)(source)) (0, $92af15b8a2030588$export$72d604e3f8d000a5)(source, this);
            if ($343926dea5af6acd$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, $92af15b8a2030588$export$79b2f7037acddd43)((0, $92af15b8a2030588$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $92af15b8a2030588$export$57ea7e3a7f6280c7)(source)) (0, $92af15b8a2030588$export$7a0eb830d336339b)(source, this);
        });
        this._active.clear();
        $343926dea5af6acd$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $92af15b8a2030588$export$45b10814cc054894)(this.source).reduce((highest, parent)=>Math.max(highest, ($343926dea5af6acd$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
};
function $343926dea5af6acd$var$isIdle(source) {
    return source.idle !== false;
}
function $343926dea5af6acd$var$checkIdle(active) {
    return !active.size || Array.from(active).every($343926dea5af6acd$var$isIdle);
}
function $343926dea5af6acd$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $92af15b8a2030588$export$79b2f7037acddd43)((0, $8e9f814fe52bc087$export$ccab2b64c5d440)(self), (node)=>{
            node.done = true;
        });
        (0, $92af15b8a2030588$export$31752c40a5fab62a)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var $343926dea5af6acd$export$2c618a4308a30424 = (source, ...args)=>new $343926dea5af6acd$export$b0cc4f9860136880(source, args);
var $343926dea5af6acd$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $92af15b8a2030588$export$2abfcde8ae218ba8)(), new $343926dea5af6acd$export$b0cc4f9860136880(source, args));
(0, $92af15b8a2030588$export$cceeabf822b64fc0).assign({
    createStringInterpolator: $92af15b8a2030588$export$4759a013d387347a,
    to: (source, args)=>new $343926dea5af6acd$export$b0cc4f9860136880(source, args)
});
var $343926dea5af6acd$export$722fbec263ad908a = (0, $92af15b8a2030588$export$a57f5080a3bcc90a).advance;



var $kxWH7 = parcelRequire("kxWH7");


// src/applyAnimatedValues.ts
var $24f1d4f2f9cc3a4a$var$isCustomPropRE = /^--/;
function $24f1d4f2f9cc3a4a$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$24f1d4f2f9cc3a4a$var$isCustomPropRE.test(name) && !($24f1d4f2f9cc3a4a$var$isUnitlessNumber.hasOwnProperty(name) && $24f1d4f2f9cc3a4a$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $24f1d4f2f9cc3a4a$var$attributeCache = {};
function $24f1d4f2f9cc3a4a$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { className: className, style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft, viewBox: viewBox, ...attributes } = props;
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $24f1d4f2f9cc3a4a$var$attributeCache[name] || ($24f1d4f2f9cc3a4a$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $24f1d4f2f9cc3a4a$var$dangerousStyleValue(name, style[name]);
        if ($24f1d4f2f9cc3a4a$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (className !== void 0) instance.className = className;
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $24f1d4f2f9cc3a4a$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $24f1d4f2f9cc3a4a$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var $24f1d4f2f9cc3a4a$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$24f1d4f2f9cc3a4a$var$isUnitlessNumber = Object.keys($24f1d4f2f9cc3a4a$var$isUnitlessNumber).reduce((acc, prop)=>{
    $24f1d4f2f9cc3a4a$var$prefixes.forEach((prefix)=>acc[$24f1d4f2f9cc3a4a$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $24f1d4f2f9cc3a4a$var$isUnitlessNumber);
var $24f1d4f2f9cc3a4a$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $24f1d4f2f9cc3a4a$var$pxTransforms = /^(translate)/;
var $24f1d4f2f9cc3a4a$var$degTransforms = /^(rotate|skew)/;
var $24f1d4f2f9cc3a4a$var$addUnit = (value, unit)=>(0, $92af15b8a2030588$export$226b3eccf92c9ed9).num(value) && value !== 0 ? value + unit : value;
var $24f1d4f2f9cc3a4a$var$isValueIdentity = (value, id)=>(0, $92af15b8a2030588$export$226b3eccf92c9ed9).arr(value) ? value.every((v)=>$24f1d4f2f9cc3a4a$var$isValueIdentity(v, id)) : (0, $92af15b8a2030588$export$226b3eccf92c9ed9).num(value) ? value === id : parseFloat(value) === id;
var $24f1d4f2f9cc3a4a$var$AnimatedStyle = class extends (0, $8e9f814fe52bc087$export$f1b0b9e366a6e2d4) {
    constructor({ x: x, y: y, z: z, ...style }){
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$24f1d4f2f9cc3a4a$var$addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    $24f1d4f2f9cc3a4a$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $92af15b8a2030588$export$f4c6fe153f5a944e)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($24f1d4f2f9cc3a4a$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $92af15b8a2030588$export$226b3eccf92c9ed9).und(value)) return;
                const unit = $24f1d4f2f9cc3a4a$var$pxTransforms.test(key) ? "px" : $24f1d4f2f9cc3a4a$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $92af15b8a2030588$export$45b10814cc054894)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${$24f1d4f2f9cc3a4a$var$addUnit(deg, unit)})`,
                        $24f1d4f2f9cc3a4a$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$24f1d4f2f9cc3a4a$var$addUnit(v, unit)).join(",")})`,
                        $24f1d4f2f9cc3a4a$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $24f1d4f2f9cc3a4a$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
var $24f1d4f2f9cc3a4a$var$FluidTransform = class extends (0, $92af15b8a2030588$export$aff8e1ac1a016a2) {
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $92af15b8a2030588$export$79b2f7037acddd43)(this.inputs, (input, i)=>{
            const arg1 = (0, $92af15b8a2030588$export$e37b7520edd66839)(input[0]);
            const [t, id] = this.transforms[i]((0, $92af15b8a2030588$export$226b3eccf92c9ed9).arr(arg1) ? arg1 : input.map((0, $92af15b8a2030588$export$e37b7520edd66839)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, $92af15b8a2030588$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $92af15b8a2030588$export$79b2f7037acddd43)(input, (value)=>(0, $92af15b8a2030588$export$57ea7e3a7f6280c7)(value) && (0, $92af15b8a2030588$export$72d604e3f8d000a5)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, $92af15b8a2030588$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $92af15b8a2030588$export$79b2f7037acddd43)(input, (value)=>(0, $92af15b8a2030588$export$57ea7e3a7f6280c7)(value) && (0, $92af15b8a2030588$export$7a0eb830d336339b)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $92af15b8a2030588$export$31752c40a5fab62a)(this, event);
    }
};
// src/primitives.ts
var $24f1d4f2f9cc3a4a$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $92af15b8a2030588$export$cceeabf822b64fc0).assign({
    batchedUpdates: (0, $kxWH7.unstable_batchedUpdates),
    createStringInterpolator: $92af15b8a2030588$export$4759a013d387347a,
    colors: $92af15b8a2030588$export$8f45430ccf837300
});
var $24f1d4f2f9cc3a4a$var$host = (0, $8e9f814fe52bc087$export$4ee5c78f6dcbcef)($24f1d4f2f9cc3a4a$var$primitives, {
    applyAnimatedValues: $24f1d4f2f9cc3a4a$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $24f1d4f2f9cc3a4a$var$AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: ({ scrollTop: scrollTop, scrollLeft: scrollLeft, ...props })=>props
});
var $24f1d4f2f9cc3a4a$export$407448d2b89b1813 = $24f1d4f2f9cc3a4a$var$host.animated;


const $70fc9a727fa662ae$export$fc10d2b1c75b2a29 = {
    dark: {
        circle: {
            r: 9
        },
        mask: {
            cx: '50%',
            cy: '23%'
        },
        svg: {
            transform: 'rotate(40deg)'
        },
        lines: {
            opacity: 0
        }
    },
    light: {
        circle: {
            r: 5
        },
        mask: {
            cx: '100%',
            cy: '0%'
        },
        svg: {
            transform: 'rotate(90deg)'
        },
        lines: {
            opacity: 1
        }
    },
    springConfig: {
        mass: 4,
        tension: 250,
        friction: 35
    }
};
let $70fc9a727fa662ae$var$REACT_TOGGLE_DARK_MODE_GLOBAL_ID = 0;
const $70fc9a727fa662ae$var$mergeThemeProperties = (theme, customTheme)=>({
        circle: {
            ...theme.circle,
            ...customTheme?.circle
        },
        mask: {
            ...theme.mask,
            ...customTheme?.mask
        },
        svg: {
            ...theme.svg,
            ...customTheme?.svg
        },
        lines: {
            ...theme.lines,
            ...customTheme?.lines
        }
    });
const $70fc9a727fa662ae$var$resolveAnimationProperties = (animationProperties)=>{
    if (!animationProperties || animationProperties === $70fc9a727fa662ae$export$fc10d2b1c75b2a29) return $70fc9a727fa662ae$export$fc10d2b1c75b2a29;
    return {
        dark: $70fc9a727fa662ae$var$mergeThemeProperties($70fc9a727fa662ae$export$fc10d2b1c75b2a29.dark, animationProperties.dark),
        light: $70fc9a727fa662ae$var$mergeThemeProperties($70fc9a727fa662ae$export$fc10d2b1c75b2a29.light, animationProperties.light),
        springConfig: {
            ...$70fc9a727fa662ae$export$fc10d2b1c75b2a29.springConfig,
            ...animationProperties.springConfig
        }
    };
};
const $70fc9a727fa662ae$export$c13c7e66b81b6f38 = ({ onChange: onChange, checked: checked = false, size: size = 24, animationProperties: animationProperties, moonColor: moonColor = 'white', sunColor: sunColor = 'black', style: style, onClick: onClickProp, role: role, tabIndex: tabIndex, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, ...rest })=>{
    const [id] = $h5vr1.useState(()=>{
        $70fc9a727fa662ae$var$REACT_TOGGLE_DARK_MODE_GLOBAL_ID += 1;
        return $70fc9a727fa662ae$var$REACT_TOGGLE_DARK_MODE_GLOBAL_ID;
    });
    const properties = $h5vr1.useMemo(()=>$70fc9a727fa662ae$var$resolveAnimationProperties(animationProperties), [
        animationProperties
    ]);
    const { circle: circle, svg: svg, lines: lines, mask: mask } = properties[checked ? 'dark' : 'light'];
    const { springConfig: springConfig } = properties;
    const svgContainerProps = (0, $343926dea5af6acd$export$c4af9125706c4d30)({
        ...svg,
        config: springConfig
    });
    const centerCircleProps = (0, $343926dea5af6acd$export$c4af9125706c4d30)({
        ...circle,
        config: springConfig
    });
    const maskedCircleProps = (0, $343926dea5af6acd$export$c4af9125706c4d30)({
        ...mask,
        config: springConfig
    });
    const linesProps = (0, $343926dea5af6acd$export$c4af9125706c4d30)({
        ...lines,
        config: springConfig
    });
    const toggle = $h5vr1.useCallback(()=>onChange(!checked), [
        checked,
        onChange
    ]);
    const onClick = $h5vr1.useCallback((event)=>{
        event.stopPropagation();
        onClickProp?.(event);
        if (!event.defaultPrevented) toggle();
    }, [
        onClickProp,
        toggle
    ]);
    const uniqueMaskId = `circle-mask-${id}`;
    return /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsx)("button", {
        type: "button",
        role: role ?? 'switch',
        "aria-checked": checked,
        "aria-label": ariaLabelledBy ? undefined : ariaLabel ?? 'Toggle dark mode',
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex ?? 0,
        onClick: onClick,
        style: {
            cursor: 'pointer',
            padding: 0,
            border: 0,
            background: 'transparent',
            lineHeight: 0,
            ...style
        },
        ...rest,
        children: /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsxs)((0, $24f1d4f2f9cc3a4a$export$407448d2b89b1813).svg, {
            xmlns: "http://www.w3.org/2000/svg",
            width: size,
            height: size,
            viewBox: "0 0 24 24",
            color: checked ? moonColor : sunColor,
            fill: "none",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            stroke: "currentColor",
            style: svgContainerProps,
            children: [
                /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsxs)("mask", {
                    id: uniqueMaskId,
                    children: [
                        /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsx)("rect", {
                            x: "0",
                            y: "0",
                            width: "100%",
                            height: "100%",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsx)((0, $24f1d4f2f9cc3a4a$export$407448d2b89b1813).circle, {
                            // @ts-ignore
                            style: maskedCircleProps,
                            r: "9",
                            fill: "black"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsx)((0, $24f1d4f2f9cc3a4a$export$407448d2b89b1813).circle, {
                    cx: "12",
                    cy: "12",
                    fill: checked ? moonColor : sunColor,
                    style: centerCircleProps,
                    mask: `url(#${uniqueMaskId})`
                }),
                /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsxs)((0, $24f1d4f2f9cc3a4a$export$407448d2b89b1813).g, {
                    stroke: "currentColor",
                    style: linesProps,
                    children: [
                        /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsx)("line", {
                            x1: "12",
                            y1: "1",
                            x2: "12",
                            y2: "3"
                        }),
                        /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsx)("line", {
                            x1: "12",
                            y1: "21",
                            x2: "12",
                            y2: "23"
                        }),
                        /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsx)("line", {
                            x1: "4.22",
                            y1: "4.22",
                            x2: "5.64",
                            y2: "5.64"
                        }),
                        /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsx)("line", {
                            x1: "18.36",
                            y1: "18.36",
                            x2: "19.78",
                            y2: "19.78"
                        }),
                        /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsx)("line", {
                            x1: "1",
                            y1: "12",
                            x2: "3",
                            y2: "12"
                        }),
                        /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsx)("line", {
                            x1: "21",
                            y1: "12",
                            x2: "23",
                            y2: "12"
                        }),
                        /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsx)("line", {
                            x1: "4.22",
                            y1: "19.78",
                            x2: "5.64",
                            y2: "18.36"
                        }),
                        /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsx)("line", {
                            x1: "18.36",
                            y1: "5.64",
                            x2: "19.78",
                            y2: "4.22"
                        })
                    ]
                })
            ]
        })
    });
};


function $e42795d87dfe6f60$var$arrayN(size) {
    return new Array(size).fill(undefined);
}
const $e42795d87dfe6f60$var$App = ()=>{
    const [isDarkMode, setDarkMode] = $h5vr1.useState(false);
    const [toggleAmount, setToggleAmount] = $h5vr1.useState(0);
    const toggleDarkMode = (checked)=>{
        setDarkMode(checked);
    };
    const addToggle = ()=>{
        setToggleAmount((prevValue)=>prevValue + 1);
    };
    return /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsxs)("div", {
        style: {
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            background: isDarkMode ? '#1b242c' : 'white',
            transition: '0.2s background'
        },
        children: [
            /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsx)((0, $70fc9a727fa662ae$export$c13c7e66b81b6f38), {
                style: {
                    marginBottom: '2rem'
                },
                checked: isDarkMode,
                onChange: toggleDarkMode,
                size: 120
            }),
            /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsx)((0, $70fc9a727fa662ae$export$c13c7e66b81b6f38), {
                style: {
                    marginBottom: '2rem'
                },
                checked: isDarkMode,
                onChange: toggleDarkMode,
                size: 80
            }),
            /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsx)((0, $70fc9a727fa662ae$export$c13c7e66b81b6f38), {
                style: {
                    marginBottom: '2rem'
                },
                checked: isDarkMode,
                onChange: toggleDarkMode,
                moonColor: "red",
                size: 30
            }),
            $e42795d87dfe6f60$var$arrayN(toggleAmount).map((_, index)=>/*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsx)((0, $70fc9a727fa662ae$export$c13c7e66b81b6f38), {
                    style: {
                        marginBottom: '2rem'
                    },
                    checked: isDarkMode,
                    onChange: toggleDarkMode,
                    size: Math.floor(Math.random() * 20) + 20
                }, index)),
            /*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsx)("button", {
                onClick: addToggle,
                children: "Add toggle"
            })
        ]
    });
};
const $e42795d87dfe6f60$var$rootElement = document.getElementById('root');
if (!$e42795d87dfe6f60$var$rootElement) throw new Error('Unable to find root element');
(0, $96cc4d1b2f01a6e0$exports.createRoot)($e42795d87dfe6f60$var$rootElement).render(/*#__PURE__*/ (0, $0ba4b23d4df9096e$exports.jsx)($e42795d87dfe6f60$var$App, {}));


//# sourceMappingURL=example.5d340494.js.map
